{
	"dialog.ok": "موافق",
	"dialog.cancel": "إلغاء",
	"dialog.confirm": "تأكيد",
	"dialog.close": "إغلاق",
	"dialog.import": "استيراد",
	"dialog.save": "حفظ",
	"dialog.discard": "تجاهل",
	"dialog.dontshowagain": "عدم العرض مرة أخرى",
	"data.cube": "مكعب",
	"data.group": "مجموعة",
	"data.texture": "خامة",
	"data.plugin": "إضافة",
	"data.preview": "معاينة",
	"data.toolbar": "شريط الأدوات",
	"data.image": "صورة",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "Left Click",
	"keys.middleclick": "Middle Click",
	"keys.rightclick": "Right Click",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Contextmenu",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Comma",
	"keys.point": "Point",
	"keys.minus": "Minus",
	"keys.cross": "Cross",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "قيود الدوران",
	"message.rotation_limit.message": "تحدد ماين كرافت الدوران بمحور واحد فقط. سيؤدي الدوران على محور مختلف إلى إلغاء جميع الدورانات على المحاور الأخرى. قم بتحويل النموذج إلى \"نموذج عام\" إذا كنت تقوم بالتصميم لأغراض أخرى وتحتاج إلى دوران حر.",
	"message.file_not_found.title": "الملف غير موجود",
	"message.file_not_found.message": "تعذر على Blockbench العثور على الملف المطلوب. تأكد من حفظه محلياً وليس على السحابة.",
	"message.screenshot.title": "لقطة شاشة",
	"message.screenshot.clipboard": "الحافظة",
	"message.screenshot.right_click": "انقر بزر الماوس الأيمن أو اضغط مطولاً على لقطة الشاشة للنسخ",
	"message.invalid_file.title": "ملف غير صالح",
	"message.invalid_file.message": "تعذر فتح ملف json: %0",
	"message.invalid_model.title": "ملف نموذج غير صالح",
	"message.invalid_model.message": "لا يحتوي هذا الملف على بيانات نموذج صالحة",
	"message.child_model_only.title": "نموذج فرعي فارغ",
	"message.child_model_only.message": "هذا الملف فرعي من %0 ولا يحتوي على نموذج",
	"message.unsaved_textures.title": "خامات غير محفوظة",
	"message.unsaved_textures.message": "يحتوي النموذج الخاص بك على خامات غير محفوظة. تأكد من حفظها ولصقها في حزمة الموارد داخل المجلد الصحيح.",
	"message.model_clipping.title": "نموذج كبير جداً",
	"message.model_clipping.message": "يحتوي النموذج الخاص بك على %0 مكعبات أكبر من حد المكعبات المسموح به في ماين كرافت. لن يعمل هذا النموذج في ماين كرافت.",
	"message.loose_texture.title": "استيراد الخامة",
	"message.loose_texture.message": "الخامة المستوردة غير موجودة داخل حزمة موارد. يمكن لماين كرافت تحميل الخامات الموجودة فقط داخل مجلد الخامات لحزمة موارد محملة.",
	"message.loose_texture.change": "تغيير المسار",
	"message.update_res.title": "دقة الخامة",
	"message.update_res.message": "هل ترغب في تحديث دقة المشروع لتطابق دقة هذه الخامة؟ انقر على \"إلغاء\" إذا كانت خامتك ذات دقة أعلى من المعتاد.",
	"message.update_res.update": "تحديث",
	"message.bedrock_overwrite_error.message": "لا يمكن لـ Blockbench دمج هذا النموذج مع الملف القديم",
	"message.bedrock_overwrite_error.backup_overwrite": "إنشاء نسخة احتياطية والاستبدال",
	"message.bedrock_overwrite_error.overwrite": "استبدال",
	"message.close_warning.message": "هل تريد حفظ نموذجك؟",
	"message.close_warning.web": "سيتم فقدان عملك الحالي. هل أنت تأكد من أنك تريد المغادرة؟",
	"message.default_textures.title": "الخامات الافتراضية",
	"message.default_textures.message": "حدد مجلد \"textures\" الخاص بحزمة الموارد الافتراضية",
	"message.default_textures.detail": "قم باستخراج حزمة الموارد الافتراضية من ملف jar الخاص بماين كرافت أو ابحث عنها في جوجل وتنزيلها. ثم حدد موقع مجلد \"textures\" وافتحه. سيتذكر Blockbench هذا الموقع ويحاول جلب الخامات منه إذا لم يجدها في حزمة الموارد الحالية.",
	"message.default_textures.select": "تحديد مجلد \"textures\" الافتراضي",
	"message.image_editor.title": "تحديد محررة الصور",
	"message.image_editor.file": "تحديد ملف...",
	"message.image_editor.exe": "تحديد الملف التنفيذي لمحرر الصور",
	"message.display_skin.title": "شكل شخصية ماين كرافت",
	"message.display_skin.message": "حدد ملف شكل شخصية من جهاز الكمبيوتر أو أدخل اسم لاعب",
	"message.display_skin.upload": "تحديد ملف",
	"message.display_skin.reset": "إعادة ضبط",
	"message.invalid_plugin": "ملف إضافة غير صالح، راجع وحدة التحكم",
	"message.load_plugin_app": "هل تريد السماح لهذه الإضافة بإجراء تغييرات على جهاز الكمبيوتر الخاص بك؟ قم بتحميل الإضافات من المؤلفين الموثوقين فقط.",
	"message.load_plugin_web": "هل تريد تحميل هذه الإضافة؟ قم بتحميل الإضافات من المطورين الموثوقين فقط.",
	"message.preset_no_info": "الإعداد المسبق لا يحتوي على معلومات لهذا المنفذ",
	"message.restart_to_update": "أعد تشغيل Blockbench لتطبيق التغييرات",
	"message.save_file": "تم الحفظ باسم %0",
	"dialog.project.title": "مشروع",
	"dialog.project.name": "اسم الملف",
	"dialog.project.parent": "النموذج الأب",
	"dialog.project.geoname": "معرف النموذج",
	"dialog.project.ao": "الإغلاق المحيطي",
	"dialog.texture.title": "خامة",
	"dialog.texture.variable": "متغير",
	"dialog.texture.namespace": "مساحة الاسم",
	"dialog.texture.folder": "مجلد",
	"dialog.extrude.title": "استخراج الصورة",
	"dialog.extrude.mode": "نمط المسح",
	"dialog.extrude.mode.areas": "مناطق",
	"dialog.extrude.mode.lines": "خطوط",
	"dialog.extrude.mode.columns": "أعمدة",
	"dialog.extrude.mode.pixels": "بكسل",
	"dialog.extrude.opacity": "الشفافية الدنيا",
	"dialog.extrude.scan": "مسح واستيراد",
	"dialog.display_preset.title": "إنشاء إعداد مسبق",
	"dialog.display_preset.message": "حدد الفتحات التي تريد حفظها",
	"dialog.display_preset.create": "إنشاء",
	"dialog.select.title": "تحديد",
	"dialog.select.group": "في المجموعة المحددة",
	"dialog.select.name": "الاسم يحتوي على",
	"dialog.select.random": "فرصة عشوائية (%)",
	"dialog.select.select": "تحديد",
	"dialog.scale.title": "قياس النموذج",
	"dialog.scale.axis": "المحور",
	"dialog.scale.clipping": "اقتطاع النموذج: نموذجك كبير جداً بالنسبة للوحة الرسم",
	"dialog.scale.confirm": "قياس",
	"dialog.plugins.title": "الإضافات",
	"dialog.plugins.installed": "المثبتة",
	"dialog.plugins.available": "المتاحة",
	"dialog.plugins.install": "تثبيت",
	"dialog.plugins.uninstall": "إلغاء التثبيت",
	"dialog.plugins.reload": "إعادة تحميل",
	"dialog.plugins.none_installed": "لا توجد إضافات مثبتة",
	"dialog.plugins.none_available": "لا توجد إضافات متاحة",
	"dialog.plugins.web_only": "للتطبيق الإلكتروني فقط",
	"dialog.plugins.app_only": "لتطبيق سطح المكتب فقط",
	"dialog.plugins.author": "بواسطة %0",
	"dialog.create_texture.folder": "مجلد",
	"dialog.create_texture.resolution": "الدقة",
	"dialog.input.title": "إدخال",
	"dialog.settings.settings": "الإعدادات",
	"dialog.settings.keybinds": "اختصارات لوحة المفاتيح",
	"dialog.settings.about": "حول",
	"layout.color.back": "الخلفية",
	"layout.color.back.desc": "خلفيات وحقول الإدخال",
	"layout.color.dark": "داكن",
	"layout.color.dark.desc": "خلفية اللوحة",
	"layout.color.ui": "الواجهة",
	"layout.color.ui.desc": "لون الواجهة الرئيسية",
	"layout.color.bright_ui": "واجهة مضيئة",
	"layout.color.bright_ui.desc": "قوائم السياق والتلميحات",
	"layout.color.button": "زر",
	"layout.color.button.desc": "أزرار ومفاتيح تبديل",
	"layout.color.selected": "محدد",
	"layout.color.selected.desc": "علامات التبويب والكائنات المحددة",
	"layout.color.border": "حدود",
	"layout.color.border.desc": "حدود الأزرار وحقول الإدخال",
	"layout.color.accent": "إبراز",
	"layout.color.accent.desc": "مقبض شريط التمرير وتفاصيل أخرى",
	"layout.color.grid": "شبكة",
	"layout.color.grid.desc": "شبكة المعاينة ثلاثية الأبعاد",
	"layout.color.text": "نص",
	"layout.color.text.desc": "النص العادي",
	"layout.color.light": "فاتح",
	"layout.color.light.desc": "النص المميز",
	"layout.color.accent_text": "نص مميز",
	"layout.color.accent_text.desc": "نص على خلفيات مميزة",
	"layout.font.main": "الخط الرئيسي",
	"layout.font.headline": "خط العناوين",
	"about.version": "الإصدار:",
	"settings.category.general": "عام",
	"settings.category.preview": "معاينة",
	"settings.category.grid": "شبكة",
	"settings.category.edit": "تحرير",
	"settings.category.snapping": "المحاذاة",
	"settings.category.defaults": "الافتراضيات",
	"settings.category.dialogs": "الحوارات",
	"settings.category.export": "تصدير",
	"settings.language": "اللغة",
	"settings.language.desc": "لغة الواجهة",
	"settings.backup_interval": "فترة النسخ الاحتياطي",
	"settings.backup_interval.desc": "فترة النسخ الاحتياطي التلقائي بالدقائق",
	"settings.origin_size": "علامة نقطة الارتكاز",
	"settings.origin_size.desc": "حجم علامة نقطة الارتكاز",
	"settings.control_size": "حجم أداة التحويل",
	"settings.control_size.desc": "حجم أداة التحويل",
	"settings.display_skin": "شخصية ماين كرافت",
	"settings.display_skin.desc": "الشخصية المستخدمة للنموذج المرجعي للاعب",
	"settings.shading": "التظليل",
	"settings.shading.desc": "تمكين التظليل في المعاينة",
	"settings.base_grid": "شبكة صغيرة",
	"settings.base_grid.desc": "إظهار الشبكة الصغيرة والمحاور",
	"settings.large_grid": "شبكة المكعبات",
	"settings.large_grid.desc": "إظهار شبكة بحجم 16x16 مكعب",
	"settings.full_grid": "شبكة المكعبات الدقيقة",
	"settings.full_grid.desc": "إظهار شبكة المكعبات بدقة البكسل",
	"settings.large_box": "مربع حد الحجم",
	"settings.large_box.desc": "إظهار حدود حد الحجم",
	"settings.display_grid": "شبكة نمط العرض",
	"settings.display_grid.desc": "إظهار الشبكة في نمط العرض",
	"settings.undo_limit": "حد التراجع",
	"settings.undo_limit.desc": "عدد الخطوات التي يمكنك التراجع عنها",
	"settings.local_move": "التحريك على محاور نسبية",
	"settings.local_move.desc": "تحريك العناصر المدورة على محاورها الخاصة إن أمكن",
	"settings.canvas_unselect": "إلغاء التحديد عند النقر على الخلفية",
	"settings.canvas_unselect.desc": "إلغاء تحديد جميع العناصر عند النقر على الخلفية خلف النموذج أو في الجدول الزمني",
	"settings.paint_side_restrict": "تقييد الفرشاة بالجانب",
	"settings.paint_side_restrict.desc": "تقييد الفرشاة بالرسم على الجانب الحالي فقط",
	"settings.autouv": "UV تلقائي",
	"settings.autouv.desc": "تمكين UV التلقائي بشكل افتراضي",
	"settings.create_rename": "إعادة تسمية العنصر الجديد",
	"settings.create_rename.desc": "التركيز على حقل الاسم عند إنشاء عنصر أو مجموعة جديدة",
	"settings.edit_size": "دقة الشبكة",
	"settings.edit_size.desc": "دقة الشبكة التي يتم محاذاة العناصر إليها",
	"settings.shift_size": "دقة التحول",
	"settings.shift_size.desc": "دقة الشبكة أثناء الضغط على Shift",
	"settings.ctrl_size": "دقة التحكم",
	"settings.ctrl_size.desc": "دقة الشبكة أثناء الضغط على Ctrl",
	"settings.negative_size": "حجم سالب",
	"settings.negative_size.desc": "السماح لأداة تغيير الحجم باستخدام أحجام سالبة",
	"settings.minifiedout": "تصدير مضغوط",
	"settings.minifiedout.desc": "كتابة ملفات JSON في سطر واحد",
	"settings.export_groups": "تصدير المجموعات في نماذج Java للكتل/العناصر",
	"settings.export_groups.desc": "حفظ المجموعات في ملفات JSON لنماذج Java للكتل أو العناصر",
	"settings.credit": "تعليق الإسناد",
	"settings.credit.desc": "إضافة تعليق إسناد إلى الملفات المصدرة",
	"settings.default_path": "المسار الافتراضي لخامات ماين كرافت",
	"settings.default_path.desc": "المجلد الذي يقوم Blockbench بتحميل الخامات الافتراضية منه",
	"settings.image_editor": "محرر الصور",
	"settings.image_editor.desc": "محرر الصور الافتراضي لتحرير الخامات",
	"category.navigate": "التنقل",
	"category.tools": "الأدوات",
	"category.file": "ملف",
	"category.blockbench": "Blockbench",
	"category.edit": "تحرير",
	"category.transform": "تحويل",
	"category.view": "عرض",
	"category.display": "إعدادات العرض",
	"category.textures": "خامات",
	"category.misc": "متنوع",
	"keybind.preview_select": "تحديد",
	"keybind.preview_rotate": "تدوير العرض",
	"keybind.preview_drag": "سحب العرض",
	"keybind.confirm": "تأكيد",
	"keybind.cancel": "إلغاء",
	"action.slider_inflate": "نفخ",
	"action.slider_inflate.desc": "نفخ المكعبات في جميع الاتجاهات دون تغيير UV",
	"action.slider_brush_size": "حجم الفرشاة",
	"action.slider_brush_size.desc": "نصف قطر الفرشاة بالبكسل",
	"action.slider_brush_opacity": "الشفافية",
	"action.slider_brush_opacity.desc": "شفافية الفرشاة من 0 إلى 255",
	"action.slider_brush_softness": "نعومة",
	"action.slider_brush_softness.desc": "نعومة الفرشاة بالنسبة المئوية",
	"action.uv_slider_pos_x": "تحريك أفقي",
	"action.uv_slider_pos_x.desc": "تحريك جميع أوجه UV المحددة أفقياً",
	"action.uv_slider_pos_y": "تحريك عمودي",
	"action.uv_slider_pos_y.desc": "تحريك جميع أوجه UV المحددة عمودياً",
	"action.uv_slider_size_x": "حجم أفقي",
	"action.uv_slider_size_x.desc": "تغيير حجم جميع أوجه UV المحددة أفقياً",
	"action.uv_slider_size_y": "حجم عمودي",
	"action.uv_slider_size_y.desc": "تغيير حجم جميع أوجه UV المحددة عمودياً",
	"action.vertex_snap_mode": "نمط المحاذاة",
	"action.vertex_snap_mode.desc": "تحديد ما إذا كانت محاذاة الرؤوس تنقل العناصر إلى الموضع المحدد أو تغير حجمها",
	"action.move_tool": "تحريك",
	"action.move_tool.desc": "أداة لتحديد العناصر وتحريكها",
	"action.resize_tool": "تغيير الحجم",
	"action.resize_tool.desc": "أداة لتحديد العناصر وتغيير حجمها",
	"action.brush_tool": "فرشاة الرسم",
	"action.brush_tool.desc": "فرشاة ملونة للرسم على الخامات",
	"action.vertex_snap_tool": "محاذاة الرؤوس",
	"action.vertex_snap_tool.desc": "نقل مكعب إلى مكعب آخر عن طريق ربط رأسين",
	"action.swap_tools": "تبديل الأدوات",
	"action.swap_tools.desc": "التبديل بين الأدوات البديلة، مثل التحريك وتغيير الحجم، أو الفرشاة وقطاف الألوان",
	"action.project_window": "مشروع...",
	"action.project_window.desc": "فتح نافذة المشروع، حيث يمكنك تحرير بيانات النموذج الوصفية",
	"action.open_model": "فتح نموذج",
	"action.open_model.desc": "فتح ملف نموذج من جهاز الكمبيوتر",
	"action.extrude_texture": "خامة مستخرجة",
	"action.extrude_texture.desc": "إنشاء نموذج عن طريق بسط خامة",
	"action.export_blockmodel": "تصدير نموذج كتلة/عنصر",
	"action.export_blockmodel.desc": "تصدير نموذج كتلة أو عنصر لـ Minecraft Java Edition",
	"action.export_optifine_part": "تصدير جزء OptiFine",
	"action.export_optifine_part.desc": "تصدير جزء واحد لنموذج كيان OptiFine",
	"action.export_optifine_full": "تصدير OptiFine JEM",
	"action.export_optifine_full.desc": "تصدير نموذج كيان OptiFine كامل",
	"action.export_obj": "تصدير نموذج OBJ",
	"action.export_obj.desc": "تصدير نموذج Wavefront OBJ للعرض",
	"action.settings_window": "الإعدادات...",
	"action.settings_window.desc": "فتح مربع حوار إعدادات Blockbench",
	"action.plugins_window": "الإضافات...",
	"action.plugins_window.desc": "فتح نافذة متجر الإضافات",
	"action.reset_layout": "إعادة ضبط التخطيط",
	"action.reset_layout.desc": "إعادة ضبط التخطيط إلى الوضع الافتراضي لـ Blockbench",
	"action.load_plugin": "تحميل إضافة من ملف",
	"action.load_plugin.desc": "تحميل إضافة عن طريق استيراد الملف المصدر",
	"action.reload_plugins": "إعادة تحميل الإضافات",
	"action.reload_plugins.desc": "إعادة تحميل جميع إضافات التطوير",
	"action.undo": "تراجع",
	"action.undo.desc": "التراجع عن آخر تغيير",
	"action.redo": "إعادة",
	"action.redo.desc": "التراجع عن آخر تراجع",
	"action.copy": "نسخ",
	"action.copy.desc": "نسخ التحديد أو الوجه أو إعدادات العرض المحددة",
	"action.paste": "لصق",
	"action.paste.desc": "لصق التحديد أو الوجه أو إعدادات العرض المحددة",
	"action.cut": "قص",
	"action.cut.desc": "قص التحديد أو الوجه أو إعدادات العرض المحددة",
	"action.add_cube": "إضافة مكعب",
	"action.add_cube.desc": "إضافة مكعب جديد",
	"action.add_group": "إضافة مجموعة",
	"action.add_group.desc": "إضافة مجموعة أو عظمة جديدة",
	"action.outliner_toggle": "تبديل المزيد من الخيارات",
	"action.outliner_toggle.desc": "تبديل مفاتيح الخيارات الإضافية في المخطط التفصيلي",
	"action.duplicate": "تكرار",
	"action.delete": "حذف",
	"action.sort_outliner": "ترتيب المخطط التفصيلي",
	"action.sort_outliner.desc": "ترتيب المخطط التفصيلي أبجدياً",
	"action.select_window": "تحديد...",
	"action.select_window.desc": "البحث عن العناصر وتحديدها بناءً على خصائصها",
	"action.invert_selection": "عكس التحديد",
	"action.invert_selection.desc": "عكس التحديد الحالي",
	"action.select_all": "تحديد الكل",
	"action.collapse_groups": "طي المجموعات",
	"action.collapse_groups.desc": "طي جميع المجموعات أو العناصر المتداخلة في المخطط التفصيلي",
	"action.scale": "قياس...",
	"action.scale.desc": "قياس العناصر المحددة",
	"action.toggle_visibility": "تبديل الرؤية",
	"action.toggle_visibility.desc": "تبديل رؤية العناصر المحددة",
	"action.toggle_export": "تبديل التصدير",
	"action.toggle_export.desc": "تبديل إعداد تصدير العناصر المحددة",
	"action.toggle_autouv": "تبديل UV التلقائي",
	"action.toggle_autouv.desc": "تبديل إعداد UV التلقائي للعناصر المحددة",
	"action.toggle_shade": "تبديل التظليل",
	"action.toggle_shade.desc": "تبديل تظليل المكعبات المحددة",
	"action.rename": "إعادة تسمية",
	"action.rename.desc": "تغيير اسم العناصر أو المجموعة المحددة",
	"action.add_display_preset": "إعداد مسبق جديد",
	"action.add_display_preset.desc": "إضافة إعداد مسبق جديد لإعدادات العرض",
	"action.fullscreen": "شاشة كاملة",
	"action.fullscreen.desc": "تبديل وضع ملء الشاشة",
	"action.zoom_in": "تكبير",
	"action.zoom_in.desc": "تكبير لزيادة حجم الواجهة",
	"action.zoom_out": "تصغير",
	"action.zoom_out.desc": "تصغير لتقليل حجم الواجهة",
	"action.zoom_reset": "إعادة ضبط التكبير",
	"action.zoom_reset.desc": "إعادة ضبط التكبير إلى 100% الافتراضية",
	"action.reset_interface": "إعادة ضبط الواجهة",
	"action.reset_interface.desc": "إعادة ضبط حجم ومواضع واجهة المستخدم",
	"action.screenshot_model": "لقطة شاشة للنموذج",
	"action.screenshot_model.desc": "التقاط لقطة شاشة مقصوصة للنموذج من الزاوية الحالية",
	"action.screenshot_app": "لقطة شاشة للتطبيق",
	"action.screenshot_app.desc": "التقاط لقطة شاشة للتطبيق بأكمله",
	"action.import_texture": "استيراد خامة",
	"action.import_texture.desc": "استيراد خامة أو أكثر من نظام الملفات",
	"action.create_texture": "إنشاء خامة",
	"action.create_texture.desc": "إنشاء خامة فارغة أو خامة قالب",
	"action.save_textures": "حفظ الخامات",
	"action.save_textures.desc": "حفظ جميع الخامات غير المحفوظة",
	"action.animated_textures": "تشغيل الخامات المتحركة",
	"action.animated_textures.desc": "تشغيل وإيقاف معاينة الخامات المتحركة",
	"action.origin_to_geometry": "توسيط نقطة الارتكاز",
	"action.origin_to_geometry.desc": "تعيين نقطة الارتكاز إلى مركز التحديد",
	"action.bone_reset_toggle": "إعادة ضبط العظمة",
	"action.bone_reset_toggle.desc": "منع العظمة من عرض مكعبات من النموذج الأب",
	"action.reload": "إعادة تحميل Blockbench",
	"action.reload.desc": "إعادة تحميل Blockbench. سيؤدي ذلك إلى إلغاء جميع التغييرات غير المحفوظة",
	"menu.file": "ملف",
	"menu.edit": "تحرير",
	"menu.transform": "تحويل",
	"menu.display": "عرض",
	"menu.view": "عرض",
	"menu.file.new": "جديد",
	"menu.file.recent": "مؤخراً",
	"menu.file.import": "استيراد",
	"menu.file.export": "تصدير",
	"menu.transform.rotate": "تدوير",
	"menu.transform.flip": "قلب",
	"menu.transform.center": "توسيط",
	"menu.transform.properties": "خصائص",
	"menu.display.preset": "تطبيق الإعداد المسبق",
	"menu.display.preset_all": "تطبيق الإعداد المسبق في كل مكان",
	"menu.display.remove_preset": "إزالة الإعداد المسبق",
	"menu.view.zoom": "تكبير",
	"menu.view.background": "خلفية",
	"menu.view.screenshot": "لقطة شاشة",
	"menu.cube.color": "لون العلامة",
	"menu.cube.texture": "خامة",
	"menu.cube.texture.transparent": "شفاف",
	"menu.cube.texture.blank": "فارغ",
	"menu.group.sort": "ترتيب",
	"menu.texture.face": "تطبيق على الوجه",
	"menu.texture.file": "ملف",
	"menu.texture.refresh": "تحديث",
	"menu.texture.change": "تغيير الملف",
	"menu.texture.folder": "إظهار في مستكشف الملفات",
	"menu.texture.edit": "تحرير",
	"menu.texture.export": "حفظ باسم",
	"menu.texture.save": "حفظ",
	"menu.texture.properties": "خصائص...",
	"menu.preview.background": "خلفية",
	"menu.preview.background.load": "تحميل",
	"menu.preview.background.position": "موضع",
	"menu.preview.background.lock": "تثبيت على الكاميرا",
	"menu.preview.screenshot": "لقطة شاشة",
	"menu.preview.perspective": "منظور",
	"menu.preview.perspective.normal": "عادي",
	"menu.preview.quadview": "عرض رباعي",
	"menu.preview.stop_drag": "إيقاف تحديد موضع الخلفية",
	"menu.uv.mapping.rotation": "تدوير",
	"menu.uv.texture": "خامة",
	"cube.color.light_blue": "أزرق فاتح",
	"cube.color.yellow": "أصفر",
	"cube.color.orange": "برتقالي",
	"cube.color.red": "أحمر",
	"cube.color.purple": "أرجواني",
	"cube.color.blue": "أزرق",
	"cube.color.green": "أخضر",
	"cube.color.lime": "ليموني",
	"switches.visibility": "الرؤية",
	"switches.export": "تصدير",
	"switches.autouv": "UV تلقائي",
	"panel.uv": "UV",
	"panel.display": "عرض",
	"panel.textures": "خامات",
	"panel.outliner": "المخطط التفصيلي",
	"uv_editor.title": "محرر UV",
	"uv_editor.all_faces": "الكل",
	"uv_editor.no_faces": "لا شيء",
	"face.north": "شمال",
	"face.south": "جنوب",
	"face.west": "غرب",
	"face.east": "شرق",
	"face.up": "أعلى",
	"face.down": "أسفل",
	"direction.north": "شمال",
	"direction.south": "جنوب",
	"direction.west": "غرب",
	"direction.east": "شرق",
	"direction.top": "أعلى",
	"direction.bottom": "أسفل",
	"display.slot.third_right": "شخص ثالث يمين",
	"display.slot.third_left": "شخص ثالث يسار",
	"display.slot.first_right": "شخص أول يمين",
	"display.slot.first_left": "شخص أول يسار",
	"display.slot.head": "رأس",
	"display.slot.ground": "أرض",
	"display.slot.frame": "إطار",
	"display.slot.gui": "واجهة المستخدم",
	"display.rotation": "تدوير",
	"display.translation": "ترجمة",
	"display.scale": "قياس",
	"display.slot": "فتحة",
	"display.reference": "نموذج مرجعي",
	"display.reference.player": "لاعب",
	"display.reference.zombie": "زومبي",
	"display.reference.armor_stand": "حامل الدروع",
	"display.reference.baby_zombie": "زومبي صغير",
	"display.reference.armor_stand_small": "حامل دروع صغير",
	"display.reference.monitor": "عادي",
	"display.reference.bow": "قوس مشحون",
	"display.reference.block": "كتلة",
	"display.reference.frame": "إطار العنصر",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "المخزون",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "الرجاء إدخال اسم",
	"display.preset.item": "عنصر افتراضي",
	"display.preset.block": "كتلة افتراضية",
	"display.preset.handheld": "سلاح افتراضي",
	"display.preset.rod": "قضيب افتراضي",
	"dialog.continue": "متابعة",
	"message.square_textures": "يجب أن تكون الخامات مربعة",
	"message.unsaved_texture.title": "خامة غير محفوظة",
	"message.unsaved_texture.message": "سيتم فقدان جميع التغييرات غير المحفوظة لهذه الخامة. هل تريد المتابعة؟",
	"action.vertex_snap_mode.move": "تحريك",
	"action.vertex_snap_mode.scale": "قياس",
	"action.open_model_folder": "فتح مجلد النموذج",
	"action.open_model_folder.desc": "فتح المجلد الذي يحتوي على النموذج",
	"action.change_textures_folder": "تغيير موقع الخامات",
	"action.change_textures_folder.desc": "تغيير المجلد الذي يتم حفظ جميع الخامات فيه",
	"menu.texture.particle": "استخدام للجسيمات",
	"message.update_notification.title": "تعذر تثبيت التحديث",
	"message.update_notification.message": "يتوفر إصدار جديد من Blockbench. يرجى تمكين التحديثات التلقائية في الإعدادات لتحديث البرنامج!",
	"message.untextured": "هذا السطح لا يحتوي على خامة",
	"dialog.toolbar_edit.title": "تخصيص شريط الأدوات",
	"keybindings.reset": "إعادة ضبط",
	"keybindings.clear": "إلغاء التعيين",
	"action.cube_counter": "إحصائيات النموذج",
	"action.uv_rotation": "تدوير UV",
	"action.uv_rotation.desc": "تدوير وجه UV",
	"action.uv_grid": "شبكة UV",
	"action.uv_grid.desc": "دقة الشبكة التي يتم محاذاة محدد UV إليها",
	"action.uv_grid.auto": "تلقائي",
	"action.uv_maximize": "تكبير UV",
	"action.uv_maximize.desc": "تعيين UV لهذا الوجه إلى كامل الخامة",
	"action.uv_auto": "UV تلقائي",
	"action.uv_auto.desc": "تعيين حجم UV لهذا الوجه إلى الحجم الفعلي للوجه",
	"action.uv_rel_auto": "UV تلقائي نسبي",
	"action.uv_rel_auto.desc": "تعيين UV لهذا الوجه إلى موضع وحجم الوجه الفعلي",
	"action.uv_mirror_x": "مرآة UV X",
	"action.uv_mirror_x.desc": "عكس UV لهذا الوجه على المحور X",
	"action.uv_mirror_y": "مرآة UV Y",
	"action.uv_mirror_y.desc": "عكس UV لهذا الوجه على المحور Y",
	"action.uv_transparent": "إزالة الوجه",
	"action.uv_transparent.desc": "إزالة الوجه الحالي",
	"action.uv_reset": "إعادة ضبط الوجه",
	"action.uv_reset.desc": "إعادة ضبط الوجه الحالي",
	"action.cullface": "إخفاء الوجه",
	"action.cullface.desc": "تعطيل عرض هذا الوجه إذا كان الجانب المحدد من النموذج مغطى",
	"action.auto_cullface": "تمكين إخفاء الوجه",
	"action.auto_cullface.desc": "تعيين إخفاء الوجه لهذا الوجه إلى نفسه",
	"action.face_tint": "تلوين",
	"action.face_tint.desc": "تمكين خيار التلوين للوجه الحالي",
	"menu.toolbar.edit": "تخصيص شريط الأدوات",
	"menu.toolbar.reset": "إعادة ضبط شريط الأدوات",
	"uv_editor.rotated": "مدور",
	"uv_editor.auto_cull": "إخفاء الوجه إلى النفس",
	"uv_editor.copied": "تم نسخ الوجه",
	"uv_editor.pasted": "تم لصق الوجه",
	"uv_editor.copied_x": "تم نسخ %0 وجه",
	"uv_editor.reset": "إعادة ضبط الوجه",
	"uv_editor.maximized": "مكبر",
	"uv_editor.autouv": "حجم تلقائي",
	"uv_editor.mirrored": "معكوس",
	"uv_editor.to_all": "تم التطبيق على جميع الوجوه",
	"uv_editor.transparent": "جعله شفافاً",
	"uv_editor.cullface_on": "إخفاء الوجه مفعل",
	"uv_editor.cullface_off": "إخفاء الوجه معطل",
	"uv_editor.tint_on": "تلوين مفعل",
	"uv_editor.tint_off": "تلوين معطل",
	"action.uv_apply_all": "تطبيق على جميع الوجوه",
	"action.uv_apply_all.desc": "تطبيق إعدادات الوجه الحالي على جميع الوجوه",
	"message.image_editor_missing.title": "محرر الصور الافتراضي",
	"message.image_editor_missing.message": "حدد الملف التنفيذي لمحرر الصور الخاص بك.",
	"message.image_editor_missing.detail": "لم يتمكن Blockbench من العثور على محرر صور على جهاز الكمبيوتر الخاص بك. حدد الملف التنفيذي لمحرر الصور المفضل لديك.",
	"action.update_autouv": "تحديث UV التلقائي",
	"action.update_autouv.desc": "تحديث تخطيط UV التلقائي للمكعبات المحددة",
	"category.uv": "UV",
	"status_bar.saved": "تم حفظ النموذج",
	"status_bar.unsaved": "توجد تغييرات غير محفوظة",
	"action.move_up": "تحريك لأعلى",
	"action.move_up.desc": "تحريك العناصر المحددة لأعلى بالنسبة لزاوية الكاميرا الحالية",
	"action.move_down": "تحريك لأسفل",
	"action.move_down.desc": "تحريك العناصر المحددة لأسفل بالنسبة لزاوية الكاميرا الحالية",
	"action.move_left": "تحريك لليسار",
	"action.move_left.desc": "تحريك العناصر المحددة لليسار بالنسبة لزاوية الكاميرا الحالية",
	"action.move_right": "تحريك لليمين",
	"action.move_right.desc": "تحريك العناصر المحددة لليمين بالنسبة لزاوية الكاميرا الحالية",
	"action.move_forth": "تحريك للأمام",
	"action.move_forth.desc": "تحريك العناصر المحددة للأمام بالنسبة لزاوية الكاميرا الحالية",
	"action.move_back": "تحريك للخلف",
	"action.move_back.desc": "تحريك العناصر المحددة للخلف بالنسبة لزاوية الكاميرا الحالية",
	"layout.color.wireframe": "الهيكل السلكي",
	"layout.color.wireframe.desc": "خطوط عرض الهيكل السلكي",
	"action.add_animation": "إضافة حركة",
	"action.add_animation.desc": "إنشاء حركة فارغة",
	"action.load_animation_file": "استيراد حركات",
	"action.load_animation_file.desc": "استيراد ملف حركات",
	"action.play_animation": "تشغيل الحركة",
	"action.play_animation.desc": "معاينة الحركة المحددة",
	"action.slider_keyframe_time": "الكود الزمني",
	"action.slider_keyframe_time.desc": "تغيير الكود الزمني للإطارات المفتاحية المحددة",
	"timeline.rotation": "تدوير",
	"timeline.position": "موضع",
	"timeline.scale": "قياس",
	"menu.keyframe.quaternion": "رباعي الأبعاد",
	"panel.animations": "حركات",
	"panel.keyframe": "إطار مفتاحي",
	"panel.keyframe.type": "إطار مفتاحي (%0)",
	"generic.delete": "حذف",
	"generic.rename": "إعادة تسمية",
	"message.no_animation_selected": "يجب تحديد حركة للقيام بهذا",
	"message.no_bone_selected": "يجب تحديد عظمة للقيام بهذا",
	"message.duplicate_groups.title": "تكرار اسم العظمة",
	"message.duplicate_groups.message": "اسم هذه العظمة موجود على عدة عظام. قد يتسبب ذلك في حدوث مشكلات.",
	"action.delete_keyframes": "حذف الإطارات المفتاحية",
	"action.delete_keyframes.desc": "حذف جميع الإطارات المفتاحية المحددة",
	"menu.animation": "حركة",
	"menu.animation.loop": "نمط التكرار",
	"menu.animation.override": "تجاوز",
	"menu.animation.anim_time_update": "تحديث وقت الحركة",
	"message.display_skin_model.title": "نموذج الشخصية",
	"message.display_skin_model.message": "اختر نوع نموذج شخصيتك",
	"message.display_skin_model.classic": "كلاسيكي",
	"message.display_skin_model.slim": "نحيف",
	"message.bone_material": "تغيير مادة العظمة",
	"action.slider_animation_length": "طول الحركة",
	"action.slider_animation_length.desc": "تغيير طول الحركة المحددة",
	"panel.variable_placeholders": "متغيرات مؤقتة",
	"status_bar.vertex_distance": "المسافة: %0",
	"dialog.create_gif.title": "تسجيل GIF",
	"dialog.create_gif.length": "الطول",
	"dialog.create_gif.fps": "إطار في الثانية",
	"dialog.create_gif.play": "تشغيل الحركة",
	"category.animation": "حركة",
	"action.record_model_gif": "تسجيل GIF...",
	"action.record_model_gif.desc": "تسجيل GIF متحرك للنموذج من الزاوية الحالية",
	"display.mirror": "مرآة",
	"data.separator": "فاصل",
	"menu.preview.background.set_position": "تعيين الموضع",
	"dialog.toolbar_edit.hidden": "مخفي",
	"action.export_class_entity": "تصدير كيان Java",
	"action.export_class_entity.desc": "تصدير نموذج الكيان كفئة Java",
	"settings.seethrough_outline": "حدود الأشعة السينية",
	"settings.seethrough_outline.desc": "إظهار الحدود من خلال الكائنات",
	"mode.edit": "تحرير",
	"mode.paint": "رسم",
	"mode.display": "عرض",
	"mode.animate": "تحريك",
	"status_bar.recording_gif": "تسجيل",
	"status_bar.processing_gif": "معالجة",
	"settings.backup_retain": "مدة الاحتفاظ بالنسخ الاحتياطي",
	"settings.backup_retain.desc": "تعيين مدة احتفاظ Blockbench بالنسخ الاحتياطية القديمة بالأيام",
	"action.rotate_tool": "تدوير",
	"action.rotate_tool.desc": "أداة لتحديد العناصر وتدويرها",
	"action.fill_tool": "دلو الطلاء",
	"action.fill_tool.desc": "دلو الطلاء لملء وجوه كاملة بلون واحد",
	"action.eraser": "ممحاة",
	"action.eraser.desc": "أداة الممحاة لاستبدال الألوان على الخامة بالشفافية",
	"action.color_picker": "قطاف الألوان",
	"action.color_picker.desc": "أداة لاختيار لون البكسل على الخامة",
	"switches.mirror": "مرآة UV",
	"language_name": "العربية",
	"message.plugin_reload": "تم إعادة تحميل %0 إضافة محلية",
	"settings.brightness": "السطوع",
	"settings.brightness.desc": "سطوع المعاينة. القيمة الافتراضية هي 50",
	"menu.preview.perspective.reset": "إعادة ضبط الكاميرا",
	"action.fill_mode": "نمط التعبئة",
	"action.fill_mode.face": "وجه",
	"action.fill_mode.color": "ألوان",
	"action.toggle_mirror_uv": "مرآة UV",
	"action.toggle_mirror_uv.desc": "تبديل عكس UV على المحور X للمكعبات المحددة",
	"menu.texture.blank": "تطبيق على الوجوه غير المزودة بخامة",
	"dialog.scale.select_overflow": "تحديد الفائض",
	"action.action_control": "التحكم في الإجراءات",
	"action.action_control.desc": "البحث عن أي إجراء متاح وتنفيذه",
	"keybindings.recording": "تسجيل اختصار لوحة المفاتيح",
	"keybindings.press": "اضغط على مفتاح أو مجموعة مفاتيح أو انقر في أي مكان على الشاشة لتسجيل اختصار لوحة المفاتيح الخاص بك.",
	"action.pivot_tool": "أداة نقطة الارتكاز",
	"action.pivot_tool.desc": "أداة لتغيير نقطة الارتكاز للعناصر والعظام",
	"action.slider_animation_speed": "سرعة التشغيل",
	"action.slider_animation_speed.desc": "سرعة تشغيل الجدول الزمني بالنسبة المئوية",
	"action.previous_keyframe": "الإطار المفتاحي السابق",
	"action.previous_keyframe.desc": "الانتقال إلى الإطار المفتاحي السابق",
	"action.next_keyframe": "الإطار المفتاحي التالي",
	"action.next_keyframe.desc": "الانتقال إلى الإطار المفتاحي التالي",
	"message.outdated_client.title": "العميل قديم",
	"message.outdated_client.message": "يرجى التحديث إلى أحدث إصدار من Blockbench للقيام بذلك.",
	"action.export_asset_archive": "تنزيل أرشيف",
	"action.export_asset_archive.desc": "تنزيل أرشيف يحتوي على النموذج وجميع الخامات فيه",
	"action.upload_sketchfab": "رفع إلى Sketchfab...",
	"message.sketchfab.name_or_token": "الرجاء إدخال رمز Sketchfab الخاص بك واسم",
	"dialog.sketchfab_uploader.title": "رفع نموذج إلى Sketchfab",
	"dialog.sketchfab_uploader.token": "رمز API",
	"dialog.sketchfab_uploader.about_token": "يُستخدم الرمز لتوصيل Blockbench بحسابك على Sketchfab. يمكنك العثور عليه على %0",
	"dialog.sketchfab_uploader.name": "اسم النموذج",
	"dialog.sketchfab_uploader.description": "الوصف",
	"dialog.sketchfab_uploader.tags": "الوسوم",
	"settings.sketchfab_token": "رمز Sketchfab",
	"settings.sketchfab_token.desc": "رمز للسماح لـ Blockbench بالرفع إلى حسابك على Sketchfab",
	"panel.color": "لون",
	"data.origin": "نقطة الارتكاز",
	"message.sketchfab.success": "تم رفع النموذج بنجاح",
	"message.sketchfab.error": "فشل رفع النموذج إلى Sketchfab",
	"settings.outliner_colors": "ألوان المخطط التفصيلي",
	"settings.outliner_colors.desc": "عرض ألوان العناصر والمجموعات في المخطط التفصيلي",
	"action.upload_sketchfab.desc": "رفع النموذج إلى Sketchfab",
	"action.element_colors": "ألوان المكعبات",
	"action.element_colors.desc": "إظهار ألوان المكعبات في المخطط التفصيلي",
	"texture.error.file": "الملف غير موجود",
	"texture.error.parent": "ملف الخامة مقدم من النموذج الأب",
	"message.recover_backup.title": "استعادة النماذج",
	"message.recover_backup.message": "تم إغلاق Blockbench دون حفظ. هل تريد استعادة النماذج؟",
	"message.invalid_session.title": "رمز جلسة غير صالح",
	"message.invalid_session.message": "انتهت صلاحية الجلسة التي تحاول الانضمام إليها أو أن الرمز المقدم غير صالح.",
	"dialog.create_texture.power": "حجم قوة 2",
	"dialog.create_gif.turn": "سرعة الدوران",
	"action.edit_session": "جلسة التحرير...",
	"action.edit_session.desc": "الاتصال بجلسة تحرير للتعاون مع مستخدمين آخرين",
	"action.reset_keyframe": "إعادة ضبط الإطار المفتاحي",
	"action.reset_keyframe.desc": "إعادة ضبط جميع قيم الإطارات المفتاحية المحددة",
	"dialog.edit_session.title": "جلسة التحرير",
	"edit_session.username": "اسم المستخدم",
	"edit_session.token": "الرمز",
	"edit_session.about": "يمكن استخدام جلسات التحرير للتعاون على النماذج عبر الإنترنت. أنشئ جلسة، وانسخ الرمز، وأرسله إلى الأصدقاء، الذين يمكنهم بعد ذلك استخدامه للانضمام.",
	"edit_session.join": "انضمام إلى الجلسة",
	"edit_session.create": "إنشاء جلسة",
	"edit_session.quit": "إنهاء الجلسة",
	"edit_session.joined": "انضم %0 إلى الجلسة",
	"edit_session.left": "غادر %0 الجلسة",
	"edit_session.quit_session": "غادر الجلسة الحالية",
	"edit_session.status": "الحالة",
	"edit_session.hosting": "استضافة",
	"edit_session.connected": "متصل بجلسة",
	"dialog.sketchfab_uploader.private": "خاص (Pro)",
	"dialog.sketchfab_uploader.password": "كلمة المرور (Pro)",
	"action.uv_select_all": "تحديد الكل",
	"action.uv_select_all.desc": "تحديد جميع الوجوه في محرر UV",
	"panel.chat": "محادثة",
	"edit_session.welcome": "مرحباً بك في هذه الجلسة بواسطة %0",
	"dialog.yes": "نعم",
	"dialog.no": "لا",
	"generic.remove": "إزالة",
	"generic.download": "تنزيل",
	"generic.search": "بحث",
	"dates.today": "اليوم",
	"dates.yesterday": "أمس",
	"dates.this_week": "هذا الأسبوع",
	"dates.weeks_ago": "قبل %0 أسبوع",
	"mode.start.new": "جديد",
	"mode.start.recent": "مؤخراً",
	"format.free": "نموذج عام",
	"format.free.desc": "نموذج بدون قيود. لمحركات الألعاب، العرض، إلخ.",
	"format.java_block": "كتلة/عنصر Java",
	"format.java_block.desc": "نموذج كتلة أو عنصر لـ Minecraft Java Edition.",
	"format.bedrock": "كيان Bedrock",
	"format.bedrock.desc": "نموذج Minecraft Bedrock Edition للكائنات والعناصر القابلة للارتباط",
	"format.bedrock_old": "نموذج Bedrock القديم",
	"format.bedrock_old.desc": "نموذج كيان Minecraft Bedrock Edition قبل الإصدار 1.12",
	"format.modded_entity": "كيان معدل",
	"format.modded_entity.desc": "نموذج كيان لمودات ماين كرافت. يمكن تصديره كملفات فئة .java.",
	"format.optifine_entity": "كيان OptiFine",
	"format.optifine_entity.desc": "نموذج كيان مخصص لمود OptiFine",
	"keys.mouse": "زر الماوس %0",
	"message.cleared_blank_faces.title": "وجوه فارغة",
	"message.cleared_blank_faces.message": "وجد Blockbench %0 مكعب بدون أي خامة. هل تريد إزالة هذه العناصر؟",
	"message.wireframe.enabled": "تم تمكين عرض الهيكل السلكي",
	"message.wireframe.disabled": "تم تعطيل عرض الهيكل السلكي",
	"dialog.convert_project.title": "تحويل المشروع",
	"dialog.create_texture.double_use": "الاحتفاظ بإشغال الخامة المتعدد",
	"dialog.model_stats.title": "إحصائيات النموذج",
	"dialog.model_stats.cubes": "مكعبات",
	"dialog.model_stats.locators": "نقاط مرجعية",
	"dialog.model_stats.groups": "مجموعات",
	"dialog.model_stats.vertices": "رؤوس",
	"dialog.model_stats.faces": "وجوه",
	"settings.username": "اسم المستخدم",
	"settings.username.desc": "اسم المستخدم لجلسات التحرير",
	"settings.painting_grid": "شبكة الرسم",
	"settings.painting_grid.desc": "إظهار الشبكة على العناصر المزودة بخامة في نمط الرسم",
	"action.convert_project": "تحويل المشروع",
	"action.convert_project.desc": "تحويل المشروع الحالي إلى مشروع بتنسيق نموذج آخر",
	"action.close_project": "إغلاق المشروع",
	"action.close_project.desc": "إغلاق المشروع المفتوح حالياً",
	"action.export_bedrock": "تصدير هندسة Bedrock",
	"action.export_bedrock.desc": "تصدير النموذج كملف هندسة لإصدار Bedrock.",
	"action.save_project": "حفظ المشروع",
	"action.save_project.desc": "حفظ النموذج الحالي كملف مشروع",
	"action.save_project_as": "حفظ المشروع باسم",
	"action.save_project_as.desc": "حفظ النموذج الحالي كملف مشروع في موقع جديد",
	"action.export_over": "حفظ النموذج",
	"action.export_over.desc": "حفظ النموذج والخامات والحركات عن طريق استبدال الملفات",
	"action.add_locator": "إضافة نقطة مرجعية",
	"action.add_locator.desc": "إضافة نقطة مرجعية جديدة للتحكم في مواضع الجسيمات والمقودات وغيرها",
	"action.uv_turn_mapping": "تدوير التخطيط",
	"action.uv_turn_mapping.desc": "تدوير تخطيط UV بمقدار 90 درجة",
	"action.remove_blank_faces": "إزالة الوجوه الفارغة",
	"action.remove_blank_faces.desc": "حذف جميع الوجوه غير المزودة بخامة من التحديد",
	"web.download_app": "تنزيل التطبيق",
	"uv_editor.turned": "تم تدوير التخطيط",
	"display.reference.crossbow": "قوس صليبي مشحون",
	"dialog.settings.search_results": "نتائج البحث",
	"settings.animation_snap": "محاذاة الحركة",
	"settings.animation_snap.desc": "فاصل المحاذاة الافتراضي للإطارات المفتاحية في الجدول الزمني للحركة بالخطوات في الثانية. يمكن تغيير هذا أيضاً لكل حركة. القيمة الافتراضية هي 24.",
	"action.import_optifine_part": "استيراد جزء OptiFine",
	"action.import_optifine_part.desc": "استيراد نموذج جزء كيان لـ OptiFine",
	"data.locator": "نقطة مرجعية",
	"mode.start.no_recents": "لا توجد نماذج مفتوحة مؤخراً",
	"panel.element": "عنصر",
	"panel.element.position": "موضع",
	"panel.element.size": "حجم",
	"panel.element.origin": "نقطة الارتكاز",
	"panel.element.rotation": "تدوير",
	"message.canvas_limit_error.title": "خطأ في حد اللوحة",
	"message.canvas_limit_error.message": "لا يمكن تنفيذ الإجراء بشكل صحيح لأن التنسيق يحد من اللوحة إلى 48 وحدة. قم بتحويل نقطة الارتكاز لمنع ذلك.",
	"data.effect": "تأثير",
	"generic.name": "الاسم",
	"settings.recent_projects": "حد النماذج الحديثة",
	"settings.recent_projects.desc": "الحد الأقصى لعدد النماذج الحديثة التي يتم تذكرها",
	"settings.volume": "مستوى الصوت",
	"settings.volume.desc": "التحكم في مستوى الصوت للمؤثرات الصوتية في الحركات",
	"action.clear_timeline": "مسح الجدول الزمني",
	"action.clear_timeline.desc": "مسح جميع العظام غير المحددة من الجدول الزمني",
	"action.select_effect_animator": "تحريك التأثيرات",
	"action.select_effect_animator.desc": "فتح الجدول الزمني لإضافة مؤثرات صوتية وجسيمات",
	"action.timeline_focus": "تصفية القنوات",
	"action.timeline_focus.desc": "تحديد قنوات الحركة لعرضها في الجدول الزمني",
	"timeline.particle": "جسيم",
	"timeline.sound": "صوت",
	"timeline.effects": "تأثيرات",
	"data.format": "تنسيق",
	"format.optifine_part": "جزء OptiFine",
	"format.optifine_part.desc": "جزء JPM لنماذج كيان OptiFine",
	"action.reverse_keyframes": "عكس الإطارات المفتاحية",
	"action.reverse_keyframes.desc": "عكس ترتيب الإطارات المفتاحية المحددة",
	"generic.help": "مساعدة",
	"message.removed_faces": "تمت إزالة %0 وجه",
	"dialog.sketchfab_uploader.draft": "مسودة",
	"action.slider_pos": "موضع %0",
	"action.slider_pos.desc": "تحريك العناصر على المحور %0",
	"action.slider_size": "حجم %0",
	"action.slider_size.desc": "تغيير حجم العناصر على المحور %0",
	"action.slider_rotation": "تدوير %0",
	"action.slider_rotation.desc": "تدوير العناصر على المحور %0",
	"action.slider_origin": "نقطة الارتكاز %0",
	"action.slider_origin.desc": "تحريك نقطة الارتكاز على المحور %0",
	"action.rotate_cw": "تدوير %0 +90",
	"action.rotate_cw.desc": "تدوير العناصر المحددة بمقدار 90 درجة على المحور %0",
	"action.rotate_ccw": "تدوير %0 -90",
	"action.rotate_ccw.desc": "تدوير العناصر المحددة بمقدار -90 درجة على المحور %0",
	"action.flip": "قلب %0",
	"action.flip.desc": "قلب العناصر المحددة على المحور %0",
	"action.center": "توسيط %0",
	"action.center.desc": "توسيط العناصر المحددة على المحور %0",
	"action.bring_up_all_animations": "إظهار جميع المحركات",
	"panel.bone": "عظمة",
	"data.color": "لون",
	"generic.export": "تصدير",
	"generic.none": "لا شيء",
	"status_bar.recording": "تسجيل مقطع زمني",
	"message.add_to_palette": "تمت الإضافة إلى اللوحة",
	"message.size_modifiers": "اضغط مع الاستمرار على Ctrl أو Shift للتحويل بزيادات أصغر.",
	"message.timelapse_start": "بدأ المقطع الزمني",
	"message.timelapse_stop": "توقف المقطع الزمني",
	"message.import_palette.replace_palette": "استبدال اللوحة القديمة",
	"message.import_palette.threshold": "حد الدمج",
	"dialog.timelapse.interval": "الفاصل الزمني (بالثواني)",
	"dialog.timelapse.source": "المصدر",
	"dialog.timelapse.source.interface": "الواجهة",
	"dialog.timelapse.source.locked": "زاوية مثبتة",
	"dialog.timelapse.destination": "المجلد الوجهة",
	"layout.color.checkerboard": "رقعة الشطرنج",
	"layout.color.checkerboard.desc": "خلفية اللوحة ومحرر UV",
	"layout.font.code": "خط الكود",
	"layout.css": "CSS مخصص",
	"settings.category.paint": "رسم",
	"settings.deactivate_size_limit": "إلغاء تنشيط حد الحجم",
	"settings.deactivate_size_limit.desc": "إلغاء تنشيط حد الحجم لتنسيقات نماذج معينة. تحذير: قد يؤدي ذلك إلى نماذج غير صالحة.",
	"settings.brush_opacity_modifier": "معدل شفافية الفرشاة",
	"settings.brush_opacity_modifier.desc": "تعديل شفافية الفرشاة عند استخدام قلم",
	"settings.brush_size_modifier": "معدل حجم الفرشاة",
	"settings.brush_size_modifier.desc": "تعديل حجم الفرشاة عند استخدام قلم",
	"settings.brush_modifier.pressure": "الضغط",
	"settings.brush_modifier.tilt": "الإمالة",
	"category.color": "لون",
	"action.import_theme": "استيراد سمة",
	"action.export_theme": "تصدير سمة",
	"action.export_theme.desc": "إنشاء ملف سمة بناءً على الإعدادات الحالية",
	"action.slider_color_h": "درجة اللون",
	"action.slider_color_s": "التشبع",
	"action.slider_color_v": "القيمة",
	"action.add_to_palette": "إضافة إلى اللوحة",
	"action.add_to_palette.desc": "إضافة اللون المحدد إلى لوحة الألوان",
	"action.import_palette": "استيراد لوحة",
	"action.import_palette.desc": "استيراد ملف لوحة",
	"action.export_palette": "تصدير لوحة",
	"action.export_palette.desc": "تصدير اللوحة كملف .GPL",
	"action.generate_palette": "إنشاء لوحة...",
	"action.generate_palette.desc": "إنشاء لوحة من خامة",
	"action.sort_palette": "ترتيب اللوحة",
	"action.sort_palette.desc": "ترتيب جميع الألوان في اللوحة حسب اللون والسطوع",
	"action.timelapse": "مقطع زمني...",
	"action.timelapse.desc": "تسجيل مقطع زمني لعملية النمذجة الخاصة بك",
	"action.add_keyframe": "إضافة إطار مفتاحي",
	"action.add_keyframe.desc": "إضافة إطار مفتاحي إلى المحرك المحدد",
	"action.bring_up_all_animations.desc": "إظهار جميع المحركات المعدلة في الجدول الزمني",
	"timeline.timeline": "تعليمات",
	"menu.palette.load.default": "افتراضي",
	"generic.import": "استيراد",
	"settings.brush_modifier.none": "لا شيء",
	"action.export_entity": "تصدير كيان Bedrock",
	"action.export_entity.desc": "تصدير النموذج كنموذج كيان لـ Minecraft Bedrock Edition",
	"settings.highlight_cubes": "تمييز العناصر",
	"settings.highlight_cubes.desc": "تمييز العناصر عند التمرير فوقها أو تحديدها",
	"action.add_marker": "تعيين علامة",
	"action.add_marker.desc": "تعيين علامة في الجدول الزمني",
	"timeline.pre_effect_script": "نص برمجي",
	"format.skin": "شخصية ماين كرافت",
	"format.skin.desc": "تحرير شخصيات اللاعبين والكائنات",
	"message.sketchfab.setup_guide": "هل تريد معرفة كيفية إعداد النماذج في Sketchfab؟ اقرأ %0",
	"dialog.skin.title": "إنشاء شخصية ماين كرافت",
	"dialog.skin.model": "نموذج",
	"action.toggle_skin_layer": "تبديل طبقة الشخصية",
	"action.toggle_skin_layer.desc": "تبديل طبقة القبعة والملابس لنموذج الشخصية",
	"action.gui_light": "إضاءة الواجهة",
	"action.gui_light.desc": "تحديد طريقة إضاءة العنصر في المخزون",
	"action.gui_light.side": "إضاءة جانبية",
	"action.gui_light.front": "إضاءة أمامية",
	"action.move_keyframe_back": "تحريك الإطارات المفتاحية للخلف",
	"action.move_keyframe_forth": "تحريك الإطارات المفتاحية للأمام",
	"menu.help": "مساعدة",
	"menu.help.discord": "خادم Discord",
	"menu.help.report_issue": "الإبلاغ عن مشكلة",
	"menu.help.plugin_documentation": "توثيق API الإضافات",
	"menu.help.search_action": "البحث عن إجراء وتنفيذه",
	"menu.help.donate": "التبرع",
	"menu.help.about": "حول...",
	"menu.preview.background.clipboard": "تحميل من الحافظة",
	"dialog.ignore": "تجاهل",
	"generic.unset": "إلغاء التعيين",
	"message.invalid_builtin_parent.title": "أب مدمج غير صالح",
	"message.invalid_builtin_parent.message": "تمت إزالة الارتباط بنموذج الأب غير الصالح '%0' لتصدير نموذج صالح.",
	"dialog.resize_texture.fill": "تعبئة بـ",
	"dialog.resize_texture.fill.transparent": "شفاف",
	"dialog.resize_texture.fill.color": "لون",
	"dialog.resize_texture.fill.repeat": "تكرار",
	"dialog.scale.element_pivot": "نقطة ارتكاز العنصر",
	"dialog.scale.selection_center": "مركز التحديد",
	"dialog.create_gif.length_mode": "نمط الطول",
	"dialog.create_gif.length_mode.seconds": "ثواني",
	"dialog.create_gif.length_mode.frames": "إطارات",
	"dialog.create_gif.length_mode.animation": "طول الحركة",
	"dialog.create_gif.length_mode.turntable": "دوران القرص الدوار",
	"dialog.save_angle.projection": "إسقاط",
	"dialog.save_angle.projection.perspective": "منظور",
	"dialog.save_angle.projection.orthographic": "متعامد",
	"dialog.sketchfab_uploader.animations": "حركات",
	"dialog.settings.theme": "سمة",
	"settings.category.interface": "واجهة",
	"settings.preview_checkerboard": "خلفية رقعة الشطرنج في المعاينة",
	"settings.preview_checkerboard.desc": "تبديل خلفية رقعة الشطرنج خلف المعاينة",
	"settings.uv_checkerboard": "خلفية رقعة الشطرنج في محرر UV",
	"settings.uv_checkerboard.desc": "تبديل خلفية رقعة الشطرنج خلف محرر UV",
	"category.paint": "رسم",
	"action.fill_mode.color_connected": "الألوان المتصلة",
	"action.draw_shape_type": "نوع الشكل",
	"action.draw_shape_type.rectangle": "مستطيل",
	"action.draw_shape_type.rectangle_h": "مستطيل (مجوف)",
	"action.draw_shape_type.ellipse": "قطع ناقص",
	"action.draw_shape_type.ellipse_h": "قطع ناقص (مجوف)",
	"action.draw_shape_type.line": "خط",
	"action.mirror_painting": "مرآة الرسم",
	"action.mirror_painting.description": "عكس ضربات الفرشاة إلى الجانب الآخر من النموذج",
	"action.lock_alpha": "قفل قناة ألفا",
	"action.lock_alpha.description": "قفل شفافية جميع البكسلات",
	"action.draw_shape_tool": "رسم شكل",
	"action.draw_shape_tool.desc": "أداة لرسم أشكال بسيطة على الخامات",
	"action.export_gltf": "تصدير نموذج glTF",
	"action.export_gltf.desc": "تصدير النموذج والحركات كملف glTF للمشاركة والعرض",
	"action.transform_space": "مساحة التحويل",
	"action.transform_space.desc": "مساحة التحويل الافتراضية للعناصر والعظام",
	"action.transform_space.global": "عام",
	"action.transform_space.local": "محلي",
	"action.toggle_camera_projection": "تبديل إسقاط الكاميرا",
	"action.toggle_camera_projection.desc": "التبديل بين إسقاط الكاميرا المنظوري والمتعامد",
	"action.load_camera_angle": "زاوية الكاميرا: %0",
	"action.load_camera_angle.desc": "تحميل زاوية الكاميرا '%0'",
	"action.slider_face_tint": "مؤشر التلوين",
	"action.slider_face_tint.desc": "تعيين مؤشر التلوين للوجه الحالي. -1 يعني غير معين.",
	"menu.help.quickstart": "معالج البدء السريع",
	"menu.help.developer": "مطور",
	"menu.help.developer.dev_tools": "فتح أدوات المطور",
	"menu.help.developer.reset_storage": "إعادة الضبط إلى إعدادات المصنع",
	"menu.help.developer.reset_storage.confirm": "هل أنت متأكد من رغبتك في إعادة ضبط Blockbench إلى إعدادات المصنع؟ سيؤدي هذا إلى حذف جميع الإعدادات المخصصة واختصارات لوحة المفاتيح والإضافات المثبتة.",
	"menu.help.developer.cache_reload": "إعادة تحميل ذاكرة التخزين المؤقت",
	"menu.preview.orthographic": "متعامد",
	"menu.preview.save_angle": "حفظ الزاوية...",
	"menu.preview.angle": "زوايا",
	"menu.preview.angle.initial": "الزاوية الأولية",
	"menu.preview.maximize": "تكبير",
	"uv_editor.copy_selection": "نسخ التحديد",
	"uv_editor.paste_selection": "لصق التحديد",
	"uv_editor.copy_paste_tool.place": "وضع",
	"uv_editor.copy_paste_tool.mirror_x": "مرآة X",
	"uv_editor.copy_paste_tool.mirror_y": "مرآة Y",
	"uv_editor.copy_paste_tool.rotate": "تدوير 90 درجة",
	"dialog.project.modded_entity_version": "إصدار التصدير",
	"dialog.save_angle.position": "موضع الكاميرا",
	"dialog.save_angle.target": "نقطة التركيز",
	"dialog.skin.pose": "وضعية",
	"layout.color.frame": "إطار النافذة",
	"layout.color.frame.desc": "حدود النافذة وشريط العنوان",
	"settings.large_grid_size": "حجم شبكة المكعبات",
	"settings.large_grid_size.desc": "حجم شبكة المكعبات",
	"action.load_plugin_from_url": "تحميل إضافة من رابط",
	"action.load_plugin_from_url.desc": "تحميل إضافة من خادم عن طريق تحديد الرابط",
	"action.cube_counter.desc": "عرض العدد الحالي للعناصر والإحصائيات الأخرى",
	"action.unlock_everything": "فتح الكل",
	"action.unlock_everything.desc": "فتح جميع المجموعات والعناصر في المخطط التفصيلي.",
	"action.load_palette": "تحميل لوحة",
	"action.load_palette.desc": "تحميل أحد الإعدادات المسبقة للوحة المضمنة أو المحفوظة",
	"action.toggle_locked": "تبديل القفل",
	"action.toggle_locked.desc": "تبديل ما إذا كانت العناصر المحددة مقفلة",
	"action.apply_display_preset": "تطبيق الإعداد المسبق",
	"action.apply_display_preset.desc": "تطبيق إعداد مسبق لعرض الإعدادات افتراضي أو مخصص",
	"action.apply_display_preset.here": "تطبيق على هذه الفتحة",
	"action.apply_display_preset.everywhere": "تطبيق على جميع الفتحات",
	"action.resolve_keyframe_expressions": "تحليل الإطار المفتاحي",
	"action.resolve_keyframe_expressions.desc": "تحليل التعبيرات الرياضية للإطارات المفتاحية المحددة",
	"action.fold_all_animations": "طي جميع المحركات",
	"menu.palette.load.empty": "فارغ",
	"switches.lock": "قفل",
	"settings.render_sides": "عرض الجوانب",
	"settings.render_sides.desc": "تحديد أي جانب من الوجه يتم عرضه",
	"settings.render_sides.auto": "تلقائي",
	"settings.render_sides.front": "الخارج",
	"settings.render_sides.double": "الداخل والخارج",
	"generic.enable": "تمكين",
	"generic.disable": "تعطيل",
	"generic.redacted": "محذوف",
	"dialog.select_texture.import_all": "استيراد الكل",
	"dialog.skin.layer_template": "خامة الطبقة",
	"about.version.up_to_date": "محدث",
	"about.version.update_available": "يتوفر الإصدار %0",
	"settings.category.application": "التطبيق",
	"settings.streamer_mode": "نمط البث",
	"settings.streamer_mode.desc": "إخفاء المعلومات الحساسة مثل النماذج الحديثة",
	"settings.automatic_updates": "تحديثات تلقائية",
	"settings.automatic_updates.desc": "تنزيل الإصدارات الجديدة تلقائياً والحفاظ على تحديث Blockbench",
	"action.rotation_space": "مساحة الدوران",
	"action.focus_on_selection": "توسيط العرض على التحديد",
	"action.focus_on_selection.desc": "محاذاة الكاميرا لمواجهة مركز التحديد الحالي",
	"action.jump_to_timeline_start": "الانتقال إلى بداية الحركة",
	"action.jump_to_timeline_end": "الانتقال إلى نهاية الحركة",
	"menu.help.updating": "جاري التحديث (%0%)",
	"menu.help.update_failed": "فشل التحديث",
	"menu.animation.loop.once": "تشغيل مرة واحدة",
	"menu.animation.loop.hold": "التثبيت على الإطار الأخير",
	"menu.animation.loop.loop": "تكرار",
	"interface.streamer_mode_on": "تم تمكين نمط البث",
	"generic.reset": "إعادة ضبط",
	"generic.restore": "استعادة",
	"keys.mousewheel": "عجلة الماوس",
	"message.delete_animation.title": "حذف الحركة",
	"message.delete_animation.message": "تمت إزالة الحركة من Blockbench. هل تريد أيضاً حذف الحركة من الملف الذي تم حفظها فيه؟",
	"message.no_animation_to_import": "لا توجد حركات للاستيراد",
	"dialog.material_instances.title": "نسخ المواد",
	"dialog.animation_import.title": "تحديد حركات للاستيراد",
	"dialog.create_texture.padding": "هامش",
	"settings.fov": "مجال الرؤية",
	"settings.fov.desc": "مجال رؤية الكاميرا. القيمة الافتراضية هي 45",
	"settings.minify_bbmodel": "ملفات مشروع مضغوطة",
	"settings.minify_bbmodel.desc": "كتابة ملفات .bbmodel مضغوطة في سطر واحد",
	"action.edit_material_instances": "تحرير نسخ المواد",
	"action.edit_material_instances.desc": "تحرير أسماء نسخ المواد لهندسة كتل Bedrock",
	"action.save_all_animations": "حفظ جميع الحركات",
	"action.save_all_animations.desc": "حفظ جميع الحركات المحملة حالياً",
	"action.keyframe_interpolation": "الاستيفاء",
	"action.keyframe_interpolation.desc": "تحديد نمط استيفاء الإطار المفتاحي",
	"action.keyframe_interpolation.linear": "خطي",
	"action.keyframe_interpolation.catmullrom": "ناعم",
	"action.timeline_focus.hide_empty": "إخفاء القنوات الفارغة",
	"menu.file.preferences": "التفضيلات",
	"menu.animation.blend_weight": "وزن المزج",
	"menu.animation.save": "حفظ",
	"menu.animation.properties": "خصائص...",
	"menu.animation.file": "ملف",
	"menu.animation.snapping": "محاذاة",
	"menu.animation.open_location": "إظهار في مستكشف الملفات",
	"panel.keyframe.add_data_point": "إضافة نقطة بيانات إطار مفتاحي",
	"panel.keyframe.remove_data_point": "إزالة نقطة بيانات",
	"panel.keyframe.pre": "قبل",
	"panel.keyframe.post": "بعد",
	"generic.all": "الكل",
	"message.small_face_dimensions.title": "أبعاد وجه غير متوافقة",
	"message.small_face_dimensions.message": "يحتوي التحديد على وجوه أصغر من وحدة واحدة في اتجاه واحد. يعتبر نظام تخطيط UV الصندوقي أي وجوه أقل من هذا الحد بعرض 0 بكسل. لذلك قد لا تعمل الخامة على هذه الوجوه بشكل صحيح.",
	"message.small_face_dimensions.face_uv": "يدعم التنسيق الحالي خرائط UV لكل وجه يمكنها التعامل مع أبعاد الوجوه الصغيرة. انقر بزر الماوس الأيمن على المكعبات المتأثرة وقم بتغيير \"نمط UV\" إلى \"UV لكل وجه\".",
	"dialog.plugins.outdated_client": "يتطلب إصداراً أحدث من Blockbench",
	"dialog.plugins.outdated_plugin": "الإضافة قديمة ولا تعمل مع هذا الإصدار من Blockbench",
	"settings.motion_trails": "آثار الحركة",
	"settings.motion_trails.desc": "إظهار آثار الحركة في محرر الحركة",
	"settings.antialiasing": "مكافحة التعرج",
	"settings.antialiasing.desc": "تبديل مكافحة التعرج في المعاينة",
	"action.timeline_frame_back": "الانتقال إطاراً واحداً للخلف",
	"action.timeline_frame_forth": "الانتقال إطاراً واحداً للأمام",
	"panel.bone.ik": "الحركة العكسية (تجريبي)",
	"settings.particle_tick_rate": "معدل تحديث الجسيمات",
	"settings.particle_tick_rate.desc": "معدل تحديث تأثيرات الجسيمات بالعلامات في الثانية. القيمة الافتراضية هي 30",
	"action.lock_motion_trail": "قفل أثر الحركة",
	"action.lock_motion_trail.desc": "قفل أثر الحركة على المجموعة المحددة حالياً",
	"menu.animation_file.unload": "إلغاء تحميل الملف",
	"data.null_object": "كائن فارغ",
	"status_bar.toggle_sidebar": "تبديل الشريط الجانبي",
	"message.load_plugin_failed.title": "فشل تحميل الإضافة",
	"message.load_plugin_failed.message": "تأكد من أن اسم الملف الأساسي للإضافة يطابق معرف الإضافة `%0`، كما هو محدد في Plugin.register().",
	"dialog.project.uv_mode": "نمط UV",
	"dialog.project.uv_mode.box_uv": "UV صندوقي",
	"dialog.project.uv_mode.face_uv": "UV لكل وجه",
	"dialog.project.texture_size": "حجم الخامة",
	"dialog.animation_export.title": "تحديد حركات للتصدير",
	"dialog.create_texture.rearrange_uv": "إعادة ترتيب UV",
	"layout.color.subtle_text": "نص خافت",
	"layout.color.subtle_text.desc": "لون نص ثانوي بتباين أقل",
	"settings.interface_scale": "مقياس الواجهة",
	"settings.interface_scale.desc": "مقياس واجهة Blockbench بأكملها",
	"settings.background_rendering": "عرض الخلفية",
	"settings.background_rendering.desc": "تحديث المعاينة عندما لا تكون النافذة في التركيز",
	"settings.ctrl_shift_size": "دقة Ctrl + Shift",
	"settings.ctrl_shift_size.desc": "دقة الشبكة أثناء الضغط على Ctrl و Shift",
	"settings.hardware_acceleration": "تسريع الأجهزة",
	"settings.hardware_acceleration.desc": "إسناد مهام العرض إلى بطاقة الرسومات",
	"action.explode_skin_model": "تفجير نموذج الشخصية",
	"action.explode_skin_model.desc": "تبديل عرض التفجير الذي يسمح لك بتحرير الوجوه المغطاة",
	"action.export_minecraft_skin": "تصدير شخصية ماين كرافت",
	"action.export_minecraft_skin.desc": "تصدير شخصية ماين كرافت كخامة PNG",
	"action.add_null_object": "إضافة كائن فارغ",
	"action.add_null_object.desc": "إضافة كائن فارغ جديد",
	"action.animated_texture_frame": "إطار الخامة المتحركة",
	"action.animated_texture_frame.desc": "تعيين الإطار الحالي للخامة المتحركة",
	"action.export_animation_file": "تصدير حركات...",
	"action.export_animation_file.desc": "تصدير مجموعة من الحركات إلى ملف جديد",
	"action.timeline_graph_editor": "تبديل محرر الرسم البياني",
	"action.timeline_graph_editor.desc": "التبديل بين عرض محرر الرسم البياني وعرض الإطارات المفتاحية في الجدول الزمني",
	"menu.file.recent.clear": "مسح الملفات الحديثة",
	"switches.shade": "تظليل",
	"generic.share": "مشاركة",
	"dates.minute": "%0 دقيقة",
	"dates.minutes": "%0 دقائق",
	"dates.hour": "%0 ساعة",
	"dates.hours": "%0 ساعات",
	"dates.day": "%0 يوم",
	"dates.days": "%0 أيام",
	"dates.week": "%0 أسبوع",
	"dates.weeks": "%0 أسابيع",
	"dates.year": "%0 سنة",
	"dates.years": "%0 سنوات",
	"message.installed_plugin": "تم تثبيت الإضافة %0 بنجاح",
	"message.installed_plugin_fail": "فشل تثبيت الإضافة %0",
	"dialog.share_model.title": "مشاركة النموذج",
	"dialog.share_model.expire_time": "وقت الانتهاء",
	"dialog.share_model.failed": "فشل رفع النموذج",
	"action.import_java_block_model": "إضافة نموذج كتلة/عنصر Java",
	"action.import_java_block_model.desc": "إضافة نموذج كتلة أو عنصر Minecraft Java من ملف json إلى النموذج الحالي",
	"action.share_model": "مشاركة...",
	"action.share_model.desc": "إنشاء رابط قصير لمشاركة النموذج الخاص بك",
	"action.import_project": "استيراد مشروع",
	"action.import_project.desc": "استيراد مشروع آخر من ملف .bbmodel إلى المشروع الحالي",
	"dialog.toolbar_edit.hidden_tools": "قد تكون بعض الأدوات مخفية لأنها غير متوفرة في الوضع أو التنسيق أو الحالة الحالية.",
	"settings.camera_near_plane": "المستوى القريب للكاميرا",
	"settings.camera_near_plane.desc": "المسافة الدنيا من الكاميرا حيث يتم عرض الكائنات. تؤدي القيم الأعلى إلى تقليل تعارض Z. القيمة الافتراضية هي 1.",
	"mode.start.keymap_preference.desc": "إذا كنت جديداً في Blockbench وتأتيك من برنامج ثلاثي الأبعاد آخر، يمكنك تحديد تخطيط مفاتيح لتسهيل انتقالك. يمكنك تغيير تخطيط المفاتيح أو اختصارات المفاتيح الفردية لاحقاً في الإعدادات.",
	"message.load_keymap": "هل أنت متأكد من رغبتك في تحميل تخطيط المفاتيح هذا؟ سيؤدي هذا إلى استبدال اختصارات لوحة المفاتيح الحالية.",
	"message.keymap_loaded": "تم تحميل تخطيط المفاتيح",
	"dialog.convert_project.current_format": "التنسيق الحالي",
	"dialog.create_texture.rearrange_uv.desc": "إنشاء ترتيب UV جديد لإعطاء كل وجه موقعه الخاص على الخامة",
	"dialog.create_texture.power.desc": "تثبيت الحجم التلقائي للخامة على قوة 2، مثل 64 أو 128. هذا مطلوب من قبل بعض برامج العرض",
	"dialog.create_texture.double_use.desc": "إذا كان عنصران يشغلان بالفعل نفس مساحة UV، فاحتفظ بذلك في الخريطة الجديدة",
	"dialog.create_texture.padding.desc": "إضافة هامش صغير بين الأجزاء الفردية للقالب",
	"dialog.create_texture.resolution.desc": "ارتفاع وعرض الخامة",
	"dialog.create_gif.color": "لون الخلفية",
	"dialog.save_angle.zoom": "تكبير",
	"dialog.skin.variant": "النسخة",
	"dialog.flip_animation.info": "يتم التعرف على العظام المتقابلة من خلال الكلمات المفتاحية 'left' و 'right' داخل أسمائها.",
	"dialog.export_private_settings.title": "إعدادات خاصة",
	"dialog.export_private_settings.message": "يحتوي ملفك على المعلومات الخاصة التالية: **%0**. اترك هذه القيم خارجاً إذا كنت تخطط لمشاركة الملف مع شخص آخر.",
	"dialog.export_private_settings.keep": "الاحتفاظ",
	"settings.timecode_frame_number": "عرض الأكواد الزمنية كأرقام إطارات",
	"settings.timecode_frame_number.desc": "عرض الأكواد الزمنية الكسرية في الجدول الزمني كرقم إطار بدلاً من جزء من المائة من الثانية",
	"settings.animation_sample_rate": "معدل أخذ عينات الحركة",
	"settings.animation_sample_rate.desc": "معدل أخذ العينات بالعينة في الثانية للمنحنيات التي لا يدعمها التنسيق المعني أصلاً",
	"keybind.preview_zoom": "عرض التكبير بالسحب",
	"action.gradient_tool": "أداة التدرج",
	"action.gradient_tool.desc": "إنشاء تدرج لوني على الخامة",
	"action.import_settings": "استيراد الإعدادات",
	"action.import_settings.desc": "استيراد ملف .bbsettings",
	"action.export_settings": "تصدير الإعدادات",
	"action.export_settings.desc": "تصدير إعدادات Blockbench كملف .bbsettings",
	"action.load_keymap": "تحميل تخطيط مفاتيح",
	"action.load_keymap.default": "افتراضي (لوحة اللمس/الماوس)",
	"action.load_keymap.mouse": "افتراضي (الماوس)",
	"action.load_keymap.default.desc": "اختصارات Blockbench الافتراضية، مع عناصر تحكم في التنقل في نافذة العرض محسّنة للاستخدام على لوحات اللمس لأجهزة الكمبيوتر المحمولة",
	"action.load_keymap.mouse.desc": "اختصارات Blockbench الافتراضية، مع ربط التنقل في نافذة العرض بزر الماوس الأوسط",
	"action.load_keymap.blender.desc": "تخطيط مفاتيح للمستخدمين الملمين بضوابط Blender",
	"action.load_keymap.cinema4d.desc": "تخطيط مفاتيح للمستخدمين الملمين بضوابط Cinema 4D",
	"action.load_keymap.maya.desc": "تخطيط مفاتيح للمستخدمين الملمين بضوابط Autodesk Maya",
	"action.import_keymap": "استيراد تخطيط مفاتيح",
	"action.import_keymap.desc": "استيراد اختصارات لوحة المفاتيح من ملف .bbkeymap",
	"action.export_keymap": "تصدير تخطيط مفاتيح",
	"action.export_keymap.desc": "تصدير اختصارات لوحة المفاتيح الحالية كملف .bbkeymap",
	"action.edit_history": "سجل التحرير...",
	"action.edit_history.desc": "عرض سجل التحرير والتراجع عن الخطوات أو إعادتها",
	"action.group_elements": "تجميع العناصر",
	"action.group_elements.desc": "تضمين العناصر المحددة في مجموعة جديدة",
	"action.unfold_groups": "فك طي المجموعات",
	"action.unfold_groups.desc": "فك طي جميع المجموعات أو العناصر المتداخلة في المخطط التفصيلي",
	"action.edit_bedrock_binding": "تحرير الربط...",
	"action.edit_bedrock_binding.desc": "تغيير العظمة التي ترتبط بها الهندسة",
	"action.pick_screen_color": "اختيار لون الشاشة",
	"action.pick_screen_color.desc": "اختيار لون من مكان ما على الشاشة",
	"action.view_mode": "نمط العرض",
	"action.view_mode.desc": "تغيير نمط عرض النموذج",
	"action.view_mode.textured": "مزود بخامة",
	"action.view_mode.solid": "صلب",
	"action.view_mode.wireframe": "هيكل سلكي",
	"action.toggle_sidebars": "تبديل الأشرطة الجانبية",
	"action.toggle_sidebars.desc": "تمكين أو تعطيل الأشرطة الجانبية",
	"action.set_animation_end": "تعيين نهاية الحركة",
	"action.set_animation_end.desc": "تعيين نهاية الحركة المحددة إلى الوقت الحالي في الجدول الزمني",
	"action.flip_animation": "قلب الحركة",
	"action.flip_animation.desc": "قلب جزء من الحركة عن طريق نسخ الإطارات المفتاحية المحددة إلى الجانب الآخر من النموذج",
	"action.graph_editor_zero_line": "تضمين خط الصفر",
	"action.graph_editor_zero_line.desc": "ما إذا كان محرر الرسم البياني يتضمن دائماً خط الصفر في العرض",
	"menu.texture.render_mode": "نمط العرض",
	"menu.texture.render_mode.emissive": "مضيء",
	"menu.texture.render_mode.layered": "طبقي",
	"menu.preview.angle.edit": "تحرير الزاوية...",
	"menu.animation.start_delay": "تأخير البدء",
	"menu.animation.loop_delay": "تأخير التكرار",
	"menu.animation.flip_keyframes": "قلب الإطارات المفتاحية",
	"menu.mobile_keyboard.disable_all": "تعطيل الكل",
	"panel.keyframe.toggle_uniform_scale": "تبديل القياس المنتظم",
	"camera_angle.common_isometric_right": "متساوي القياس يمين (2:1)",
	"camera_angle.common_isometric_left": "متساوي القياس يسار (2:1)",
	"camera_angle.true_isometric_right": "متساوي القياس حقيقي يمين (30°)",
	"camera_angle.true_isometric_left": "متساوي القياس حقيقي يسار (30°)",
	"menu.help.wiki": "ويكي Blockbench",
	"settings.update_to_prereleases": "التحديث إلى الإصدارات الأولية",
	"settings.update_to_prereleases.desc": "التحديث تلقائياً إلى إصدارات بيتا من Blockbench لاختبار الميزات الجديدة. قد تكون الإصدارات الأولية غير مستقرة، لا تقم بتمكين هذا الخيار إذا كنت تعتمد على Blockbench في العمل أو المشاريع المهمة الأخرى.",
	"data.separator.spacer": "فاصل",
	"data.separator.linebreak": "فاصل سطر",
	"data.setting": "إعداد",
	"generic.select_all": "تحديد الكل",
	"generic.select_none": "إلغاء تحديد الكل",
	"projects.new_tab": "علامة تبويب جديدة",
	"projects.close_tab": "إغلاق علامة التبويب",
	"message.invalid_format.title": "تنسيق غير صالح",
	"message.invalid_format.message": "تم إنشاء هذا النموذج بتنسيق '%0'، وهو غير متوفر في تثبيت Blockbench الخاص بك. على الأرجح أنك بحاجة إلى إضافة معينة لفتحه بشكل صحيح.",
	"message.invalid_link": "رابط نموذج غير صالح أو منتهي الصلاحية",
	"message.default_textures.current": "المسار الحالي",
	"message.update_after_restart": "سيتم تثبيت التحديث بعد إعادة التشغيل التالية",
	"message.copy_paste_tool_viewport": "يمكن استخدام هذه الأداة فقط في المحرر ثنائي الأبعاد",
	"dialog.project.shadow_size": "حجم الظل",
	"dialog.find_replace.target": "الهدف",
	"dialog.find_replace.target.element_names": "أسماء العناصر",
	"dialog.find_replace.target.group_names": "أسماء المجموعات",
	"dialog.find_replace.target.animation_names": "أسماء الحركات",
	"dialog.find_replace.target.keyframe_values": "قيم الإطارات المفتاحية",
	"dialog.find_replace.find": "بحث",
	"dialog.find_replace.replace": "استبدال",
	"dialog.find_replace.regex": "تعبير نمطي",
	"dialog.add_primitive.shape": "شكل",
	"dialog.add_primitive.shape.circle": "دائرة",
	"dialog.add_primitive.shape.tube": "أنبوب",
	"dialog.add_primitive.shape.cone": "مخروط",
	"dialog.add_primitive.shape.cylinder": "أسطوانة",
	"dialog.add_primitive.shape.sphere": "كرة",
	"dialog.add_primitive.shape.torus": "طارة",
	"dialog.add_primitive.shape.cube": "متوازي مستطيلات",
	"dialog.add_primitive.shape.pyramid": "هرم",
	"dialog.add_primitive.diameter": "القطر",
	"dialog.add_primitive.height": "الارتفاع",
	"dialog.add_primitive.sides": "الأضلاع",
	"dialog.add_primitive.minor_diameter": "السماكة",
	"dialog.add_primitive.minor_sides": "الأضلاع الصغرى",
	"dialog.create_texture.combine_polys": "دمج الجزر",
	"dialog.create_texture.combine_polys.desc": "دمج الوجوه في جزر UV متصلة",
	"dialog.model_stats.meshes": "شبكات",
	"dialog.export_private_settings.omit": "استبعاد",
	"layout.select": "تحديد",
	"layout.options": "خيارات",
	"layout.color": "مخطط الألوان",
	"layout.documentation": "توثيق",
	"layout.color.bright_ui_text": "نص واجهة مضيئة",
	"layout.color.bright_ui_text.desc": "نص على خلفيات مضيئة",
	"layout.name": "الاسم",
	"layout.author": "المؤلف",
	"settings.dialog.desc": "إظهار مربع حوار \"%0\"",
	"settings.export_empty_groups": "تصدير المجموعات الفارغة",
	"settings.export_empty_groups.desc": "تضمين المجموعات بدون محتوى في الملفات المصدرة",
	"category.separators": "فواصل",
	"keybind.preview_area_select": "تحديد المنطقة",
	"action.color_erase_mode": "نمط المسح",
	"action.color_erase_mode.desc": "مع تمكين نمط المسح، تقوم أدوات مثل التعبئة والمستطيل بطرح الألوان بدلاً من إضافتها",
	"action.open_from_link": "فتح نموذج من رابط...",
	"action.open_from_link.desc": "فتح نموذج من رابط blckbn.ch",
	"action.import_obj": "استيراد نموذج OBJ",
	"action.import_obj.desc": "استيراد كائنات من نموذج OBJ كشبكات",
	"action.add_plugin": "تثبيت إضافة",
	"action.add_plugin.desc": "تثبيت إضافة من خلال التحكم في الإجراءات",
	"action.remove_plugin": "إلغاء تثبيت إضافة",
	"action.remove_plugin.desc": "إلغاء تثبيت إضافة من خلال التحكم في الإجراءات",
	"action.add_mesh": "إضافة شبكة",
	"action.add_mesh.desc": "إضافة شبكة جديدة",
	"action.add_texture_mesh": "إضافة شبكة خامة",
	"action.add_texture_mesh.desc": "إضافة شبكة خامة جديدة",
	"action.find_replace": "بحث/استبدال...",
	"action.find_replace.desc": "البحث عن أجزاء من الأسماء واستبدالها",
	"action.hide_everything_except_selection": "إخفاء كل شيء باستثناء التحديد",
	"action.hide_everything_except_selection.desc": "تبديل رؤية جميع العناصر باستثناء العناصر المحددة",
	"action.transform_space.normal": "عادي",
	"action.selection_mode": "نمط التحديد",
	"action.selection_mode.desc": "تغيير كيفية تحديد العناصر في نافذة العرض",
	"action.selection_mode.object": "كائن",
	"action.selection_mode.face": "وجه",
	"action.selection_mode.vertex": "رأس",
	"action.create_face": "إنشاء وجه أو حافة",
	"action.create_face.desc": "إنشاء وجه أو حافة جديدة بين الرؤوس المحددة",
	"action.convert_to_mesh": "تحويل إلى شبكة",
	"action.convert_to_mesh.desc": "تحويل العناصر المحددة إلى شبكات",
	"action.invert_face": "عكس الوجه",
	"action.invert_face.desc": "عكس الوجوه المحددة لجعلها تواجه الاتجاه المعاكس",
	"action.extrude_mesh_selection": "استخراج التحديد",
	"action.extrude_mesh_selection.desc": "استخراج الأجزاء المحددة من الشبكة",
	"action.loop_cut": "قطع حلقي",
	"action.loop_cut.desc": "تقسيم الشبكة في حلقة عبر الحافة المحددة",
	"action.merge_meshes": "دمج الشبكات",
	"action.merge_meshes.desc": "دمج شبكات متعددة في شبكة واحدة",
	"action.keyframe_uniform": "قياس منتظم",
	"action.keyframe_uniform.desc": "تمكين القياس المنتظم على الإطارات المفتاحية المحددة",
	"menu.locator.ignore_inherited_scale": "تجاهل القياس الموروث",
	"menu.texture.elements": "تطبيق على العناصر",
	"uv_editor.transparent_face": "وجه شفاف",
	"display.pose_angle": "زاوية الوضعية (للمعاينة فقط)",
	"data.mesh": "شبكة",
	"dialog.create_texture.type": "النوع",
	"dialog.create_texture.type.blank": "فارغ",
	"dialog.create_texture.type.template": "قالب خامة",
	"dialog.create_texture.type.color_map": "قالب لون صلب",
	"dialog.sketchfab_uploader.suggested_tags": "الوسوم المقترحة",
	"dialog.sketchfab_uploader.category": "الفئة",
	"dialog.sketchfab_uploader.category2": "الفئة 2",
	"layout.restore_backup": "تم استبدال السمة المخصصة \"%0\". انقر هنا لاستعادتها.",
	"layout.borders": "حدود",
	"action.fill_mode.element": "عنصر",
	"action.inset_mesh_selection": "إدخال التحديد",
	"action.inset_mesh_selection.desc": "إدخال الأجزاء المحددة من الشبكة",
	"action.dissolve_edges": "إذابة الحواف",
	"action.dissolve_edges.desc": "إذابة الحواف المحددة في الشبكة ودمج الوجوه التي تقسمها",
	"action.split_mesh": "تقسيم الشبكة",
	"action.split_mesh.desc": "تقسيم الوجوه المحددة من الشبكة إلى شبكة جديدة",
	"action.merge_vertices": "دمج الرؤوس",
	"action.merge_vertices.desc": "دمج الرؤوس المحددة في موضع الرأس الأول المحدد",
	"action.view_mode.normal": "اتجاه الوجه",
	"action.snap_uv_to_pixels": "محاذاة UV إلى البكسلات",
	"action.snap_uv_to_pixels.desc": "محاذاة رؤوس UV المحددة إلى شبكة البكسل",
	"menu.file.import.import_open_project": "استيراد مشروع مفتوح",
	"menu.help.unlock_projects": "فتح جميع المشاريع",
	"status_bar.selection.faces": "%0 وجه",
	"status_bar.selection.vertices": "%0 رأس",
	"message.merged_vertices": "تم العثور على %0 رأس ودمجها في %1 موقع",
	"settings.vertex_merge_distance": "مسافة دمج الرؤوس",
	"settings.vertex_merge_distance.desc": "المسافة التي يتم ضمنها دمج الرؤوس باستخدام الدمج حسب المسافة",
	"settings.show_only_selected_uv": "عرض UV المحدد فقط",
	"settings.show_only_selected_uv.desc": "عرض أوجه UV المحددة فقط في محرر UV بشكل افتراضي",
	"action.merge_vertices.merge_all": "دمج الكل",
	"action.merge_vertices.merge_all_in_center": "دمج الكل في المركز",
	"action.merge_vertices.merge_by_distance": "دمج حسب المسافة",
	"action.merge_vertices.merge_by_distance_in_center": "دمج حسب المسافة في المركز",
	"action.uv_rotate_left": "تدوير UV يساراً",
	"action.uv_rotate_left.desc": "تدوير أوجه UV المحددة عكس اتجاه عقارب الساعة",
	"action.uv_rotate_right": "تدوير UV يميناً",
	"action.uv_rotate_right.desc": "تدوير أوجه UV المحددة في اتجاه عقارب الساعة",
	"menu.uv.display_uv": "عرض UV",
	"menu.uv.display_uv.selected_faces": "الوجوه المحددة",
	"menu.uv.display_uv.selected_elements": "جميع الوجوه",
	"menu.uv.display_uv.all_elements": "جميع الوجوه على جميع العناصر",
	"menu.paste.face": "وجه UV",
	"menu.paste.mesh_selection": "تحديد الشبكة",
	"menu.paste.outliner": "عناصر",
	"uv_editor.show_all_faces": "عرض جميع الوجوه",
	"uv_editor.show_selected_faces": "عرض الوجوه المحددة",
	"status_bar.selection.edges": "%0 حافة",
	"action.selection_mode.edge": "حافة",
	"message.cannot_re_import.title": "لا يمكن إعادة استيراد النموذج",
	"message.cannot_re_import.message": "لا يمكن استيراد تنسيق النموذج المصدر إلى Blockbench مرة أخرى. تأكد من حفظ النموذج كملف مشروع.",
	"generic.default": "افتراضي",
	"units.pixels_per_meter": "%0 بكسل لكل متر",
	"mode.pose": "وضعية",
	"modifier_actions.resize_both_sides": "تغيير الحجم في كلا الاتجاهين",
	"modifier_actions.resize_one_side": "تغيير الحجم في اتجاه واحد",
	"modifier_actions.draw_line": "رسم خط",
	"modifier_actions.drag_without_snapping": "سحب بدون محاذاة",
	"modifier_actions.stretch_keyframes": "تمديد الإطارات المفتاحية",
	"modifier_actions.resize_background": "تغيير حجم الخلفية",
	"modifier_actions.select_multiple": "تحديد متعدد",
	"modifier_actions.select_range": "تحديد نطاق",
	"modifier_actions.drag_to_duplicate": "سحب للتكرار",
	"modifier_actions.uniform_scaling": "قياس منتظم",
	"modifier_actions.snap_direction": "اتجاه المحاذاة",
	"message.no_valid_elements": "لم يتم تحديد عناصر صالحة...",
	"dialog.add_primitive.shape.plane": "مستوى",
	"dialog.save_angle.rotation_mode": "نمط الدوران",
	"dialog.save_angle.rotation": "تدوير",
	"dialog.save_angle.fov": "مجال الرؤية",
	"settings.hide_tab_bar": "إخفاء شريط علامات التبويب تلقائياً",
	"settings.hide_tab_bar.desc": "إخفاء شريط علامات التبويب عند فتح علامة تبويب واحدة فقط",
	"settings.status_bar_modifier_keys": "اقتراح مفاتيح معدلة في شريط الحالة",
	"settings.status_bar_modifier_keys.desc": "عرض مفاتيح معدلة مقترحة حسب السياق في شريط الحالة",
	"settings.ground_plane": "المستوى الأرضي",
	"settings.ground_plane.desc": "إظهار مستوى أرضي أسفل النموذج",
	"settings.preview_paste_behavior": "سلوك اللصق الافتراضي في نافذة العرض",
	"settings.preview_paste_behavior.desc": "تحديد السلوك عند لصق شيء ما في نافذة العرض في نمط التحرير وتوفر خيارات متعددة",
	"settings.preview_paste_behavior.always_ask": "اسأل دائماً",
	"action.new_window": "نافذة جديدة",
	"action.new_window.desc": "فتح نافذة Blockbench جديدة",
	"action.export_collada": "تصدير نموذج Collada (dae)",
	"action.export_collada.desc": "تصدير النموذج والحركات كملف dae لاستخدامه في تطبيقات ثلاثية الأبعاد أخرى",
	"action.paint_mode_uv_overlay": "تراكب UV",
	"action.paint_mode_uv_overlay.desc": "عرض خريطة UV كتراكب في نمط الرسم",
	"action.bake_animation_into_model": "خبز وضعية الحركة في النموذج",
	"action.bake_animation_into_model.desc": "خبز إطار الحركة المعروض حالياً في النموذج. يتم تطبيق الدوران والموضع فقط، ويتم تجاهل القياس.",
	"action.keyframe_interpolation.step": "خطوة",
	"action.set_ik_target": "تعيين هدف IK",
	"action.set_ik_target.desc": "تحديد العظمة الهدف التي يجب أن يحركها هذا الكائن الفارغ عبر الحركة العكسية",
	"menu.action_control.type.tab": "علامة تبويب",
	"menu.action_control.type.angle": "زاوية الكاميرا",
	"menu.action_control.recent_in_streamer_mode": "متأكد؟ تم تمكين نمط البث",
	"menu.action_control.recent_in_streamer_mode.desc": "هل أنت متأكد من رغبتك في عرض النماذج الحديثة؟",
	"menu.tools": "أدوات",
	"menu.file.recent.more": "عرض المزيد...",
	"menu.null_object.lock_ik_target_rotation": "قفل دوران هدف IK",
	"menu.animation_file.import_remaining": "استيراد المتبقي من الملف",
	"edit.loop_cut.offset": "الإزاحة",
	"edit.extrude_mesh_selection.extend": "تمديد",
	"cube.color.pink": "وردي",
	"cube.color.silver": "فضي",
	"dialog.plugins.offline": "لا يوجد اتصال بالإنترنت",
	"dialog.create_texture.pixel_density": "كثافة البكسل",
	"dialog.create_texture.pixel_density.desc": "كثافة البكسل للخامة، بالبكسل لكل متر. قد يختلف حجم خريطة الخامة اعتماداً على كمية وحجم العناصر.",
	"panel.skin_pose": "وضعية",
	"panel.skin_pose.none": "لا شيء",
	"panel.skin_pose.natural": "طبيعي",
	"panel.skin_pose.walking": "مشي",
	"panel.skin_pose.crouching": "انحناء",
	"panel.skin_pose.sitting": "جلوس",
	"panel.skin_pose.jumping": "قفز",
	"panel.skin_pose.aiming": "تصويب",
	"edit.loop_cut.direction": "الاتجاه",
	"data.texture_mesh": "شبكة خامة",
	"generic.left": "يسار",
	"generic.right": "يمين",
	"mode.start.quick_setup": "إعداد سريع",
	"mode.start.keymap": "تخطيط المفاتيح",
	"mode.start.quick_setup.more_themes": "المزيد...",
	"dialog.resize_texture.animation_frames": "إطارات الحركة",
	"dialog.export_emission_map.title": "تصدير خريطة الانبعاث",
	"dialog.export_emission_map.format": "التنسيق",
	"dialog.export_emission_map.format.luminance": "اللمعان",
	"dialog.export_emission_map.format.luminance_inverted": "اللمعان المعكوس",
	"dialog.export_emission_map.format.colors": "ألوان",
	"dialog.export_emission_map.threshold": "حد الشفافية",
	"dialog.export_emission_map.round_up": "التقريب إلى %0 x %1",
	"dialog.export_emission_map.flip_y": "قلب المحور Y",
	"dialog.select.type": "نوع العنصر",
	"dialog.create_texture.max_edge_angle": "حد زاوية الحافة",
	"dialog.create_texture.max_edge_angle.desc": "الزاوية القصوى بين وجهين حيث سيظلان مجتمعين",
	"dialog.create_texture.max_island_angle": "حد زاوية الجزيرة",
	"dialog.create_texture.max_island_angle.desc": "الزاوية القصوى التي يمكن دمجها في نفس جزيرة UV",
	"settings.mobile_panel_side": "جانب اللوحة في النسخة المحمولة",
	"settings.mobile_panel_side.desc": "تحديد جانب الشاشة الذي تعرض عليه اللوحات عند استخدام Blockbench في الاتجاه الأفقي",
	"settings.obj_face_export_mode": "نمط تصدير وجوه OBJ",
	"settings.obj_face_export_mode.desc": "اختيار ما إذا كان مصدر OBJ يحول جميع الوجوه إلى مثلثات أو رباعيات",
	"settings.obj_face_export_mode.both": "افتراضي",
	"settings.obj_face_export_mode.tris": "تحويل إلى مثلثات",
	"settings.obj_face_export_mode.quads": "تحويل إلى رباعيات",
	"action.seam_tool": "أداة التماس",
	"action.seam_tool.desc": "أداة لتحديد طبقات UV على حواف الشبكة",
	"action.resolve_group": "حل المجموعة",
	"action.resolve_group.desc": "حل المجموعة مع الاحتفاظ بأبنائها في نفس المكان",
	"action.move_to_group": "نقل إلى",
	"action.move_to_group.desc": "نقل العناصر المحددة إلى مجموعة أو عنصر مختلف في المخطط التفصيلي",
	"action.select_seam": "تحديد التماس UV",
	"action.select_seam.desc": "تحديد نمط التماس UV للحواف المحددة",
	"action.select_seam.auto": "تلقائي",
	"action.select_seam.join": "ضم",
	"action.select_seam.divide": "تقسيم",
	"action.adjust_brightness_contrast": "ضبط السطوع والتباين...",
	"action.adjust_brightness_contrast.desc": "ضبط سطوع وتباين الخامة المحددة",
	"action.adjust_saturation_hue": "ضبط التشبع ودرجة اللون...",
	"action.adjust_saturation_hue.desc": "ضبط تشبع ودرجة لون الخامة المحددة",
	"action.invert_colors": "عكس الألوان",
	"action.invert_colors.desc": "عكس جميع ألوان الخامة المحددة",
	"action.adjust_curves": "ضبط المنحنيات...",
	"action.adjust_curves.desc": "ضبط منحنيات السطوع للخامة المحددة",
	"action.flip_texture_x": "قلب أفقياً",
	"action.flip_texture_y": "قلب عمودياً",
	"action.resize_texture": "تغيير حجم الخامة...",
	"action.view_mode.uv": "معاينة UV",
	"action.append_to_template": "إلحاق العناصر بالقالب...",
	"action.append_to_template.desc": "إضافة العناصر المحددة حالياً إلى قالب الخامة",
	"action.move_texture_with_uv": "تحريك الخامة مع UV",
	"action.move_texture_with_uv.desc": "تحريك خامة الوجه عند سحب أوجه UV",
	"action.timeline_setups": "إعدادات الجدول الزمني",
	"action.save_timeline_setup": "حفظ إعداد الجدول الزمني...",
	"action.save_timeline_setup.desc": "حفظ إعداد مسبق للمحركات والقنوات المحددة حالياً",
	"menu.texture": "خامة",
	"menu.texture.render_mode.default": "افتراضي",
	"menu.texture.merge_onto_texture": "دمج على الخامة أعلاه",
	"menu.animation.unload": "إلغاء التحميل",
	"panel.timeline": "الجدول الزمني",
	"action.pan_tool": "أداة التحريك",
	"action.pan_tool.desc": "أداة للتنقل في نافذة العرض ومحرر الخامة",
	"mode.start.recent.favorite": "وضع علامة كمفضلة",
	"mode.start.info": "معلومات",
	"mode.start.target": "الهدف",
	"mode.start.start": "بدء",
	"mode.start.create_new": "إنشاء نموذج جديد",
	"mode.start.format.informations": "من الجيد معرفة:",
	"mode.start.format.resources": "الموارد:",
	"format.free.info.meshes": "في هذا التنسيق، يمكنك إنشاء نماذج منخفضة المضلعات باستخدام المكعبات والشبكات المخصصة.",
	"format.free.info.limitation": "لا يمكن تحميل النماذج في الألعاب التي تحتاج إلى تنسيقات متخصصة، مثل ماين كرافت.",
	"format.skin.info.skin": "تم تصميم هذا التنسيق لإنشاء شخصيات ماين كرافت وخامات الكائنات.",
	"format.skin.info.model": "لا يمكن تغيير النموذج. لإجراء تغييرات على النموذج، قم أولاً بالتحويل إلى تنسيق مختلف عبر **ملف** > **تحويل المشروع**.",
	"format.java_block.info.rotation": "يقتصر الدوران على محور واحد لكل عنصر",
	"format.java_block.info.size": "يقتصر النموذج على حجم 3 في 3 في 3 مكعبات. يمكن لإعدادات العرض جعل نماذج العناصر أكبر رغم ذلك",
	"format.java_block.info.animation": "لا يدعم هذا التنسيق الحركات في ماين كرافت العادية. إذا كنت تقوم بإنشاء مود، يمكنك استخدام GeckoLib لتحريك النماذج. إذا لم يكن الأمر كذلك، فإن الطريقة الوحيدة للتحريك هي تبديل النموذج باستخدام الأوامر أو الخامات المتحركة.",
	"format.bedrock.info.textures": "يمكن أن يحتوي كل نموذج على خامة واحدة فقط",
	"format.bedrock_block": "كتلة Bedrock",
	"format.bedrock_block.desc": "نموذج كتلة لـ Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "يقتصر حجم المكعبات الفردية على الأعداد الصحيحة.",
	"format.modded_entity.info.format": "تتم كتابة النماذج في كود Java بدلاً من هياكل البيانات المخصصة مثل جميع تنسيقات تصدير Blockbench الأخرى.",
	"format.optifine_entity.info.optifine_required": "لن يرى المستخدمون الذين ليس لديهم OptiFine مثبتاً النموذج.",
	"format.optifine_entity.info.pivots": "نقاط ارتكاز العظام مقفلة، لذا من الجيد تركها دون تغيير.",
	"format_category.low_poly": "منخفض المضلعات",
	"format_category.minecraft": "ماين كرافت",
	"format_category.other": "أخرى",
	"format_category.loaders": "محملات",
	"message.recover_backup.recover": "استعادة",
	"message.invalid_characters.title": "مسار غير صالح",
	"message.invalid_characters.message": "يحتوي مسار الملف المستورد على أحرف غير صالحة أو أحرف كبيرة أو مسافات بيضاء. الأحرف المدعومة هي: %0",
	"dialog.share_model.thumbnail": "صورة مصغرة",
	"dialog.skin.high_res_texture": "يرجى ملاحظة أن الشخصيات ذات الدقة المحددة لن تعمل كشخصيات ماين كرافت عادية. حدد دقة أقل.",
	"settings.allow_display_slot_mirror": "السماح بعكس فتحة العرض",
	"settings.allow_display_slot_mirror.desc": "السماح بعكس فتحات العرض لنماذج عناصر Java. تحذير: هذا يعمل فقط في ماين كرافت 1.14 أو إصدارات أقدم أو في حالات خاصة.",
	"action.switch_tabs": "تبديل علامات التبويب",
	"action.switch_tabs.desc": "التنقل بين علامات التبويب المفتوحة. اضغط مع الاستمرار على Shift للتنقل في الاتجاه المعاكس.",
	"action.unselect_all": "إلغاء تحديد الكل",
	"action.save_palette": "حفظ اللوحة...",
	"action.save_palette.desc": "حفظ لوحة الألوان الحالية داخل Blockbench للاستخدام لاحقاً",
	"action.keyframe_column_create": "إنشاء عمود إطارات مفتاحية",
	"action.keyframe_column_create.desc": "إضافة إطارات مفتاحية لجميع القنوات في الجدول الزمني عند الكود الزمني الحالي، إذا كانت تحتوي بالفعل على إطارات مفتاحية",
	"action.keyframe_column_select": "تحديد عمود الإطارات المفتاحية",
	"action.keyframe_column_select.desc": "تحديد جميع الإطارات المفتاحية في الجدول الزمني على طول عمود أسفل رأس التشغيل",
	"menu.uv": "UV",
	"menu.keyframe": "إطار مفتاحي",
	"menu.palette.load.update": "تحديث اللوحة",
	"menu.palette.load.update.desc": "تحديث هذه اللوحة بألوان لوحة Blockbench الحالية",
	"menu.timeline_marker.set_time": "تعيين الوقت...",
	"uv_editor.scale_uv": "قياس UV",
	"action.preview_scene": "مشهد المعاينة",
	"action.preview_scene.desc": "تغيير مشهد معاينة النموذج",
	"preview_scene.minecraft_overworld": "العالم العلوي",
	"preview_scene.minecraft_nether": "النتير",
	"preview_scene.minecraft_end": "الاند",
	"dialog.project.modded_entity_flip_y": "قلب المحور Y",
	"preview_scene.studio": "استوديو",
	"format.image": "صورة",
	"modifier_actions.set_copy_source": "تعيين مصدر النسخ",
	"message.load_images.title": "تحميل الصور",
	"message.load_images.edit_image": "تحرير الصورة",
	"dialog.add_primitive.align_edges": "محاذاة الحواف",
	"dialog.flip_animation.show_in_timeline": "إظهار العظام المعدلة في الجدول الزمني",
	"settings.default_cube_size": "حجم المكعب",
	"settings.default_cube_size.desc": "تعيين حجم المكعب الافتراضي عند إنشاء مكعب جديد",
	"settings.uniform_keyframe": "إطارات مفتاحية للقياس المنتظم",
	"settings.uniform_keyframe.desc": "تعيين إطارات مفتاحية للقياس إلى قياس منتظم بشكل افتراضي",
	"settings.nearest_rectangle_select": "تحديد المستطيل: أقرب حافة",
	"settings.nearest_rectangle_select.desc": "محاذاة تحديدات المستطيل إلى أقرب حافة بكسل، كما في GIMP، بدلاً من البكسلات بأكملها.",
	"settings.pick_color_opacity": "اختيار شفافية اللون",
	"settings.pick_color_opacity.desc": "اختيار شفافية اللون مع قطاف الألوان وتعيينها كشفافية الفرشاة",
	"settings.paint_with_stylus_only": "الرسم بالقلم فقط",
	"settings.paint_with_stylus_only.desc": "استخدام القلم فقط للرسم، مع تخصيص إدخال الماوس أو اللمس للتنقل.",
	"action.copy_brush_mode": "نمط نسخ الفرشاة",
	"action.copy_brush_mode.copy": "نسخ",
	"action.copy_brush_mode.pattern": "نمط",
	"action.copy_brush_mode.sample": "عينة",
	"action.brush_shape": "شكل الفرشاة",
	"action.brush_shape.square": "مربع",
	"action.brush_shape.circle": "دائرة",
	"action.blend_mode": "نمط المزج",
	"action.blend_mode.default": "افتراضي",
	"action.blend_mode.set_opacity": "تعيين الشفافية",
	"action.blend_mode.color": "لون",
	"action.blend_mode.behind": "خلف",
	"action.blend_mode.multiply": "ضرب",
	"action.blend_mode.divide": "قسمة",
	"action.blend_mode.add": "إضافة",
	"action.blend_mode.subtract": "طرح",
	"action.blend_mode.screen": "شاشة",
	"action.blend_mode.overlay": "تراكب",
	"action.blend_mode.hard_light": "ضوء قاسي",
	"action.blend_mode.difference": "فرق",
	"action.copy_brush": "فرشاة النسخ",
	"action.copy_brush.desc": "فرشاة لاستنساخ أجزاء من الخامة أو رسم أنماط. اضغط مع الاستمرار على Ctrl وانقر لتحديد مصدر نسخ.",
	"action.validator_window": "عرض مشكلات النموذج...",
	"action.validator_window.desc": "فتح المدقق، الذي يسرد المشكلات في النموذج الحالي.",
	"action.cancel_gif": "إلغاء GIF",
	"menu.text_edit.copy_vector": "نسخ المتجه",
	"menu.brush_presets.dialog": "إعدادات الفرشاة المسبقة...",
	"menu.brush_presets.pixel_brush": "فرشاة بكسل",
	"menu.brush_presets.smooth_brush": "فرشاة ناعمة",
	"menu.texture.edit_in_blockbench": "تحرير في Blockbench",
	"menu.mirror_painting.axis": "المحور",
	"menu.mirror_painting.axis.desc": "تحديد المحور الذي سيتم عكس ضربات الفرشاة عليه",
	"menu.mirror_painting.global": "تماثل عام",
	"menu.mirror_painting.global.desc": "تمكين عكس الرسم على النموذج في الفضاء العام",
	"menu.mirror_painting.local": "تماثل محلي",
	"menu.mirror_painting.local.desc": "تمكين عكس الرسم في الفضاء المحلي لكل عنصر",
	"menu.mirror_painting.texture_frames": "تكرار على إطارات الدفتر",
	"menu.mirror_painting.texture_frames.desc": "عكس ضربات الفرشاة إلى كل إطار من الخامات المتحركة",
	"format.bedrock_block.info.size_limit": "يقتصر الحجم الإجمالي للكتلة على 30 بكسل في جميع الأبعاد. يمكن أن ينحرف الحد عن مركز الكتلة بمقدار 7 بكسل في جميع الاتجاهات.",
	"format.bedrock_block.info.textures": "يمكن تطبيق خامات متعددة على مكعبات مختلفة في Blockbench، ولكنها تتطلب إعداداً إضافياً في حزمة السلوك للعمل بشكل صحيح في اللعبة.",
	"format.image.desc": "تحرير الصور في محرر الصور ثنائي الأبعاد",
	"generic.delete_all": "حذف الكل",
	"message.child_model_only.open": "فتح الأب",
	"message.child_model_only.open_with_textures": "فتح الأب وتبني الخامات",
	"dialog.project.credit": "إسناد",
	"dialog.convert_project.create_copy": "إنشاء نسخة",
	"dialog.texture.frame_time": "وقت الإطار",
	"dialog.texture.frame_time.desc": "تعيين المدة التي سيكون فيها كل إطار مرئياً، بالعلامات. كل علامة تساوي 1/20 من الثانية.",
	"dialog.texture.frame_interpolate": "استيفاء",
	"dialog.texture.frame_interpolate.desc": "استيفاء بين إطارات الحركة عن طريق التلاشي المتقاطع إلى الإطار التالي",
	"dialog.texture.frame_order_type": "نمط التكرار",
	"dialog.texture.frame_order_type.loop": "تكرار",
	"dialog.texture.frame_order_type.backwards": "تكرار عكسي",
	"dialog.texture.frame_order_type.back_and_forth": "ذهاب وإياب",
	"dialog.texture.frame_order_type.custom": "ترتيب مخصص",
	"dialog.texture.frame_order": "ترتيب الإطارات",
	"dialog.texture.frame_order.desc": "تعيين ترتيب إطارات مخصص عن طريق سرد فهارس الإطارات بترتيب جديد. تبدأ فهارس الإطارات من 0 مع الإطار الأول.",
	"dialog.select.mode": "النمط",
	"dialog.select.mode.new": "تحديد جديد",
	"dialog.select.mode.add": "إضافة إلى المحدد",
	"dialog.select.mode.remove": "إزالة من المحدد",
	"dialog.select.mode.in_selection": "تحديد فقط من المحدد",
	"dialog.predicate_overrides.model": "نموذج",
	"dialog.predicate_overrides.predicates": "المسندات",
	"dialog.predicate_overrides.variants": "النسخ",
	"dialog.predicate_overrides.start_value": "البداية",
	"dialog.predicate_overrides.add_override": "إضافة تجاوز",
	"dialog.predicate_overrides.add_predicate": "إضافة مسند",
	"dialog.predicate_overrides.generate_overrides": "إنشاء تجاوزات",
	"dialog.predicate_overrides.confirm_delete": "هل أنت متأكد من رغبتك في حذف جميع التجاوزات؟",
	"dialog.predicate_overrides.predicate.angle": "زاوية البوصلة",
	"dialog.predicate_overrides.predicate.blocking": "هل يحجب",
	"dialog.predicate_overrides.predicate.broken": "هل مكسور",
	"dialog.predicate_overrides.predicate.cast": "هل مصبوب",
	"dialog.predicate_overrides.predicate.cooldown": "وقت التهدئة",
	"dialog.predicate_overrides.predicate.damage": "الضرر",
	"dialog.predicate_overrides.predicate.damaged": "هل تالف",
	"dialog.predicate_overrides.predicate.lefthanded": "هل أعسر",
	"dialog.predicate_overrides.predicate.pull": "مقدار السحب",
	"dialog.predicate_overrides.predicate.pulling": "هل يسحب",
	"dialog.predicate_overrides.predicate.charged": "هل مشحون",
	"dialog.predicate_overrides.predicate.firework": "هل لديه ألعاب نارية",
	"dialog.predicate_overrides.predicate.throwing": "جاهز للرمي",
	"dialog.predicate_overrides.predicate.time": "وقت اليوم",
	"dialog.predicate_overrides.predicate.custom_model_data": "بيانات النموذج المخصص",
	"dialog.predicate_overrides.predicate.level": "مستوى الضوء",
	"dialog.predicate_overrides.predicate.filled": "مستوى ملء الحزمة",
	"dialog.predicate_overrides.predicate.tooting": "هل ينفخ",
	"settings.model_export_scale": "مقياس تصدير النموذج",
	"settings.model_export_scale.desc": "العامل الذي يتم من خلاله تقليل مقياس نماذج glTF و DAE و FBX المصدرة. القيمة الافتراضية هي 16، والتي تحول 16 وحدة Blockbench إلى متر واحد في التصدير.",
	"action.export_fbx": "تصدير نموذج FBX",
	"action.export_fbx.desc": "تصدير النموذج والحركات كملف fbx لاستخدامه في تطبيقات ثلاثية الأبعاد ومحركات ألعاب أخرى",
	"action.center_lateral": "توسيط جانبي",
	"action.center_lateral.desc": "توسيط العناصر المحددة على المحورين X و Z",
	"action.adjust_opacity": "ضبط الشفافية...",
	"action.adjust_opacity.desc": "ضبط شفافية الخامة المحددة",
	"action.rotate_texture_cw": "تدوير في اتجاه عقارب الساعة",
	"action.rotate_texture_ccw": "تدوير عكس اتجاه عقارب الساعة",
	"action.predicate_overrides": "تحرير تجاوزات المسندات...",
	"action.predicate_overrides.desc": "تحديد نماذج لتجاوز هذا النموذج بناءً على شروط محددة",
	"action.auto_set_cullfaces": "تعيين أوجه الإخفاء تلقائياً",
	"action.auto_set_cullfaces.desc": "إنشاء أوجه إخفاء تلقائياً لإخفاء الوجوه عندما تكون مغطاة بالكتلة المجاورة.",
	"menu.texture.edit_externally": "تحرير خارجياً",
	"menu.mirror_painting.texture": "تماثل المحرر ثنائي الأبعاد",
	"menu.mirror_painting.texture.desc": "تمكين عكس الرسم في الفضاء ثنائي الأبعاد على الصورة أو الخامة",
	"menu.animator.rotation_global": "تدوير في الفضاء العام",
	"uv_editor.face_properties": "خصائص الوجه",
	"uv_editor.face_properties.material_instance": "نسخة المادة",
	"uv_editor.tint.info": "يمكن تمكين التلوين على وجه لإخبار ماين كرافت بتلوينه. في النسخة العادية، لا يمكن استخدام التلوين إلا بواسطة كتل محددة مثل الأوراق وغبار الحجر الأحمر، ويمكن أن يكون له قيمة 0 فقط.",
	"uv_editor.cullface.info": "يخبر تمكين إخفاء الوجه الوجه الموجود على كتلة بعدم العرض إذا تم وضع كتلة كاملة أخرى بجانبه في الاتجاه المحدد في عالم ماين كرافت الخاص بك. يمكن استخدام هذا لتحسين الأداء.",
	"uv_editor.material_instance.info": "يمكن تعيين نسخ المواد إلى اسم معرف من قبل المستخدم. يمكن استخدام هذا الاسم في ملف JSON الخاص بالكتلة في حزمة السلوك لتعيين خامة ومادة معينة للوجه.",
	"display.reference.frame_invisible": "إطار العنصر (غير مرئي)",
	"data.settings_profile": "الملف الشخصي",
	"message.display_skin.invalid_name": "تعذر العثور على حساب ماين كرافت بالاسم \"%0\".",
	"dialog.load_plugins_from_query.title": "تحميل الإضافات",
	"dialog.load_plugins_from_query.text": "لقد استخدمت رابطاً يتطلب تثبيت إضافات. هل ترغب في تثبيتها؟",
	"dialog.select_model.title": "تحديد نموذج",
	"dialog.select_model.bones": "عظام",
	"dialog.select_model.cubes": "مكعبات",
	"dialog.settings.create_profile": "إنشاء ملف شخصي...",
	"settings_profile.confirm_delete": "هل أنت متأكد من رغبتك في حذف ملف الإعدادات الشخصي هذا؟",
	"settings_profile.condition.type.selectable": "قابل للتحديد يدوياً",
	"settings.interface_mode": "نمط الواجهة",
	"settings.interface_mode.desc": "نمط الواجهة",
	"settings.interface_mode.auto": "تلقائي",
	"settings.interface_mode.desktop": "سطح المكتب",
	"settings.interface_mode.mobile": "جوال",
	"settings.paint_through_transparency": "الرسم عبر الشفافية",
	"settings.paint_through_transparency.desc": "الرسم عبر البكسلات الشفافة عند تمكين قفل قناة ألفا",
	"action.tab_overview": "نظرة عامة على علامات التبويب",
	"action.tab_overview.desc": "عرض جميع علامات التبويب المفتوحة في شبكة والانتقال إلى واحدة منها",
	"action.slider_color_red": "أحمر اللون",
	"action.slider_color_green": "أخضر اللون",
	"action.slider_color_blue": "أزرق اللون",
	"action.add_animation_controller": "إضافة وحدة تحكم حركة",
	"action.add_animation_controller.desc": "إنشاء وحدة تحكم حركة فارغة",
	"action.animation_controller_preview_mode": "معاينة وحدة التحكم",
	"action.animation_controller_preview_mode.paused": "متوقف مؤقتاً",
	"action.animation_controller_preview_mode.manual": "معاينة يدوية",
	"action.animation_controller_preview_mode.play": "تشغيل تلقائي",
	"action.keyframe_interpolation.bezier": "بيزيه",
	"action.keyframe_bezier_linked": "ربط مقابض بيزيه",
	"action.keyframe_bezier_linked.desc": "توصيل مقبض بيزيه الأيمن والأيسر للإطار المفتاحي",
	"action.reset_keyframe_handles": "إعادة ضبط مقابض الإطارات المفتاحية",
	"action.reset_keyframe_handles.desc": "إعادة ضبط مقابض بيزيه للإطارات المفتاحية المحددة",
	"action.looped_animation_playback": "تشغيل مكرر",
	"action.looped_animation_playback.desc": "معاينة الحركات في حلقة لا نهائية",
	"timeline.bind_to_actor": "ربط بالممثل",
	"animation_controllers.select_preset": "تحديد إعداد مسبق لوحدة التحكم...",
	"animation_controllers.state.animations": "حركات",
	"animation_controllers.state.particles": "جسيمات",
	"animation_controllers.state.sounds": "أصوات",
	"animation_controllers.state.on_entry": "عند الدخول",
	"animation_controllers.state.on_exit": "عند الخروج",
	"animation_controllers.state.transitions": "انتقالات",
	"animation_controllers.state.condition": "الشرط",
	"animation_controllers.state.blend_transition": "وقت المزج",
	"animation_controllers.state.shortest_path": "مزج بأقصر مسار",
	"animation_controllers.state.edit_transition": "تحرير الانتقال",
	"menu.color_picker.picker_type": "نوع المنتقي",
	"menu.color_picker.picker_type.square": "مربع",
	"menu.color_picker.picker_type.wheel": "عجلة",
	"menu.color_picker.slider_mode": "نمط شريط التمرير",
	"menu.color_picker.slider_mode.hsv": "درجة اللون، التشبع، القيمة",
	"menu.color_picker.slider_mode.rgb": "أحمر، أخضر، أزرق",
	"menu.texture.render_mode.additive": "إضافي",
	"panel.color.picker_options": "خيارات منتقي الألوان",
	"panel.animation_controllers": "وحدة تحكم الحركة",
	"display.preset.armor_stand": "أرض (حامل الدروع)",
	"data.file_path": "مسار الملف",
	"dialog.extrude.orientation": "الاتجاه",
	"dialog.extrude.orientation.upright": "عمودي X",
	"dialog.extrude.orientation.flat": "مسطح",
	"dialog.scale.box_uv_warning": "قد يؤدي تغيير حجم المكعبات التي تستخدم UV الصندوقي إلى كسر تخطيط UV. بدلاً من ذلك، حاول تغيير حجم النموذج أثناء التنفيذ، أو قم بالتبديل إلى نمط UV لكل وجه في ملف > مشروع أو لكل مكعب.",
	"dialog.create_gif.format": "التنسيق",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "سلسلة PNG",
	"dialog.create_gif.pixelate": "بكسل",
	"dialog.create_gif.bg_image": "صورة الخلفية",
	"dialog.create_gif.turn.desc": "تدوير النموذج أثناء التسجيل. استخدم قيماً سالبة لتدوير النموذج في اتجاه عقارب الساعة. القيمة 60 تقابل دورة واحدة كل ثانية.",
	"settings_profile.condition": "الشرط",
	"settings_profile.condition.type.file_path.desc": "استخدم صيغة التعبير النمطي لمطابقة مسار ملف المشروع الحالي. استخدم الخطوط المائلة للأمام للدلائل",
	"settings.only_selected_bezier_handles": "عرض مقابض بيزيه المحددة فقط",
	"settings.only_selected_bezier_handles.desc": "إخفاء مقابض الإطارات المفتاحية بيزيه غير المحددة حالياً",
	"settings.embed_textures": "تضمين الخامات",
	"settings.embed_textures.desc": "تضمين محتوى ملف الخامة في ملفات .bbmodel",
	"action.selection_mode.cluster": "مجموعة",
	"dialog.copied_to_clipboard": "تم النسخ إلى الحافظة",
	"data.reference_image": "صورة مرجعية",
	"message.delete_reference_image": "هل أنت متأكد من رغبتك في حذف هذه الصورة المرجعية؟ لا يمكن التراجع عن هذا.",
	"message.add_reference_image.message": "حدد من أين تحميل الصورة المرجعية",
	"message.import_particle_texture.import": "استيراد خامة الجسيمات",
	"message.import_particle_texture.message": "هل ترغب في استيراد ملف خامة لاستخدامه لجسيماتك؟",
	"message.save_codec_selector.title": "حفظ تنسيق النموذج",
	"message.save_codec_selector.message": "حدد تنسيقاً لحفظ النموذج فيه.",
	"message.save_codec_selector.project_file": "مشروع Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "كلاهما",
	"message.display_skin.username": "اسم المستخدم (Java)",
	"message.palette_locked": "اللوحة مقفلة",
	"dialog.project.default_uv_mode": "نمط UV الافتراضي",
	"dialog.project.default_uv_mode.description": "نمط UV الافتراضي للمشروع. يمكن أيضاً تغيير نمط UV لكل مكعب.",
	"dialog.export_options.title": "خيارات التصدير",
	"dialog.edit_texture.preview": "معاينة",
	"dialog.proportional_editing.range": "النطاق",
	"dialog.proportional_editing.falloff": "التلاشي",
	"dialog.proportional_editing.falloff.linear": "خطي",
	"dialog.proportional_editing.falloff.hermite_spline": "ناعم",
	"dialog.proportional_editing.falloff.constant": "ثابت",
	"dialog.proportional_editing.selection": "التحديد",
	"dialog.proportional_editing.selection.linear": "المسافة الخطية",
	"dialog.proportional_editing.selection.connections": "الاتصالات",
	"dialog.mirror_painting_texture_center.middle": "الوسط",
	"dialog.mirror_painting_texture_center.custom": "مخصص",
	"dialog.settings.reset_to_default": "إعادة الضبط إلى الافتراضي",
	"keybindings.item.num_slider.increase": "زيادة",
	"keybindings.item.num_slider.decrease": "تقليل",
	"settings.always_show_splash_art": "عرض شاشة البداية دائماً",
	"settings.always_show_splash_art.desc": "عرض شاشة البداية دائماً على شاشة البدء",
	"action.slider_palette_color": "تبديل لون اللوحة",
	"action.slider_palette_color.desc": "التنقل بين الألوان في اللوحة",
	"action.proportional_editing": "التحرير النسبي",
	"action.proportional_editing.desc": "التأثير نسبياً على الرؤوس المحيطة عند تحرير أجزاء من الشبكة",
	"action.limit_to_palette": "تقييد باللوحة",
	"action.limit_to_palette.desc": "تقييد ألوان الخامة بتلك الموجودة في اللوحة المحملة حالياً",
	"action.edit_reference_images": "تحرير الصور المرجعية",
	"action.edit_reference_images.desc": "تشغيل نمط الصورة المرجعية لإضافة أو تحرير الصور المرجعية والمخططات",
	"action.add_reference_image": "إضافة صورة مرجعية",
	"action.reference_image_from_clipboard": "لصق صورة مرجعية",
	"action.reference_image_list": "الصور المرجعية",
	"action.connect_uv_faces": "توصيل أوجه UV",
	"action.connect_uv_faces.desc": "توصيل أوجه UV المحددة بآخر وجه UV محدد",
	"action.merge_uv_vertices": "دمج رؤوس UV",
	"action.merge_uv_vertices.desc": "محاذاة رؤوس UV المحددة الأولى إلى آخر رؤوس UV محددة",
	"action.bedrock_animation_mode": "نمط حركة Bedrock",
	"action.bedrock_animation_mode.desc": "تحديد نمط تحرير الحركات لـ Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "كيان",
	"action.bedrock_animation_mode.attachable_first": "عنصر شخص أول",
	"action.bedrock_animation_mode.attachable_third": "عنصر شخص ثالث",
	"timeline.amplify": "تضخيم",
	"menu.options": "خيارات...",
	"menu.palette.lock_palette": "قفل اللوحة",
	"menu.uv.export": "تصدير تخطيط UV",
	"menu.uv.flip_x": "مرآة X",
	"menu.uv.flip_y": "مرآة Y",
	"menu.mirror_painting.enabled": "مفعل",
	"reference_image.position": "الموضع",
	"reference_image.size": "الحجم",
	"reference_image.rotation": "الدوران",
	"reference_image.opacity": "الشفافية",
	"reference_image.visibility": "الرؤية",
	"reference_image.clear_mode": "نمط المسح",
	"reference_image.layer": "الطبقة",
	"reference_image.layer.background": "خلف النموذج",
	"reference_image.layer.viewport": "فوق النموذج",
	"reference_image.layer.float": "فوق الواجهة",
	"reference_image.scope": "النطاق",
	"reference_image.scope.project": "فقط هذا المشروع",
	"reference_image.scope.global": "جميع المشاريع",
	"reference_image.enabled_modes": "مفعل في الأوضاع",
	"codec.common.encoding": "الترميز",
	"codec.common.armature": "تصدير المجموعات كهيكل عظمي",
	"codec.common.export_animations": "تصدير الحركات",
	"codec.common.embed_textures": "تضمين الخامات",
	"preview.center_camera": "توسيط الكاميرا",
	"display.reference.frame_top": "إطار العنصر علوي",
	"display.reference.frame_top_invisible": "إطار العنصر علوي (غير مرئي)",
	"action.proportional_editing_range": "نطاق التحرير النسبي",
	"action.proportional_editing_range.desc": "ضبط نطاق التحرير النسبي",
	"action.toggle_all_reference_images": "إخفاء/إظهار جميع الصور المرجعية",
	"action.toggle_all_reference_images.desc": "تبديل رؤية جميع الصور المرجعية دفعة واحدة",
	"action.add_animation_controller_state": "إضافة حالة وحدة تحكم الحركة",
	"action.add_animation_controller_state.desc": "إضافة حالة جديدة إلى وحدة تحكم الحركة",
	"menu.slider.round_value": "تقريب القيمة",
	"texture.error.too_large": "الدقة تتجاوز الحد الأقصى %0",
	"dialog.copy_to_clipboard": "نسخ إلى الحافظة",
	"dialog.open_url": "فتح الرابط",
	"reference_image.image": "الصورة",
	"uv_editor.rotate_uv": "تدوير UV",
	"generic.error": "خطأ",
	"projects.start_screen": "شاشة البدء",
	"message.invalid_link.message": "النموذج المشترك \"%0\" الذي تحاول تحميله إما غير صالح أو انتهت صلاحيته.",
	"message.plugin_dependencies.title": "تبعيات الإضافة",
	"message.plugin_dependencies.message1": "تتطلب الإضافة هذه التبعيات:",
	"message.plugin_dependencies.message1_update": "تم تحديث الإضافة %0 وتتطلب الآن هذه التبعيات:",
	"message.plugin_dependencies.message2": "هل تريد تثبيتها للمتابعة؟",
	"message.plugin_dependencies.invalid": "للأسف لا يمكن تثبيت الإضافة، فهي تحتوي على تبعية غير صالحة:",
	"message.preview_scene_load_failed": "فشل تحميل مشهد المعاينة. تحقق من اتصالك بالإنترنت.",
	"dialog.convert_project.text1": "تحويل المشروع إلى تنسيق مختلف.",
	"dialog.convert_project.text2": "استخدم التحويل على مسؤوليتك الخاصة. التنسيقات لها ميزات وقيود مختلفة، لذا سيؤدي التحويل في بعض الحالات إلى كسر أجزاء من مشروعك.",
	"dialog.convert_project.text3": "لا يمكنك التراجع عن التحويل، ولهذا سيتم إنشاء نسخة بشكل افتراضي.",
	"dialog.unsaved_work.title": "عمل غير محفوظ",
	"dialog.unsaved_work.text": "تحتوي المشاريع التالية على تغييرات غير محفوظة. هل تريد حفظ تغييراتك؟",
	"dialog.unsaved_work.discard_all": "تجاهل الكل",
	"dialog.unsaved_work.save_all": "حفظ الكل",
	"dialog.resize_texture.mode": "النمط",
	"dialog.resize_texture.mode.crop": "قص/توسيع",
	"dialog.resize_texture.mode.scale": "قياس",
	"dialog.plugins.is_installed": "مثبت",
	"dialog.plugins.is_disabled": "معطل",
	"dialog.plugins.disable": "تعطيل",
	"dialog.plugins.enable": "تمكين",
	"dialog.plugins.dependencies": "يعتمد على:",
	"dialog.view_backups.open_folder": "فتح المجلد",
	"dialog.share_model.reference_images": "تضمين الصور المرجعية",
	"dialog.share_model.too_large": "فشل الرفع: النموذج كبير جداً",
	"dialog.share_model.too_large_references": "فشل الرفع: النموذج كبير جداً. حاول بدون الصور المرجعية.",
	"settings.stretch_linked": "ربط التمدد",
	"settings.stretch_linked.desc": "تمديد المكعب في جميع الاتجاهات بنفس القيمة",
	"settings.grids": "إظهار الشبكات",
	"settings.grids.desc": "إظهار أو إخفاء جميع الشبكات ثلاثية الأبعاد",
	"settings.double_click_switch_tools": "تبديل الأدوات عند النقر المزدوج",
	"settings.double_click_switch_tools.desc": "انقر نقراً مزدوجاً على نافذة العرض للتبديل بين الأدوات",
	"settings.outlines_in_paint_mode": "حدود التحديد في نمط الرسم",
	"settings.outlines_in_paint_mode.desc": "عرض حدود تحديد العناصر أثناء وجودك في نمط الرسم",
	"settings.json_indentation": "مسافة بادئة JSON",
	"settings.json_indentation.desc": "نمط المسافة البادئة لملفات JSON المصدرة",
	"settings.json_indentation.tabs": "علامات تبويب",
	"settings.json_indentation.spaces_4": "مسافات: 4",
	"settings.json_indentation.spaces_2": "مسافات: 2",
	"action.slider_stretch": "تمدد",
	"action.slider_stretch.desc": "تمديد المكعبات بشكل مضاعف على المحور %0 دون تغيير UV",
	"action.view_backups": "عرض النسخ الاحتياطية",
	"action.view_backups.desc": "استعراض قائمة النسخ الاحتياطية المحفوظة تلقائياً للمشروع",
	"action.search_outliner": "بحث في المخطط التفصيلي",
	"action.search_outliner.desc": "البحث عن أسماء عناصر محددة في المخطط التفصيلي",
	"action.mirror_modeling": "النمذجة بالمرآة",
	"action.mirror_modeling.desc": "تمكين النمذجة بالمرآة على المحور X. ستنعكس جميع التغييرات التي تجريها في نافذة العرض إلى الجانب الآخر، ما لم يتم تعطيلها بشكل خاص على العنصر.",
	"action.allow_element_mirror_modeling": "السماح بالنمذجة بالمرآة",
	"action.allow_element_mirror_modeling.desc": "اختيار ما إذا كانت العناصر المحددة يمكن أن تتأثر بالنمذجة بالمرآة",
	"action.switch_face_crease": "تبديل ثني الوجه",
	"action.switch_face_crease.desc": "تبديل الاتجاه الذي تطوى فيه الرباعية في المنتصف",
	"action.clear_unused_texture_space": "مسح مساحة الخامة غير المستخدمة",
	"action.clear_unused_texture_space.desc": "مسح أجزاء الخامة غير المرسومة على أي عناصر",
	"action.split_screen": "تقسيم الشاشة",
	"action.split_screen.desc": "تحديد نمط تقسيم الشاشة في نافذة العرض",
	"action.split_screen.single": "مفردة",
	"action.split_screen.double_horizontal": "مزدوجة أفقياً",
	"action.split_screen.double_vertical": "مزدوجة عمودياً",
	"action.split_screen.quad": "رباعية",
	"action.split_screen.triple_left": "ثلاثية يسار",
	"action.split_screen.triple_right": "ثلاثية يمين",
	"action.split_screen.triple_top": "ثلاثية أعلى",
	"action.split_screen.triple_bottom": "ثلاثية أسفل",
	"action.uv_project_from_view": "إسقاط UV من العرض",
	"action.uv_project_from_view.desc": "إنشاء UV تلقائياً للوجوه المحددة من منظور العرض ثلاثي الأبعاد",
	"action.graph_editor_other_graphs": "عرض الرسوم البيانية الأخرى",
	"action.graph_editor_other_graphs.desc": "ما إذا كانت رسوم المحاور غير المحددة معروضة",
	"action.graph_editor_include_other_graphs": "تضمين الرسوم البيانية الأخرى",
	"action.graph_editor_include_other_graphs.desc": "ما إذا كان محرر الرسم البياني يتضمن الرسوم غير المحددة في العرض",
	"action.set_ik_source": "تعيين جذر IK",
	"action.set_ik_source.desc": "تحديد عظمة جذر السلسلة التي يجب أن يحركها هذا الكائن الفارغ عبر الحركة العكسية",
	"edit.loop_cut.cuts": "قطع",
	"panel.element.stretch": "تمدد",
	"preview_scene.minecraft_plains": "سهول",
	"preview_scene.minecraft_cherry_grove": "بستان كرز",
	"preview_scene.minecraft_snowy_tundra": "تندرا ثلجية",
	"preview_scene.minecraft_sunset": "غروب الشمس",
	"preview_scene.minecraft_night": "ليل",
	"preview_scene.minecraft_desert": "صحراء",
	"preview_scene.minecraft_underwater": "تحت الماء",
	"preview_scene.minecraft_coral_reef": "شعاب مرجانية",
	"preview_scene.minecraft_lush_cave": "كهف خصيب",
	"preview_scene.minecraft_deep_dark": "الظلام العميق",
	"generic.navigate_forward": "أمام",
	"generic.navigate_back": "خلف",
	"action.element_render_order": "ترتيب عرض الشفافية",
	"action.element_render_order.default": "تلقائي",
	"action.element_render_order.behind": "خلف",
	"action.element_render_order.in_front": "أمام",
	"message.installing_update.title": "تحديث متاح",
	"message.installing_update.message": "إصدار جديد جاهز للتثبيت. بعد إغلاق التطبيق، يرجى الانتظار لحوالي %0 ثانية قبل فتح Blockbench مرة أخرى أو إيقاف تشغيل الكمبيوتر، لتثبيت التحديث.",
	"settings.brush_cursor_2d": "مؤشر الفرشاة ثنائي الأبعاد",
	"settings.brush_cursor_2d.desc": "عرض مخطط حول الفرشاة في مساحة العمل ثنائية الأبعاد",
	"settings.brush_cursor_3d": "مؤشر الفرشاة ثلاثي الأبعاد",
	"settings.brush_cursor_3d.desc": "عرض مخطط حول الفرشاة في مساحة العمل ثلاثية الأبعاد",
	"settings.cdn_mirror": "استخدام مرآة CDN",
	"settings.cdn_mirror.desc": "استخدام مرآة CDN لتنزيل الإضافات. تتلقى المرآة التحديثات بشكل أسرع وتعمل في بعض المناطق حيث لا تعمل المرآة الافتراضية.",
	"data.layer": "طبقة",
	"data.panel": "لوحة",
	"generic.confirm_delete": "هل أنت متأكد من رغبتك في حذف هذا؟",
	"format_category.general": "عام",
	"modifier_actions.no_uniform_scaling": "قياس حر",
	"message.texture_refresh_conflict.title": "نسخ خامة متعارضة",
	"message.texture_refresh_conflict.message": "قد يحتوي ملف الخامة على تغييرات تتعارض مع نسخة Blockbench",
	"message.texture_refresh_conflict.keep_ours": "الاحتفاظ بنسخة Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "تحميل الملف وتجاهل جميع التغييرات والطبقات في Blockbench",
	"message.group_required_to_animate": "لا يمكنك تحريك هذا النوع من العناصر. أنشئ مجموعة أو هيكلاً عظمياً لتحريكه.",
	"dialog.texture.uv_size": "حجم UV",
	"dialog.advanced_screenshot.angle_preset": "إعداد زاوية مسبق",
	"dialog.advanced_screenshot.resolution": "الدقة",
	"dialog.advanced_screenshot.zoom_to_fit": "تكبير لملاءمة",
	"dialog.advanced_screenshot.zoom": "تكبير / البعد البؤري",
	"dialog.advanced_screenshot.anti_aliasing": "مكافحة التعرج",
	"dialog.advanced_screenshot.anti_aliasing.off": "إيقاف",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "أخذ عينات متعددة",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "أخذ عينات فائقة",
	"dialog.advanced_screenshot.show_gizmos": "عرض أدوات التحرير",
	"dialog.advanced_screenshot.shading": "تظليل",
	"settings.auto_keyframe": "إطار مفتاحي تلقائي",
	"settings.auto_keyframe.desc": "إنشاء إطار مفتاحي تلقائياً بقيم افتراضية في بداية الجدول الزمني عند تحويل العظمة في وقت لاحق",
	"settings.modded_entity_integer_size": "حجم صحيح للكيان المعدل",
	"settings.modded_entity_integer_size.desc": "تقييد أحجام المكعبات في تنسيق الكيان المعدل بالأعداد الصحيحة. بينما تدعم بعض الإصدارات تقنياً الأعداد العشرية، إلا أن الأعداد الصحيحة أسهل بكثير في تخطيط UV.",
	"category.layers": "طبقات",
	"keybind.paint_secondary_color": "الرسم باللون الثانوي",
	"action.selection_tool_operation_mode": "نمط عملية التحديد",
	"action.selection_tool_operation_mode.create": "تحديد جديد",
	"action.selection_tool_operation_mode.add": "إضافة إلى التحديد",
	"action.selection_tool_operation_mode.subtract": "طرح من التحديد",
	"action.selection_tool_operation_mode.intersect": "تقاطع",
	"action.pixel_perfect_drawing": "رسم دقيق للبكسل",
	"action.pixel_perfect_drawing.desc": "رسم خطوط فنية بكسل ناعمة بدون بكسلات مزدوجة عند المنحنيات",
	"action.selection_tool": "أداة التحديد",
	"action.selection_tool.desc": "تحديد أجزاء من الصورة",
	"action.selection_tool.rectangle": "مستطيل",
	"action.selection_tool.ellipse": "قطع ناقص",
	"action.selection_tool.lasso": "تحديد لاسو",
	"action.selection_tool.wand": "عصا سحرية",
	"action.selection_tool.color": "نفس اللون",
	"action.move_layer_tool": "تحريك الطبقة",
	"action.move_layer_tool.desc": "تحريك الطبقة الحالية أو التحديد",
	"action.export_modded_animations": "تصدير حركات الكيان المعدل",
	"action.export_modded_animations.desc": "تصدير حركات لنموذج كيان معدل لـ Minecraft Java Edition",
	"action.swap_colors": "تبديل الألوان",
	"action.swap_colors.desc": "تبديل اللون الرئيسي باللون الثانوي",
	"action.apply_mesh_rotation": "تطبيق الدوران",
	"action.apply_mesh_rotation.desc": "إعادة ضبط دوران عنصر الشبكة، وتطبيقه على الهندسة بدلاً من ذلك",
	"action.flip_texture_x.desc": "قلب الخامة أو الطبقة أفقياً",
	"action.flip_texture_y.desc": "قلب الخامة أو الطبقة عمودياً",
	"action.rotate_texture_cw.desc": "تدوير الخامة أو الطبقة في اتجاه عقارب الساعة",
	"action.rotate_texture_ccw.desc": "تدوير الخامة أو الطبقة عكس اتجاه عقارب الساعة",
	"action.crop_texture_to_selection": "قص الخامة حسب التحديد",
	"action.create_empty_layer": "إنشاء طبقة فارغة",
	"action.enable_texture_layers": "تمكين الطبقات",
	"action.disable_texture_layers": "تعطيل الطبقات",
	"action.layer_opacity": "شفافية الطبقة",
	"action.layer_to_texture_size": "توسيع الطبقة إلى حجم الخامة",
	"action.layer_to_texture_size.desc": "توسيع الطبقة إلى حجم الخامة",
	"action.merge_layer_down": "دمج لأسفل",
	"action.merge_layer_down.desc": "دمج في الطبقة أدناه",
	"action.advanced_screenshot": "لقطة شاشة متقدمة...",
	"action.advanced_screenshot.desc": "التقاط لقطة شاشة للنموذج بخيارات متقدمة",
	"action.bake_ik_animation": "خبز الحركة العكسية",
	"action.bake_ik_animation.desc": "خبز الدورانات المطبقة بواسطة الحركة العكسية في الحركة المحددة",
	"action.save_animation_preset": "حفظ إعداد حركة مسبق...",
	"action.save_animation_preset.desc": "حفظ الإطارات المفتاحية المحددة كإعداد حركة مسبق",
	"action.animation_onion_skin": "جلد البصل للحركة",
	"action.animation_onion_skin.desc": "عرض عرض هيكل سلكي لإطار مختلف في الحركة كمرجع",
	"action.apply_animation_preset": "تطبيق إعداد الحركة المسبق",
	"action.apply_animation_preset.desc": "تحديد من قائمة الإعدادات المسبقة للحركة وتطبيقه على العظمة المحددة",
	"menu.brush_presets.pixel_perfect": "فرشاة دقيقة للبكسل",
	"panel.layers": "طبقات",
	"uv_editor.copy_paste_tool.to_layer": "إلى طبقة جديدة",
	"format.image.new": "إنشاء صورة جديدة",
	"format.image.info.summary": "يتيح لك محرر الصور ثنائي الأبعاد إنشاء الصور والفنون البكسلية وتحريرها مباشرة في Blockbench، دون الحاجة إلى محرر صور خارجي. قم بتحرير الصور، أو تعديل الخامات، أو أنشئ فنك البكسلي الخاص!",
	"settings.move_with_selection_tool": "استخدام أداة التحديد لتحريك التحديدات",
	"settings.move_with_selection_tool.desc": "السماح لأداة التحديد بتحريك التحديدات مباشرة، دون الحاجة إلى التبديل إلى أداة تحريك الطبقة",
	"settings.final_newline": "سطر جديد نهائي",
	"settings.final_newline.desc": "إدراج حرف سطر جديد في نهاية الملفات المصدرة",
	"action.crop_layer_to_selection": "قص الطبقة حسب التحديد",
	"action.edit_mode_uv_overlay.desc": "عرض تراكب خريطة UV لجميع العناصر في نمط التحرير",
	"menu.image": "صورة",
	"menu.texture.discard_changes": "تجاهل التغييرات",
	"menu.texture.discard_changes.desc": "تجاهل جميع التغييرات غير المحفوظة وتحميل أحدث إصدار من الملف",
	"panel.textures.images": "صور",
	"dialog.advanced": "متقدم",
	"dialog.recommended_option": "موصى به",
	"modifier_actions.snap_to_center": "محاذاة إلى المركز",
	"modifier_actions.snap_to_pixels": "محاذاة إلى البكسلات",
	"message.invalid_format.install_plugin": "تثبيت الإضافة '%0'",
	"message.plugin_deprecated.message": "هل أنت متأكد من رغبتك في تثبيت هذه الإضافة القديمة؟",
	"message.plugin_deprecated.install_anyway": "تثبيت على أي حال",
	"message.image_editor.not_found": "تعذر العثور على محرر الصور المحدد. يرجى تحديد خيار آخر.",
	"message.knife_tool.confirm": "اضغط %0 أو انقر هنا لتطبيق أداة السكين",
	"message.knife_tool.skipped_face": "لا يمكن القطع بين وجوه مختلفة. قم بتضمين الحواف أو الرؤوس بينها!",
	"message.optimize_animation.keyframes_removed": "تمت إزالة %0 إطاراً مفتاحياً زائداً",
	"message.optimize_animation.nothing_to_optimize": "لم يتم العثور على شيء لتحسينه!",
	"message.duplicate_bone_copy_animation.title": "نسخ الحركة",
	"message.duplicate_bone_copy_animation.message": "العظمة المكررة متحركة في %0 حركات. هل تريد نسخ الإطارات المفتاحية إلى العظمة الجديدة؟",
	"message.auto_fix_mesh_edit.title": "إصلاح تلقائي",
	"message.auto_fix_mesh_edit.revert": "التراجع عن التحرير",
	"message.auto_fix_mesh_edit.overlapping_vertices": "تم نقل بعض الرؤوس إلى نفس النقطة. كيف تريد المتابعة؟",
	"message.auto_fix_mesh_edit.concave_quads": "أصبح وجه أو أكثر من الوجوه الرباعية مقعراً الآن، مما قد يسبب مشاكل في تخطيط UV والعرض. يمكن لـ Blockbench إصلاح ذلك تلقائياً لك:",
	"message.auto_fix_mesh_edit.merge_vertices": "دمج الرؤوس",
	"message.auto_fix_mesh_edit.split_quads": "تقسيم الرباعيات",
	"message.load_images.add_image": "إضافة صورة",
	"dialog.project.modded_entity_entity_class": "فئة الكيان",
	"dialog.resize_texture.offset": "الإزاحة",
	"dialog.animated_texture_editor.code_reference": "مرجع الكود",
	"dialog.animated_texture_editor.code_reference.about": "تم إنشاء هذا الكود لتنفيذ حركة الخامة كمرجع ولا يعمل بالضرورة دون تعديل. اطلع على التوثيق لمعرفة المزيد.",
	"dialog.animated_texture_editor.code_reference.docs": "توثيق",
	"dialog.animated_texture_editor.reframe": "إعادة تأطير",
	"dialog.animated_texture_editor.stride": "حجم الإطار",
	"dialog.animated_texture_editor.frames": "عدد الإطارات",
	"dialog.animated_texture_editor.add_frame": "إضافة إطار",
	"dialog.animated_texture_editor.resize_frames": "تغيير حجم الإطارات...",
	"dialog.animated_texture_editor.apply": "تطبيق",
	"dialog.add_primitive.edge_size": "حجم الحافة",
	"dialog.change_animation_speed.speed": "السرعة",
	"dialog.change_animation_speed.adjust_snapping": "ضبط المحاذاة",
	"dialog.optimize_animation.selection": "التحديد",
	"dialog.optimize_animation.selection.selected_keyframes": "الإطارات المفتاحية المحددة",
	"dialog.optimize_animation.selection.selected_animation": "الحركة المحددة",
	"dialog.optimize_animation.selection.all_animations": "جميع الحركات",
	"dialog.optimize_animation.thresholds": "قيم الحدود",
	"dialog.import_obj.obj": "ملف OBJ",
	"dialog.import_obj.mtl": "ملف MTL",
	"dialog.import_obj.scale": "قياس",
	"layout.thumbnail": "CSS صورة مصغرة مخصصة",
	"settings.pixel_grid": "شبكة البكسل",
	"settings.pixel_grid.desc": "عرض شبكة بكسل الخامة على العناصر في نمط التحرير",
	"settings.image_editor_grid_size": "حجم شبكة محرر الصور",
	"settings.image_editor_grid_size.desc": "حجم الشبكة الكبيرة في محرر الصور ثنائي الأبعاد",
	"settings.ground_plane_double_side": "المستوى الأرضي مزدوج الجوانب",
	"settings.ground_plane_double_side.desc": "جعل المستوى الأرضي مرئياً من الأسفل",
	"settings.optifine_save_default_texture": "OptiFine JEM: تصدير الخامة المحددة",
	"settings.optifine_save_default_texture.desc": "تصدير الخامة المحددة كخامة افتراضية للنموذج",
	"action.slider_color_select_threshold": "حد اختيار اللون",
	"action.slider_color_select_threshold.desc": "مدى قرب لون البكسل المجاور ليتم تحديده حسب اللون أو العصا السحرية",
	"action.stretch_tool": "تمدد",
	"action.stretch_tool.desc": "أداة لتحديد العناصر وتمديدها",
	"action.knife_tool": "أداة السكين",
	"action.knife_tool.desc": "أداة لقطع وجوه الشبكة إلى قطع أصغر",
	"action.duplicate_project": "تكرار المشروع",
	"action.duplicate_project.desc": "إنشاء نسخة من المشروع المفتوح",
	"action.transform_space.parent": "الأب",
	"action.transform_pivot_space": "مساحة تحويل نقطة الارتكاز",
	"action.solidify_mesh_selection": "تصلب الوجوه",
	"action.solidify_mesh_selection.desc": "تصلب الوجوه المحددة من الشبكة",
	"action.animated_texture_editor": "محرر الدفتر...",
	"action.animated_texture_editor.desc": "تحرير حركة الدفتر للخامة المحددة",
	"action.center_individual_pivots": "توسيط نقاط الارتكاز الفردية",
	"action.center_individual_pivots.desc": "تعيين نقطة ارتكاز كل عنصر محدد إلى مركزه",
	"action.uv_cycle": "تدوير UV",
	"action.uv_cycle.desc": "التنقل عبر ترتيب رؤوس UV دون تغيير مواضع UV",
	"action.uv_cycle_invert": "عكس تدوير UV",
	"action.uv_cycle_invert.desc": "عكس ترتيب رؤوس UV دون تغيير مواضع UV",
	"action.slider_animation_controller_speed": "سرعة تشغيل وحدة التحكم",
	"action.slider_animation_controller_speed.desc": "سرعة تشغيل وحدات تحكم الحركة بالنسبة المئوية",
	"action.optimize_animation": "تحسين الحركة",
	"action.optimize_animation.desc": "تحسين الحركة الحالية وتقليل عدد الإطارات المفتاحية",
	"action.change_animation_speed": "تغيير سرعة الحركة...",
	"action.change_animation_speed.desc": "تغيير سرعة الحركة المحددة",
	"timeline.select_particle_file": "تحديد ملف الجسيمات",
	"timeline.select_sound_file": "تحديد ملف الصوت",
	"menu.cube.texture.default": "افتراضي",
	"menu.texture.particle.clear": "التوقف عن استخدام للجسيمات",
	"menu.texture.use_as_default": "تعيين كافتراضي",
	"menu.texture.use_as_default.clear": "إلغاء التعيين كافتراضي",
	"menu.toolbar.overflow": "فائض شريط الأدوات",
	"edit.solidify_mesh_selection.thickness": "السماكة",
	"reference_image.sync_to_timeline": "مزامنة مع الجدول الزمني",
	"reference_image.toggle_playback": "تشغيل/إيقاف مؤقت",
	"dialog.add_primitive.shape.beveled_cuboid": "متوازي مستطيلات مشطوف",
	"dialog.ignore_all": "تجاهل الكل",
	"data.texture_group": "مجموعة خامات",
	"data.animation": "حركة",
	"generic.on": "تشغيل",
	"generic.off": "إيقاف",
	"format.free.info.3d_printing": "طباعة ثلاثية الأبعاد",
	"message.invalid_file.merge_conflict": "يحتوي الملف على تعارضات دمج Git غير محلولة.",
	"dialog.expand_texture_selection.radius": "المقدار",
	"dialog.expand_texture_selection.corner": "شكل الزاوية",
	"dialog.expand_texture_selection.corner.round": "مدور",
	"dialog.expand_texture_selection.corner.square": "مربع",
	"dialog.expand_texture_selection.corner.manhattan": "مانهاتن",
	"dialog.merge_animation.merge_target": "دمج في",
	"keybindings.variation_conflict": "يتعارض الاختلاف مع اختصار لوحة المفاتيح الرئيسي",
	"settings.recovery_save_interval": "فاصل حفظ نقطة الاسترداد",
	"settings.recovery_save_interval.desc": "يحفظ Blockbench المشروع المفتوح في الخلفية بشكل منتظم للاسترداد في حالة تعطل الكمبيوتر. قم بتعيين الفاصل الزمني بالثواني. اضبط على 0 لتعطيل الحفظ.",
	"settings.save_view_per_tab": "حفظ العرض لكل علامة تبويب",
	"settings.save_view_per_tab.desc": "حفظ زاوية العرض الحالية لكل علامة تبويب على حدة",
	"settings.inherit_parent_color": "وراثة لون الأب",
	"settings.inherit_parent_color.desc": "تعيين لون علامة العنصر الذي تم إنشاؤه حديثاً إلى لون الأب بدلاً من لون عشوائي",
	"keybind.preview_select.multi_select": "تحديد متعدد",
	"keybind.preview_select.group_select": "تحديد مجموعة",
	"keybind.preview_select.loop_select": "تحديد حلقي",
	"action.fill_mode.selection": "التحديد",
	"action.fill_mode.selected_elements": "العناصر المحددة",
	"action.image_tiled_view": "عرض مبلط",
	"action.image_tiled_view.description": "تمكين العرض المبلط في المحرر ثنائي الأبعاد",
	"action.image_onion_skin_view": "جلد البصل في محرر الصور",
	"action.image_onion_skin_view.description": "تمكين عرض جلد البصل في المحرر ثنائي الأبعاد",
	"action.expand_texture_selection": "توسيع تحديد الخامة",
	"action.expand_texture_selection.desc": "توسيع أو تقليص تحديد الخامة",
	"action.switch_tabs.reverse_order": "ترتيب عكسي",
	"action.save_project_incremental": "حفظ المشروع بزيادة",
	"action.save_project_incremental.desc": "حفظ النموذج الحالي كملف مشروع بزيادة (مثال: project_2.bbmodel)",
	"action.copy.multiple": "نسخ الكل",
	"action.copy.multiple.desc": "نسخ جميع البيانات المتاحة بشكل فردي",
	"action.paste.multiple": "لصق الكل",
	"action.randomize_marker_colors": "ألوان علامات عشوائية",
	"action.cube_light_emission": "انبعاث الضوء",
	"action.cube_light_emission.desc": "تغيير انبعاثية المكعبات المحددة، كقيمة بين 0 و 15",
	"action.view_mode.colored_solid": "صلب بألوان العلامات",
	"action.focus_on_selection.rotate_only": "تدوير فقط",
	"action.create_texture_group": "إنشاء مجموعة خامات",
	"action.create_texture_group.desc": "إنشاء مجموعة للخامات الخاصة بك",
	"action.uv_maximize.all_faces": "تأثير على جميع الوجوه",
	"action.retarget_animators": "إعادة توجيه الحركات",
	"action.retarget_animators.desc": "تحديد المحرك الذي يستهدف أي عظمة أو عنصر",
	"action.merge_animation": "دمج الحركة",
	"action.merge_animation.desc": "دمج الحركة في حركة أخرى",
	"action.add_keyframe.reset_values": ": مع القيم الافتراضية",
	"action.set_timeline_range_start": "تعيين بداية نطاق الجدول الزمني",
	"action.set_timeline_range_start.desc": "تعيين نقطة البداية لنطاق تشغيل مخصص في الجدول الزمني للحركة",
	"action.set_timeline_range_end": "تعيين نهاية نطاق الجدول الزمني",
	"action.set_timeline_range_end.desc": "تعيين نقطة النهاية لنطاق تشغيل مخصص في الجدول الزمني للحركة",
	"action.disable_timeline_range": "تعطيل نطاق الجدول الزمني",
	"action.disable_timeline_range.desc": "تعطيل نطاق التشغيل المخصص في الجدول الزمني للحركة",
	"menu.texture_group.resolve": "حل",
	"menu.image_tiled_view.mirrored": "حواف معكوسة",
	"menu.image_onion_skin_view.frame": "إطارات",
	"menu.image_onion_skin_view.frame.last_viewed": "آخر إطار تم عرضه",
	"menu.image_onion_skin_view.frame.previous": "الإطار السابق",
	"menu.image_onion_skin_view.frame.next": "الإطار التالي",
	"menu.image_onion_skin_view.frame.both": "السابق + التالي",
	"menu.image_onion_skin_view.display": "عرض",
	"menu.image_onion_skin_view.display.pixels": "بكسلات أصغر",
	"menu.image_onion_skin_view.display.transparent": "شفاف",
	"menu.image_onion_skin_view.above": "عرض أعلاه",
	"menu.animation.reload": "إعادة تحميل",
	"switches.autouv.alt": "نسبي",
	"display.rotation_pivot": "نقطة ارتكاز الدوران",
	"display.scale_pivot": "نقطة ارتكاز القياس",
	"display.reference.fox": "ثعلب",
	"display.reference.eating": "أكل",
	"preview_scene.sky": "سماء",
	"preview_scene.space": "فضاء",
	"preview_scene.minecraft_ocean": "محيط",
	"message.import_palette.selection_only": "التحديد فقط",
	"dialog.blend_transition_edit.ease_in_out": "دخول-خروج سهل (%0)",
	"dialog.blend_transition_edit.generate": "إنشاء...",
	"dialog.blend_transition_edit.generate.learn_more": "مزيد من المعلومات والمعاينة",
	"dialog.blend_transition_edit.generate.curve": "نوع التخفيف",
	"dialog.blend_transition_edit.generate.steps": "إطارات مفتاحية",
	"settings.fps_limit": "حد الإطارات في الثانية",
	"settings.fps_limit.desc": "تحديد عدد الإطارات في الثانية التي يعرضها Blockbench. يقتصر معدل الإطارات الفعلي على ما يمكن لجهازك عرضه.",
	"settings.outliner_reveal_on_select": "كشف العناصر عند التحديد",
	"settings.outliner_reveal_on_select.desc": "كشف العناصر في المخطط التفصيلي عند تحديدها",
	"settings.java_export_pivots": "تصدير نقاط الارتكاز في نماذج Java للكتل/العناصر",
	"settings.java_export_pivots.desc": "حفظ نقاط الارتكاز في نماذج Java للكتل أو العناصر على المكعبات بدون دوران",
	"animation_controllers.state.blend_transition_curve": "منحنى انتقال المزج",
	"menu.slider.reset_vector": "إعادة ضبط المتجه",
	"dialog.blend_transition_edit.extended": "رسم بياني موسع",
	"message.screenshot_too_large.title": "مشكلة في دقة لقطة الشاشة",
	"message.screenshot_too_large.message": "تعذر عرض لقطة الشاشة بنجاح. يرجى المحاولة مرة أخرى بدقة أقل أو بدون أخذ عينات فائقة.",
	"message.rename_elements.numbering": "يمكنك استخدام أحرف خاصة لإنشاء أرقام متسلسلة: % للحصول على فهرس العنصر داخل مجموعته، $ للحصول على الفهرس داخل التحديد.",
	"generic.edit_externally": "تحرير خارجياً",
	"message.settings_require_restart.title": "إعادة التشغيل مطلوبة",
	"message.settings_require_restart.message": "سيتم تطبيق بعض الإعدادات فقط بعد إعادة تشغيل البرنامج.",
	"message.settings_require_restart.restart_now": "إعادة التشغيل الآن",
	"message.settings_require_restart.restart_later": "إعادة التشغيل لاحقاً",
	"message.classroom_mode.install_plugin": "لا يمكن تثبيت الإضافات في نمط الفصل الدراسي",
	"dialog.collection.export_path": "مسار التصدير",
	"dialog.collection.select_all": "تحديد الكل",
	"dialog.collection.select_none": "إلغاء تحديد الكل",
	"dialog.collection.add_with_filter": "إضافة مع عامل تصفية",
	"dialog.collection.remove": "إزالة",
	"dialog.material_config.title": "تكوين المادة",
	"dialog.material_config.color_value": "قيمة اللون",
	"dialog.material_config.mer": "معدن-انبعاث-خشونة",
	"dialog.material_config.mer_value": "قيمة MER",
	"dialog.material_config.depth_type": "نوع العمق",
	"dialog.create_texture.disable_mirror_uv": "تعطيل مرآة UV",
	"dialog.create_texture.disable_mirror_uv.desc": "تعطيل خيار مرآة UV في النمذجة بالمرآة للحفاظ على UV منفصل لكل جانب من النموذج",
	"dialog.create_gif.turn.sync_to_anim_length": "مزامنة مع طول الحركة",
	"settings.category.controls": "ضوابط",
	"settings.classroom_mode": "نمط الفصل الدراسي",
	"settings.classroom_mode.desc": "تقييد الوظائف مثل تثبيت الإضافات وإزالة الروابط إلى وسائل التواصل الاجتماعي",
	"settings.antialiasing_bleed_fix": "إصلاح نزيف مكافحة التعرج",
	"settings.antialiasing_bleed_fix.desc": "إصلاح نزيف الخامة عند استخدام مكافحة التعرج. قد لا يكون مدعوماً على الأجهزة القديمة.",
	"settings.tone_mapping": "تخطيط النغمة",
	"settings.tone_mapping.desc": "طريقة تقريبية لعرض النطاق الديناميكي العالي على شاشة قياسية لعرض PBR.",
	"settings.audio_scrubbing": "صوت التنقل في الجدول الزمني",
	"settings.audio_scrubbing.desc": "تشغيل معاينات قصيرة للصوت أثناء التنقل في الجدول الزمني",
	"settings.viewport_rotate_speed": "سرعة دوران نافذة العرض",
	"settings.viewport_rotate_speed.desc": "حساسية الإدخال عند الدوران في نافذة العرض",
	"settings.viewport_zoom_speed": "سرعة تكبير نافذة العرض",
	"settings.viewport_zoom_speed.desc": "حساسية الإدخال عند التكبير في نافذة العرض",
	"settings.editor_2d_zoom_speed": "سرعة تكبير المحرر ثنائي الأبعاد",
	"settings.editor_2d_zoom_speed.desc": "حساسية الإدخال عند التكبير في محرر UV والرسم ثنائي الأبعاد",
	"category.select": "تحديد",
	"action.vertex_snap_mode.rotate": "تدوير",
	"action.export_image": "تصدير صورة",
	"action.export_image.desc": "تصدير الخامة كملف صورة",
	"action.apply_mirror_modeling": "تطبيق النمذجة بالمرآة",
	"action.apply_mirror_modeling.desc": "تطبيق النمذجة بالمرآة على التحديد. سيتم نسخ جميع العناصر المحددة وقلبها عبر المحور X.",
	"action.create_collection": "إنشاء مجموعة",
	"action.create_collection.desc": "إنشاء مجموعة من تحديد المخطط التفصيلي",
	"action.set_collection_content_to_selection": "تعيين محتوى المجموعة إلى المحدد",
	"action.set_collection_content_to_selection.desc": "تعيين المجموعات والعناصر المحددة كمحتوى المجموعة",
	"action.add_to_collection": "إضافة المحدد إلى المجموعة",
	"action.add_to_collection.desc": "إضافة المجموعات والعناصر المحددة إلى المجموعة",
	"action.view_mode.material": "معاينة المادة",
	"action.create_material": "إنشاء مادة",
	"action.create_material.desc": "إنشاء مادة PBR جديدة من الخامة المحددة",
	"action.generate_pbr_map": "إنشاء خريطة PBR...",
	"action.generate_pbr_map.desc": "إنشاء خريطة PBR (خريطة ارتفاع أو معدن، انبعاث، خشونة) من خامة موجودة",
	"menu.tools.main_tools": "صندوق الأدوات",
	"menu.view.panels": "لوحات",
	"menu.texture.pbr_channel": "قناة PBR",
	"menu.texture.pbr_channel.color": "لون",
	"menu.texture.pbr_channel.normal": "عادي",
	"menu.texture.pbr_channel.height": "ارتفاع",
	"menu.texture.pbr_channel.mer": "MER (معدن-انبعاث-خشونة)",
	"menu.texture.pbr_channel.mer_subsurface": "MER تحت السطح",
	"menu.collection.export_project": "تصدير المشروع",
	"menu.collection.export_as": "تصدير كـ \"%0\"",
	"menu.panel.enable": "تمكين",
	"menu.panel.move_to": "نقل إلى",
	"menu.panel.move_to.left_bar": "الشريط الجانبي الأيسر",
	"menu.panel.move_to.right_bar": "الشريط الجانبي الأيمن",
	"menu.panel.move_to.top": "أعلى",
	"menu.panel.move_to.bottom": "أسفل",
	"menu.panel.move_to.float": "عائم",
	"menu.panel.move_to.hidden": "إخفاء",
	"menu.panel.fold": "طي",
	"menu.mirror_painting.texture_center": "الأصل",
	"menu.mirror_modeling.mirror_uv": "مرآة UV",
	"menu.animation_onion_skin.frames": "إطارات",
	"menu.animation_onion_skin.select": "تحديد",
	"menu.animation_onion_skin.previous": "السابق",
	"menu.animation_onion_skin.next": "التالي",
	"menu.animation_onion_skin.previous_next": "السابق + التالي",
	"menu.animation_onion_skin.count": "العدد",
	"menu.animation_onion_skin.interval": "الفاصل",
	"menu.animation_onion_skin_selective": "جلد بصل انتقائي",
	"menu.animation_onion_skin_selective.desc": "عرض جلد البصل فقط للجزء المحدد من النموذج",
	"edit.loop_cut.unit": "الوحدة",
	"edit.loop_cut.unit.size_units": "وحدات الحجم",
	"edit.loop_cut.unit.percent": "نسبة مئوية",
	"edit.extrude_mesh_selection.direction": "الاتجاه",
	"edit.extrude_mesh_selection.direction.outwards": "للخارج",
	"edit.extrude_mesh_selection.direction.average": "متوسط",
	"edit.extrude_mesh_selection.even_extend": "تمديد متساوٍ",
	"edit.vertex_snap.align": "محاذاة",
	"edit.vertex_snap.align.longest": "أطول محور",
	"edit.vertex_snap.align.direction": "الاتجاه من نقطة الارتكاز",
	"edit.vertex_snap.align.align_axis": "محور %0",
	"edit.vertex_snap.ignore_axis": "تجاهل المحور",
	"codec.common.format": "التنسيق",
	"codec.image.quality": "الجودة",
	"panel.collections": "مجموعات",
	"modifier_actions.always": "مفعل دائماً",
	"modifier_actions.unless": "ما لم %0",
	"settings.undo_selections": "التراجع عن التحديد",
	"settings.undo_selections.desc": "تتبع تغييرات التحديد كخطوة في سجل التراجع",
	"action.focus_on_selection.zoom": "تكبير للملاءمة",
	"display.reference.tooting": "نفخ البوق",
	"settings.selection_tolerance": "تسامح التحديد",
	"settings.selection_tolerance.desc": "حجم المنطقة التي يمكن النقر عليها لتحديد حافة أو رأس",
	"action.delete.keep_vertices": "الاحتفاظ بالحواف/الرؤوس",
	"menu.mesh": "شبكة",
	"dialog.material_config.subsurface": "تشتت تحت السطح",
	"dialog.material_config.subsurface_enabled.desc": "استخدام قناة ألفا لخريطة MER لتشتت تحت السطح",
	"settings.pick_combined_color": "اختيار اللون المدمج",
	"settings.pick_combined_color.desc": "اختيار اللون المدمج لجميع الطبقات عند البكسل المعني، بدلاً من اللون على الطبقة النشطة",
	"action.split_rgb_into_layers": "تقسيم قنوات RGBA إلى طبقات",
	"action.split_rgb_into_layers.desc": "تقسيم الخامة إلى طبقات مضافة، واحدة لكل قناة RGBA",
	"dialog.project.java_block_version": "إصدار التنسيق",
	"data.spline_mesh": "شريحة",
	"data.billboard": "لوحة إعلانية",
	"data.armature": "هيكل عظمي",
	"data.armature_bone": "عظمة هيكل عظمي",
	"generic.reload": "إعادة تحميل",
	"modifier_actions.subtract": "طرح",
	"modifier_actions.reduced_intensity": "ضبط دقيق",
	"modifier_actions.select_bone": "تحديد عظمة",
	"modifier_actions.spline_select_multiple_points": "تحديد نقاط أو مقابض متعددة",
	"modifier_actions.move_panel_without_docking": "تحريك بدون إرساء",
	"message.save_all_textures.message": "هل تريد حفظ كل من الخامات التالية؟",
	"message.save_all_textures.skip": "تخطي",
	"dialog.add_spline.shape": "شكل",
	"dialog.add_spline.shape.segment": "قطعة",
	"dialog.add_spline.shape.square": "مستطيل",
	"dialog.add_spline.shape.circle": "دائرة",
	"dialog.add_spline.diameter": "القطر",
	"dialog.add_spline.sides_tubular": "قطاعات الأنبوب",
	"dialog.add_spline.sides_radial": "قطاعات الحلقة",
	"dialog.add_spline.radius": "نصف قطر الأنبوب",
	"dialog.add_spline.length": "الطول",
	"dialog.add_spline.width": "العرض",
	"dialog.plugins.revoke_permissions": "إلغاء الأذونات",
	"dialog.expression_editor.pretty_print": "طباعة منسقة",
	"dialog.expression_editor.minify": "ضغط",
	"dialog.expression_editor.find_replace": "بحث/استبدال",
	"dialog.create_gif.show_gizmos": "تسجيل الأدوات والشبكة",
	"dialog.preview_options.title": "خيارات المعاينة",
	"dialog.preview_options.background": "خلفية",
	"dialog.preview_options.background.checkerboard": "رقعة الشطرنج",
	"dialog.preview_options.background.solid": "صلب",
	"dialog.preview_options.background.custom_color": "لون مخصص",
	"dialog.preview_options.show_gizmos": "عرض الأدوات",
	"dialog.skin.texture_source": "مصدر الخامة",
	"dialog.skin.texture_source.template": "إنشاء قالب",
	"dialog.skin.texture_source.load_texture": "تحميل من ماين كرافت",
	"dialog.skin.texture_file": "ملف الخامة",
	"dialog.convert_skin.adjust_texture": "ضبط الخامة",
	"dialog.settings.clear_profile_value": "مسح قيمة الملف الشخصي",
	"layout.section.customize": "تخصيص",
	"layout.theme.configure": "تكوين",
	"layout.color.elevated": "مرتفع",
	"layout.color.elevated.desc": "عناصر واجهة مرتفعة، عادةً ما تكون مفصولة بظل مسقط",
	"layout.file.watch_changes": "مراقبة التغييرات وإعادة التحميل",
	"settings.autocomplete_code": "إكمال الكود تلقائياً",
	"settings.autocomplete_code.desc": "عرض اقتراحات الإكمال التلقائي في محررات الكود",
	"settings.detect_flipbook_textures": "كشف خامات الدفتر",
	"settings.detect_flipbook_textures.desc": "كشف خامات الدفتر المتحركة تلقائياً ومعاينتها كحركة",
	"settings.double_click_select_reference": "تحديد الصورة المرجعية عند النقر المزدوج",
	"settings.double_click_select_reference.desc": "انقر نقراً مزدوجاً على نافذة العرض لتحديد صورة مرجعية",
	"settings.default_keyframe_interpolation": "استيفاء الإطار المفتاحي الافتراضي",
	"settings.default_keyframe_interpolation.desc": "تحديد نمط استيفاء الإطار المفتاحي الافتراضي",
	"settings.color_picker_style": "نمط منتقي الألوان",
	"settings.color_picker_style.desc": "تحديد نمط منتقي الألوان في نمط الرسم",
	"settings.export_asset_paths": "تصدير مسارات الأصول",
	"settings.export_asset_paths.desc": "تحديد كيفية حفظ مسارات الأصول مثل الخامات أو الحركات في ملفات .bbmodel",
	"settings.export_asset_paths.relative": "مسارات نسبية",
	"settings.export_asset_paths.absolute": "مسارات كاملة",
	"settings.export_asset_paths.both": "مسارات نسبية وكاملة (الخامة فقط)",
	"settings.export_asset_paths.none": "عدم التصدير",
	"action.slider_spline_resolution": "دقة الشريحة %0",
	"action.slider_spline_resolution.desc": "تغيير دقة الشريحة على المحور %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "قطاعات الحلقة",
	"action.slider_spline_resolution.v.desc_precision": "قطاعات الأنبوب",
	"action.slider_spline_radius": "نصف قطر الشريحة",
	"action.slider_spline_radius.desc": "تغيير نصف قطر الشريحة",
	"action.slider_spline_handle_tilt": "إمالة المقبض",
	"action.slider_spline_handle_tilt.desc": "تغيير إمالة مقبض الشريحة",
	"action.slider_spline_handle_size": "حجم المقبض",
	"action.slider_spline_handle_size.desc": "تغيير حجم مقبض الشريحة",
	"action.blend_mode.lighten": "تفتيح",
	"action.blend_mode.darken": "تعتيم",
	"action.weight_brush": "فرشاة الوزن",
	"action.weight_brush.desc": "رسم أوزان الرؤوس على الشبكات لتشوهات الهيكل العظمي",
	"action.convert_minecraft_skin_variant": "تحويل شخصية عريضة/نحيفة",
	"action.convert_minecraft_skin_variant.desc": "التبديل بين نموذج الشخصية العريض (ستيف) والنموذج النحيف (أليكس). مع إمكانية ضبط الخامة تلقائياً لتناسب النموذج",
	"action.custom_skin_poses": "وضعيات شخصية مخصصة",
	"action.custom_skin_poses.desc": "تحميل إعداد وضعية شخصية مسبق مخصص",
	"action.custom_skin_poses.update": "تحديث الوضعية",
	"action.custom_skin_poses.update.desc": "استبدال الوضعية المحفوظة بالوضعية الحالية للنموذج",
	"action.add_custom_skin_pose": "إضافة وضعية شخصية مخصصة",
	"action.add_custom_skin_pose.desc": "حفظ الوضعية الحالية للنموذج كإعداد وضعية مسبق",
	"action.export_stl": "تصدير STL",
	"action.export_stl.desc": "تصدير نموذج STL للطباعة ثلاثية الأبعاد",
	"action.add_element": "إضافة عنصر",
	"action.add_element.desc": "إضافة عنصر جديد من قائمة أنواع العناصر",
	"action.add_spline": "إضافة شريحة",
	"action.add_spline.desc": "إضافة شريحة جديدة",
	"action.add_billboard": "إضافة لوحة إعلانية",
	"action.add_billboard.desc": "إضافة لوحة إعلانية جديدة، وهي عنصر مسطح يواجه الكاميرا دائماً",
	"action.add_armature": "إضافة هيكل عظمي",
	"action.add_armature.desc": "إضافة هيكل عظمي يسمح بتشويه الشبكة عبر الحركة",
	"action.add_armature_bone": "إضافة عظمة هيكل عظمي",
	"action.add_armature_bone.desc": "إضافة عظمة إلى الهيكل العظمي",
	"action.search_textures": "بحث في الخامات",
	"action.search_textures.desc": "البحث عن الخامات بالاسم",
	"action.search_animations": "بحث في الحركات",
	"action.search_animations.desc": "البحث عن الحركات بالاسم",
	"action.spline_selection_mode": "نمط تحديد الشريحة",
	"action.spline_selection_mode.object": "كائن",
	"action.spline_selection_mode.handles": "مقابض",
	"action.spline_render_mode": "الهندسة",
	"action.spline_render_mode.mesh": "شبكة",
	"action.spline_render_mode.path": "مسار",
	"action.spline_render_mode.desc": "الهندسة التي يجب أن تعرضها هذه الشريحة",
	"action.spline_uv_mode": "نمط UV",
	"action.spline_uv_mode.length_accurate": "دقيق الطول",
	"action.spline_uv_mode.uniform": "منتظم",
	"action.spline_uv_mode.per_segment": "لكل قطعة",
	"action.spline_uv_mode.desc": "كيفية وضع شبكة أنبوب الشريحة لـ UV الخاصة بها",
	"action.spline_ring_segments": "قطاعات الحلقة",
	"action.spline_ring_segments.desc": "عدد التقسيمات الفرعية لهذه الشريحة لكل حلقة أنبوب",
	"action.spline_tube_segments": "قطاعات الأنبوب",
	"action.spline_tube_segments.desc": "عدد التقسيمات الفرعية لهذه الشريحة على طول مسارها",
	"action.spline_tube_radius": "نصف قطر الأنبوب",
	"action.spline_tube_radius.desc": "تعيين نصف قطر أنبوب الشريحة",
	"action.spline_display_space": "مساحة العرض",
	"action.spline_display_space.desc": "عرض مؤشرات مساحة الشريحة على مسارها",
	"action.spline_handle_mode": "نمط مقبض الشريحة",
	"action.spline_handle_mode.desc": "النمط الذي يجب استخدامه لتحويل مقابض الشريحة",
	"action.spline_handle_mode.aligned": "محاذاة",
	"action.spline_handle_mode.free": "حر",
	"action.spline_handle_mode.mirrored": "معكوس",
	"action.slider_weight_brush_size": "حجم فرشاة الوزن",
	"action.weight_brush_xray": "نمط الأشعة السينية لفرشاة الوزن",
	"action.weight_brush_xray.desc": "عند التمكين، ستؤثر فرشاة الوزن على جميع الرؤوس بدلاً من تلك المرئية على السطح فقط",
	"action.apply_spline_rotation": "تطبيق الدوران",
	"action.apply_spline_rotation.desc": "إعادة ضبط دوران عنصر الشريحة، وتطبيقه على الهندسة بدلاً من ذلك",
	"action.extrude_spline_selection": "استخراج الشريحة",
	"action.extrude_spline_selection.desc": "استخراج المقبض المحدد على جميع الشرائح",
	"action.split_spline": "تقسيم الشريحة",
	"action.split_spline.desc": "تقسيم الشريحة إلى شريحتين عند المقبض المحدد",
	"action.divide_spline_curve": "تقسيم قطعة الشريحة",
	"action.divide_spline_curve.desc": "تقسيم قطعة الشريحة إلى قطعتين جديدتين بمقبض جديد عند تقاطعهما",
	"action.set_vertex_weights": "تعيين أوزان الرؤوس",
	"action.set_vertex_weights.desc": "تعيين أوزان الرؤوس المحددة إلى قيمة محددة على عظمة هيكل عظمي معينة",
	"action.calculate_vertex_weights": "حساب أوزان الرؤوس",
	"action.calculate_vertex_weights.desc": "تعيين أوزان الرؤوس تلقائياً بناءً على موضع العظام",
	"action.shelf_alignment": "محاذاة الرف",
	"action.shelf_alignment.desc": "تحديد المحاذاة الرأسية للعناصر على الرف",
	"action.shelf_alignment.top": "محاذاة علوية",
	"action.shelf_alignment.bottom": "محاذاة سفلية",
	"action.view_mode.vertex_weight": "وزن الرأس",
	"action.view_mode.weighted_bone_colors": "ألوان عظام مرجحة",
	"action.create_animation_group": "إنشاء مجموعة حركات",
	"action.create_animation_group.desc": "إنشاء مجموعة من الحركات",
	"action.move_graph_keyframes_up": "تحريك رسم الإطارات المفتاحية لأعلى",
	"action.move_graph_keyframes_down": "تحريك رسم الإطارات المفتاحية لأسفل",
	"menu.skin": "شخصية",
	"menu.text_edit.expression_editor": "محرر التعبيرات",
	"menu.color_picker.picker_type.normal": "خريطة عادية",
	"menu.texture.flipbook_animation": "حركة الدفتر",
	"menu.panel.attach_to": "إرفاق بـ",
	"menu.animation.playing": "تشغيل",
	"menu.animation_file.save_as": "حفظ باسم",
	"menu.animator.quaternion_interpolation": "استيفاء رباعي الأبعاد",
	"edit.extrude_spline_selection.extend": "تمديد",
	"edit.divide_spline_curve.position": "الموضع",
	"group.bedrock_binding": "الربط",
	"group.cem_attach": "ربط CEM",
	"group.cem_model": "نموذج CEM",
	"group.cem_scale": "مقياس CEM",
	"cube.rescale": "إعادة قياس الدوران",
	"cube.rescale.desc": "إعادة قياس المكعب لتعويض زاوية الدوران",
	"mesh.shading": "تظليل",
	"mesh.shading.flat": "مسطح",
	"mesh.shading.smooth": "ناعم",
	"spline_mesh.cyclic": "دوري",
	"spline_mesh.cyclic.desc": "ما إذا كانت الشريحة المحددة يجب أن تشكل حلقة (دورة)",
	"billboard.offset": "الإزاحة",
	"billboard.facing_mode": "نمط المواجهة",
	"billboard.facing_mode.lookat": "النظر إلى",
	"billboard.facing_mode.lookat_y": "النظر إلى Y",
	"billboard.facing_mode.rotate": "تدوير",
	"billboard.facing_mode.rotate_y": "تدوير Y",
	"armature_bone.connected": "متصل",
	"reference_image.blueprint": "مخطط مقفل",
	"codec.image.alpha_channel": "قناة ألفا",
	"codec.image.animation_fps": "إطارات الحركة في الثانية",
	"panel.palette": "لوحة",
	"panel.keyframe.change_effect_file": "تغيير ملف التأثير",
	"panel.transform": "تحويل",
	"panel.element.spline_dimensions": "أبعاد الشريحة",
	"display.slot.on_shelf": "رف",
	"display.reference.shelf": "رف (جميع الفتحات)",
	"display.reference.shelf_left": "رف (الفتحة اليسرى)",
	"display.reference.shelf_center": "رف (الفتحة الوسطى)",
	"display.reference.shelf_right": "رف (الفتحة اليمنى)",
	"message.newer_project_format_version.title": "العميل قديم",
	"message.newer_project_format_version.message": "تم حفظ هذا الملف في إصدار أحدث من Blockbench. قم بالتحديث إلى Blockbench %0 أو أحدث لتتمكن من فتحه بشكل صحيح",
	"message.load_images.add_layer": "إضافة كطبقة",
	"message.load_images.category.add_to_project": "إضافة إلى المشروع",
	"message.load_images.category.new_project": "مشروع جديد",
	"message.load_palette.title": "تحميل لوحة",
	"message.load_palette.message": "هل أنت متأكد من رغبتك في تحميل هذه اللوحة؟ سيؤدي هذا إلى استبدال لوحة الألوان الحالية.",
	"dialog.set_vertex_weights.weight": "الوزن",
	"dialog.set_vertex_weights.overwrite": "استبدال العظام الأخرى",
	"action.element_render_order.short": "ترتيب العرض",
	"action.element_render_order.desc": "ترتيب عرض العناصر. يمكن أن يساعد ذلك في إصلاح العناصر المخفية خلف عناصر أخرى ذات خامات شفافة. اتركه على تلقائي للعناصر غير الشفافة.",
	"spline.shading.flat": "مسطح",
	"spline.shading.smooth": "ناعم",
	"spline.shading": "تظليل",
	"spline.shading.desc": "كيفية تظليل أنبوب هذه الشريحة",
	"action.slider_weight_brush_limit": "حد فرشاة الوزن",
	"action.slider_weight_brush_limit.desc": "تعيين حد أعلى للوزن الذي يمكن لفرشاة الوزن تعيينه لرأس",
	"action.weight_brush_blend_mode": "نمط مزج فرشاة الوزن",
	"action.weight_brush_blend_mode.set": "تعيين",
	"action.weight_brush_blend_mode.add": "إضافة",
	"action.apply_texture_to_elements": "تطبيق الخامة على العناصر",
	"action.apply_texture_to_elements.desc": "تطبيق الخامة المحددة على العناصر المحددة",
	"menu.panel.reset_size": "إعادة ضبط الحجم",
	"action.import_layer": "استيراد طبقة",
	"action.import_layer.desc": "استيراد ملفات صور كطبقات",
	"menu.collection.open_file": "فتح الملف",
	"layout.version": "الإصدار",
	"settings.status_bar_transform_sliders": "أشرطة تمرير التحويل في شريط الحالة",
	"settings.status_bar_transform_sliders.desc": "عرض شريط أدوات أشرطة تمرير التحويل للأداة المحددة في شريط الحالة بدلاً من استخدام لوحة التحويل",
	"settings.default_bedrock_format": "تنسيق Bedrock الافتراضي",
	"settings.default_bedrock_format.desc": "تحديد التنسيق الافتراضي لتحميل نماذج Minecraft Bedrock فيها، عندما لا يمكن اكتشاف تنسيق محدد من السياق.",
	"settings.limit_brush_opacity_per_stroke": "تحديد شفافية الفرشاة لكل ضربة",
	"settings.limit_brush_opacity_per_stroke.desc": "تحديد الشفافية التي يمكن للفرشاة تطبيقها على قيمة شريط تمرير الشفافية أثناء كل ضربة فرشاة. مع فرشاة ناعمة، قد يؤدي هذا السلوك إلى ضوضاء غير مرغوب فيها طفيفة.",
	"action.merge_splines": "دمج الشرائح",
	"action.merge_splines.desc": "دمج شرائح متعددة في شريحة واحدة",
	"settings.default_java_block_version": "إصدار كتلة/عنصر Java الافتراضي",
	"settings.default_java_block_version.desc": "إصدار التنسيق الافتراضي عند إنشاء نماذج كتل/عناصر Java جديدة أو فتح ملفات بدون إصدار تنسيق",
	"data.bounding_box": "مربع إحاطة",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "سحب بالزر الأيسر أفقياً",
	"keys.slide_lmb_vertical": "سحب بالزر الأيسر عمودياً",
	"keys.slide_rmb_horizontal": "سحب بالزر الأيمن أفقياً",
	"keys.slide_rmb_vertical": "سحب بالزر الأيمن عمودياً",
	"message.recover_backup.unknown_project": "مشروع غير معروف",
	"message.recover_backup.discard_others": "تجاهل جميع الآخرين",
	"message.unsupported_file_extension.title": "تنسيق الملف غير مدعوم",
	"message.unsupported_file_extension.message": "لا يمكن فتح الملف %0، التنسيق غير مدعوم. قد تحتاج إلى إضافة لهذا النوع من الملفات.",
	"message.unsupported_file_extension.open_in_default_program": "فتح في البرنامج الافتراضي",
	"dialog.project.uv_size": "حجم UV",
	"dialog.collection.offset": "الإزاحة",
	"dialog.texture.fps": "إطار في الثانية",
	"dialog.texture.fps.desc": "إطارات في الثانية لحركة دفتر الخامة",
	"dialog.edit_uv_size.title": "تحرير حجم UV",
	"dialog.edit_uv_size.target": "الهدف",
	"dialog.edit_uv_size.adjust": "ضبط",
	"dialog.edit_uv_size.adjust.adjust_uv": "UV معاكس",
	"dialog.edit_uv_size.adjust.adjust_scale": "UV معاكس وقياس",
	"dialog.edit_uv_size.adjust.keep": "الاحتفاظ بـ UV",
	"dialog.edit_uv_size.target_size": "حجم UV الهدف",
	"dialog.edit_uv_size.preset.original": "الأصلي",
	"dialog.edit_uv_size.preset.match_texture": "مطابقة الخامة",
	"dialog.edit_uv_size.result": "النتيجة",
	"dialog.edit_uv_size.result.textures": "خامات",
	"dialog.adjust_brightness_contrast.brightness": "السطوع",
	"dialog.adjust_brightness_contrast.contrast": "التباين",
	"dialog.adjust_saturation_hue.saturation": "التشبع",
	"dialog.adjust_saturation_hue.hue": "درجة اللون",
	"dialog.adjust_opacity.mode": "النمط",
	"dialog.adjust_opacity.mode.multiply": "ضرب",
	"dialog.adjust_opacity.mode.set": "تعيين",
	"dialog.bedrock_bounding_box.type": "النوع",
	"dialog.bedrock_bounding_box.type.collision_box": "تصادم",
	"dialog.bedrock_bounding_box.type.selection_box": "مربع التحديد",
	"dialog.bedrock_bounding_box.type.hitbox": "مربع الإصابة",
	"dialog.bedrock_bounding_box.hitbox_note": "يرجى ملاحظة أن مربعات إصابة الكائنات تعمل فقط حتى حجم معين وقد لا تتكيف مع دوران الكائن في اللعبة.",
	"dialog.bedrock_bounding_box.collision_note": "يرجى ملاحظة أن مربعات تصادم الكائنات تدعم فقط شكلاً واحداً متمركزاً بمخطط علوي مربع.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "لا توجد مربعات إحاطة في هذا المشروع",
	"dialog.install_plugins_from_list.ids": "معرفات الإضافات",
	"dialog.install_plugins_from_list.info": "تثبيت عدة إضافات من قائمة المعرفات. قبل التثبيت، يرجى التأكد من أنك تحتاج بالفعل إلى جميع الإضافات. يمكن أن يؤدي الاحتفاظ بإضافات غير نشطة إلى زيادة مخاطر الأخطاء وعدم التوافق مع التحديثات المستقبلية.",
	"dialog.copy_installed_plugins.details": "تضمين التفاصيل",
	"dialog.flip_animation.phase_offset": "إزاحة الطور",
	"dialog.flip_animation.phase_offset.off": "إيقاف",
	"dialog.flip_animation.phase_offset.custom": "مخصص",
	"dialog.flip_animation.clear_opposite": "استبدال المقابل",
	"settings.flipbook_textures_in_animation": "تشغيل خامات الدفتر في الحركة",
	"settings.flipbook_textures_in_animation.desc": "معاينة الحركات على خامات الدفتر بالتزامن مع الجدول الزمني للحركة",
	"settings.display_uv": "عرض أوجه UV",
	"settings.display_uv.desc": "تحديد أوجه UV التي يتم عرضها في محرر UV",
	"settings.display_uv.selected_faces": "الوجوه المحددة فقط",
	"settings.display_uv.selected_elements": "جميع الوجوه على العناصر المحددة",
	"settings.display_uv.all_elements": "جميع الوجوه على جميع العناصر",
	"settings.local_position_values": "قيم الموضع المحلية",
	"settings.local_position_values.desc": "عرض جميع قيم الموضع في لوحة التحويل في الفضاء المحلي",
	"settings.transform_cube_from_center": "تحويل المكعبات من المركز",
	"settings.transform_cube_from_center.desc": "تحرير قيم موضع المكعب من المركز بدلاً من الزاوية",
	"settings.color_picker_tool_switch": "تبديل أداة منتقي الألوان",
	"settings.color_picker_tool_switch.desc": "عند اختيار بكسل شفاف، التبديل إلى الممحاة. عندما كانت الممحاة محددة مسبقاً وتم اختيار لون، التبديل إلى الفرشاة",
	"keybind.preview_scroll_zoom": "تكبير العرض",
	"keybind.uv_editor_scroll_zoom": "تكبير محرر UV/ثنائي الأبعاد",
	"action.blend_mode.alpha_mask": "قناع ألفا",
	"action.swap_tools.hold": "اضغط مع الاستمرار للتبديل (قطاف الألوان)",
	"action.import_bedrock_voxel_shape": "استيراد شكل فوكسل Bedrock",
	"action.import_bedrock_voxel_shape.desc": "إضافة شكل فوكسل من ملف json إلى المشروع الحالي",
	"action.export_bedrock_voxel_shape": "تصدير شكل فوكسل Bedrock",
	"action.export_bedrock_voxel_shape.desc": "تصدير مربعات الإحاطة في المشروع كملف شكل فوكسل Bedrock",
	"action.plugins_window_menu": "القائمة",
	"action.copy_installed_plugins": "نسخ الإضافات المثبتة",
	"action.copy_installed_plugins.desc": "إنشاء ونسخ قائمة بالإضافات المثبتة حالياً",
	"action.install_plugins_from_list": "تثبيت إضافات من قائمة",
	"action.install_plugins_from_list.desc": "تثبيت إضافات من قائمة معرفات الإضافات",
	"action.add_bounding_box": "إضافة مربع إحاطة",
	"action.add_bounding_box.desc": "إضافة مربع إحاطة جديد",
	"action.split_alpha_into_layer": "تقسيم قناة ألفا إلى طبقة",
	"action.split_alpha_into_layer.desc": "تقسيم قناة ألفا للخامة إلى طبقة قناع ألفا",
	"action.generate_bedrock_block_box": "نسخ مكون التصادم/التحديد",
	"action.generate_bedrock_block_box.desc": "إنشاء مكون تصادم أو مربع تحديد لكتل Minecraft Bedrock Edition",
	"action.generate_bedrock_entity_box": "نسخ مكون التصادم/مربع الإصابة",
	"action.generate_bedrock_entity_box.desc": "إنشاء مكون تصادم أو اختبار إصابة مخصص لكائنات Minecraft Bedrock Edition",
	"action.refresh_texture": "تحديث الخامة",
	"action.refresh_texture.desc": "إعادة تحميل الخامة من الملف",
	"action.move_uv_to_cursor": "تحريك UV إلى المؤشر",
	"action.move_uv_to_cursor.desc": "تحريك أوجه UV المحددة إلى موضع مؤشر الماوس",
	"action.edit_mode_uv_overlay": "عرض جميع العناصر",
	"action.round_keyframe_values": "تقريب قيم الإطارات المفتاحية",
	"action.round_keyframe_values.desc": "تقريب جميع قيم الإطارات المفتاحية المحددة",
	"action.keyframe_column_create.all_channels": "جميع القنوات",
	"action.keyframe_column_create.all_channels.desc": "تهيئة جميع القنوات بإطارات مفتاحية حتى لو لم يكن لديها إطارات مفتاحية سابقاً",
	"action.add_all_to_timeline": "إضافة الكل إلى الجدول الزمني",
	"action.mirror_animating": "عكس التحريك",
	"action.mirror_animating.desc": "عكس تعديلات الحركة إلى الجانب المقابل",
	"action.copy_animation_pose": "نسخ وضعية الحركة",
	"action.copy_animation_pose.desc": "نسخ جميع الإطارات المفتاحية لتكرار وضعية الحركة الحالية",
	"menu.texture.file_format": "تنسيق الملف",
	"menu.texture.wrap_mode": "نمط الالتفاف",
	"menu.texture.wrap_mode.limited": "مقيد",
	"menu.texture.wrap_mode.repeat": "تكرار",
	"menu.texture.wrap_mode.clamp": "تثبيت الحافة",
	"edit.reparent_selection.adjust_position": "الحفاظ على تحويل العالم",
	"texture_mesh.texture_name": "اسم الخامة",
	"display.slot.embedded": "مضمن",
	"display.animate_preview": "معاينة الحركة",
	"display.reference.flower_pot": "وعاء الزهور",
	"data.generated_item_mesh": "نموذج عنصر مولّد",
	"message.generated_item_model.title": "نموذج عنصر مولّد",
	"message.generated_item_model.message": "هذا النموذج ليس له عناصر خاصة به. تقوم ماين كرافت ببناء شكل العنصر من خامة النموذج، لذا فإن ما تراه هنا هو مجرد معاينة لذلك الشكل. لا يمكن تحريره، ولا يتم تصديره.\n\nلتغيير مظهر العنصر في اللعبة، قم بتحرير الخامة.",
	"message.generated_item_model.edit_texture": "تحرير الخامة",
	"message.generated_item_model.convert": "تحويل إلى نموذج قابل للتحرير",
	"message.convert_generated_item_model.title": "تحويل إلى نموذج قابل للتحرير",
	"message.convert_generated_item_model.message": "سيؤدي هذا إلى بناء عناصر حقيقية عن طريق استخراج الخامة، حتى تتمكن من تغيير شكل العنصر في ثلاثي الأبعاد.\n\nإذا كنت تريد فقط تغيير مظهر العنصر، فلست بحاجة إلى هذا. بدلاً من ذلك، قم بتحرير الخامة، وستستمر ماين كرافت في إنشاء الشكل منها.",
	"message.convert_generated_item_model.confirm": "استخراج الخامة",
	"message.generated_item_model_conflict.title": "نموذج عنصر مولّد",
	"message.generated_item_model_conflict.message": "لا يمكن لماين كرافت استخدام كل من نموذج العنصر المولّد والعناصر. الآن بعد أن أصبح لهذا النموذج عناصر، يتم تجاهل الشكل المولّد في اللعبة.",
	"message.generated_item_model_conflict.convert": "تحويل النموذج المولّد إلى مكعبات",
	"message.generated_item_model_conflict.convert.desc": "استخراج الخامة إلى عناصر حقيقية، بحيث لا يتم فقدان أي شيء",
	"message.generated_item_model_conflict.remove": "إزالة النموذج المولّد",
	"message.generated_item_model_conflict.remove.desc": "حذف المعاينة ونمذجة العنصر من الصفر",
	"message.generated_item_model_conflict.keep": "الاحتفاظ به كمرجع",
	"message.generated_item_model_conflict.keep.desc": "عرضه في Blockbench فقط، ولا يتم تصديره أبداً",
	"message.add_reference_image.globally": "إضافة لجميع المشاريع",
	"dialog.extrude.orientation.upright_z": "عمودي Z",
	"dialog.extrude.depth": "العمق",
	"dialog.add_primitive.shape.icosphere": "كرة سداسية",
	"dialog.add_primitive.shape.octahedron": "ثماني السطوح",
	"dialog.add_primitive.shape.dodecahedron": "اثنا عشري السطوح",
	"dialog.add_primitive.detail": "التفاصيل",
	"dialog.plugins.update": "تحديث",
	"dialog.plugins.update_available": "تحديث متاح",
	"dialog.create_variable_placeholder.variable": "المتغير",
	"dialog.create_variable_placeholder.type": "النوع",
	"dialog.create_variable_placeholder.type.value": "قيمة",
	"dialog.create_variable_placeholder.type.slider": "شريط تمرير",
	"dialog.create_variable_placeholder.type.toggle": "مفتاح تبديل",
	"dialog.create_variable_placeholder.type.impulse": "نبضة",
	"dialog.create_variable_placeholder.value": "القيمة",
	"dialog.create_variable_placeholder.duration": "المدة",
	"dialog.create_variable_placeholder.step": "الخطوة",
	"dialog.create_variable_placeholder.range": "النطاق",
	"dialog.create_variable_placeholder.output": "المخرجات",
	"dialog.view_built_in_variables.function": "المعلمات المطلوبة",
	"dialog.advanced_screenshot.export": "تصدير",
	"dialog.preview_options.show_element_markers": "عرض علامات العناصر",
	"dialog.preview_options.show_element_markers.desc": "عرض علامات للإشارة إلى موضع العناصر مثل العظام والكائنات الفارغة والنقاط المرجعية",
	"settings.maximum_zoom_distance": "أقصى مسافة تكبير",
	"settings.maximum_zoom_distance.desc": "المدى الذي يمكن للكاميرا أن تبتعد فيه عن النموذج",
	"settings.constant_outlines": "حدود ثابتة",
	"settings.constant_outlines.desc": "عرض حدود العناصر دائماً بغض النظر عن التحديد",
	"settings.new_project_dialog": "مربع حوار المشروع الجديد",
	"settings.new_project_dialog.desc": "عرض مربع حوار المشروع عند إنشاء مشروع جديد",
	"settings.opacity_range": "نطاق الشفافية",
	"settings.opacity_range.desc": "تحديد النطاق المستخدم للتحكم في شفافية الطبقات والفرش",
	"settings.automatic_plugin_updates": "تحديثات الإضافات التلقائية",
	"settings.automatic_plugin_updates.desc": "تحديث الإضافات تلقائياً للحفاظ عليها محدثة",
	"settings.native_window_frame": "إطار نافذة أصلي",
	"settings.native_window_frame.desc": "استخدام إطار نافذة أصلي بنمط نظام التشغيل",
	"keybind.preview_scroll_pan": "تحريك العرض بالتمرير",
	"keybind.preview_scroll_pan.desc": "استخدام التمرير لتحريك العرض، يمكن استخدامه للتحريك بإصبعين مع لوحات اللمس",
	"action.position_slider_per_element": "تحريك المواضع الفردية",
	"action.position_slider_per_element.desc": "عند التمكين، يؤدي استخدام أشرطة تمرير الموضع إلى تغيير المواضع الفردية لكل عنصر. عند التعطيل، يتحرك التحديد بأكمله في مساحة التحويل المحددة.",
	"action.origin_slider_direct_values": "تحريك قيم نقطة الارتكاز مباشرة",
	"action.origin_slider_direct_values.desc": "عند التمكين، تحرك أشرطة تمرير نقطة الارتكاز نقطة الارتكاز مباشرة، مما يؤثر على موضع الكائن. عند التعطيل، يتم ضبط المواضع تلقائياً.",
	"action.brush_lock_mode": "نمط قفل الفرشاة",
	"action.brush_lock_mode.none": "غير مقفل",
	"action.brush_lock_mode.element": "قفل على العنصر",
	"action.brush_lock_mode.face": "قفل على الوجه",
	"action.slider_brush_aspect_ratio": "نسبة أبعاد الفرشاة",
	"action.slider_brush_aspect_ratio.desc": "نسبة أبعاد الفرشاة",
	"action.screen_space_brush_projection": "إسقاط فرشاة في مساحة الشاشة",
	"action.screen_space_brush_projection.desc": "استخدام إسقاط مساحة الشاشة للرسم بفرشاة",
	"action.close_other_projects": "إغلاق علامات التبويب الأخرى",
	"action.close_other_projects.desc": "إغلاق جميع المشاريع باستثناء المشروع المفتوح",
	"action.close_projects_to_right": "إغلاق علامات التبويب إلى اليمين",
	"action.close_projects_to_right.desc": "إغلاق جميع علامات تبويب المشاريع إلى يمين المشروع المفتوح",
	"action.extrude_texture_to_model": "استخراج الخامة",
	"action.extrude_texture_to_model.desc": "إنشاء نموذج عن طريق استخراج هذه الخامة",
	"action.experimental_settings": "إعدادات تجريبية",
	"action.experimental_settings.desc": "تخصيص إعدادات المطور التجريبية",
	"action.convert_texture_mesh_to_cubes": "تحويل إلى نموذج مستخرج",
	"action.convert_texture_mesh_to_cubes.desc": "استبدال شبكة الخامة بمكعبات مستخرجة من خامتها، في نفس المكان",
	"action.flip_in_place": "قلب في المكان %0",
	"action.flip_in_place.desc": "قلب العناصر المحددة على المحور %0 في موضعها الحالي",
	"action.create_layer_group": "إنشاء مجموعة طبقات",
	"action.resolve_layer_group": "حل مجموعة الطبقات",
	"action.preview_models": "نماذج المعاينة",
	"action.preview_models.desc": "تحديد وتحويل النماذج المرجعية",
	"action.keyframe_select_before_playhead": "تحديد الإطارات المفتاحية قبل رأس التشغيل",
	"action.keyframe_select_before_playhead.desc": "تحديد جميع الإطارات المفتاحية في الجدول الزمني عند أو قبل رأس التشغيل",
	"action.keyframe_select_after_playhead": "تحديد الإطارات المفتاحية بعد رأس التشغيل",
	"action.keyframe_select_after_playhead.desc": "تحديد جميع الإطارات المفتاحية في الجدول الزمني عند أو بعد رأس التشغيل",
	"action.set_ik_pole": "تعيين قطب IK",
	"action.set_ik_pole.desc": "تحديد القطب الذي ستحاول السلسلة مواجهته أثناء الحركة",
	"action.create_variable_placeholder": "إنشاء متغير مؤقت",
	"action.create_variable_placeholder.desc": "إضافة متغير إلى قائمة المتغيرات المؤقتة لمعاينة قيمة",
	"action.view_built_in_variables": "عرض المتغيرات المضمنة",
	"action.view_built_in_variables.desc": "عرض قائمة المتغيرات وقيمها التي يوفرها Blockbench تلقائياً لمعاينة الحركة",
	"menu.paint": "رسم",
	"menu.brush_presets.screen_space": "فرشاة مساحة الشاشة",
	"edit.loop_cut.spacing": "التباعد",
	"edit.loop_cut.spacing.proportional": "نسبي",
	"edit.loop_cut.spacing.even_start": "متساوٍ - من البداية",
	"edit.loop_cut.spacing.even_end": "متساوٍ - من النهاية",
	"cube.shade_direction_override": "تجاوز اتجاه التظليل",
	"cube.shade_direction_override.desc": "يحدد اتجاه مصدر الضوء لإضفاء تأثير تظليل على الوجوه. إذا لم يتم تحديده، لن يتم تطبيق أي تظليل. لا يؤثر هذا على الإغلاق المحيطي أو التظليل بناءً على مستوى الضوء.",
	"null_object.ik_target": "هدف IK",
	"null_object.ik_source": "مصدر IK",
	"null_object.ik_pole": "قطب IK",
	"reference_image.layer.scene": "مشهد ثلاثي الأبعاد",
	"reference_image.view_mode": "نمط العرض",
	"reference_image.view_mode.flat_image": "صورة مسطحة",
	"reference_image.view_mode.billboard": "لوحة إعلانية ثلاثية الأبعاد",
	"reference_image.cull_backface": "إخفاء الجانب الخلفي",
	"codec.common.merge_armature_mesh": "دمج شبكة الهيكل العظمي",
	"preview_model.transform": "تحويل",
	"preview_model.reset_transform": "إعادة ضبط التحويل",
	"preview_model.minecraft_player": "لاعب ماين كرافت",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor"
}